import { B as Dc } from "./base-CMhGIFuX.mjs.js";
import { c as Hc, j as Gu, a as Fc, b as Sc } from "./client-BkmPNNjT.mjs.js";
import { X as Wc } from "./x-BeA-aqru.mjs.js";
class Uc extends Dc {
  async connectedCallback() {
    super.connectedCallback();
    const Tl = this.getJson("options"), R = this.querySelectorAll("[data-slide]"), $l = Number(this.dataset.autoplay), {
      ManagedCarousel: je
    } = await import("./managedCarousel-Bu1k7zH3.mjs.js");
    Hc.createRoot(this).render(/* @__PURE__ */ Gu.jsx(je, {
      options: Tl,
      autoplay: $l,
      css: {
        root: this.dataset.cssRoot,
        content: this.dataset.cssContent,
        item: this.dataset.cssSlide,
        prevBtn: this.dataset.cssPrevBtn,
        nextBtn: this.dataset.cssNextBtn
      },
      children: R
    }));
  }
}
customElements.get("hz-carousel") || customElements.define("hz-carousel", Uc);
var Ut = {}, ta = {};
var wc;
function Gc() {
  if (wc) return ta;
  wc = 1;
  var Wn = Fc(), Tl = Sc();
  function R(l) {
    var t = "https://react.dev/errors/" + l;
    if (1 < arguments.length) {
      t += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var i = 2; i < arguments.length; i++)
        t += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + l + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var $l = Symbol.for("react.transitional.element"), je = Symbol.for("react.portal"), Yt = Symbol.for("react.fragment"), Hr = Symbol.for("react.strict_mode"), Wr = Symbol.for("react.profiler"), Ur = Symbol.for("react.consumer"), ne = Symbol.for("react.context"), $e = Symbol.for("react.forward_ref"), le = Symbol.for("react.suspense"), nt = Symbol.for("react.suspense_list"), lt = Symbol.for("react.memo"), ee = Symbol.for("react.lazy"), pa = Symbol.for("react.scope"), Gr = Symbol.for("react.activity"), ja = Symbol.for("react.legacy_hidden"), $a = Symbol.for("react.memo_cache_sentinel"), nu = Symbol.for("react.view_transition"), Yr = Symbol.iterator;
  function Xr(l) {
    return l === null || typeof l != "object" ? null : (l = Yr && l[Yr] || l["@@iterator"], typeof l == "function" ? l : null);
  }
  var te = Array.isArray;
  function Zr(l, t) {
    var i = l.length & 3, u = l.length - i, f = t;
    for (t = 0; t < u; ) {
      var o = l.charCodeAt(t) & 255 | (l.charCodeAt(++t) & 255) << 8 | (l.charCodeAt(++t) & 255) << 16 | (l.charCodeAt(++t) & 255) << 24;
      ++t, o = 3432918353 * (o & 65535) + ((3432918353 * (o >>> 16) & 65535) << 16) & 4294967295, o = o << 15 | o >>> 17, o = 461845907 * (o & 65535) + ((461845907 * (o >>> 16) & 65535) << 16) & 4294967295, f ^= o, f = f << 13 | f >>> 19, f = 5 * (f & 65535) + ((5 * (f >>> 16) & 65535) << 16) & 4294967295, f = (f & 65535) + 27492 + (((f >>> 16) + 58964 & 65535) << 16);
    }
    switch (o = 0, i) {
      case 3:
        o ^= (l.charCodeAt(t + 2) & 255) << 16;
      case 2:
        o ^= (l.charCodeAt(t + 1) & 255) << 8;
      case 1:
        o ^= l.charCodeAt(t) & 255, o = 3432918353 * (o & 65535) + ((3432918353 * (o >>> 16) & 65535) << 16) & 4294967295, o = o << 15 | o >>> 17, f ^= 461845907 * (o & 65535) + ((461845907 * (o >>> 16) & 65535) << 16) & 4294967295;
    }
    return f ^= l.length, f ^= f >>> 16, f = 2246822507 * (f & 65535) + ((2246822507 * (f >>> 16) & 65535) << 16) & 4294967295, f ^= f >>> 13, f = 3266489909 * (f & 65535) + ((3266489909 * (f >>> 16) & 65535) << 16) & 4294967295, (f ^ f >>> 16) >>> 0;
  }
  var Bn = Object.assign, nn = Object.prototype.hasOwnProperty, Jr = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), ra = {}, ia = {};
  function Xt(l) {
    return nn.call(ia, l) ? !0 : nn.call(ra, l) ? !1 : Jr.test(l) ? ia[l] = !0 : (ra[l] = !0, !1);
  }
  var Zn = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  ), Jn = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), F = /["'&<>]/;
  function k(l) {
    if (typeof l == "boolean" || typeof l == "number" || typeof l == "bigint")
      return "" + l;
    l = "" + l;
    var t = F.exec(l);
    if (t) {
      var i = "", u, f = 0;
      for (u = t.index; u < l.length; u++) {
        switch (l.charCodeAt(u)) {
          case 34:
            t = "&quot;";
            break;
          case 38:
            t = "&amp;";
            break;
          case 39:
            t = "&#x27;";
            break;
          case 60:
            t = "&lt;";
            break;
          case 62:
            t = "&gt;";
            break;
          default:
            continue;
        }
        f !== u && (i += l.slice(f, u)), f = u + 1, i += t;
      }
      l = f !== u ? i + l.slice(f, u) : i;
    }
    return l;
  }
  var Qr = /([A-Z])/g, aa = /^ms-/, I = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function C(l) {
    return I.test("" + l) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : l;
  }
  var Ae = Wn.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Vr = Tl.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Un = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, Q = Vr.d;
  Vr.d = {
    f: Q.f,
    r: Q.r,
    D: at,
    C: mn,
    L: ru,
    m: ri,
    X: Ea,
    S: Ta,
    M: iu
  };
  var nl = [], re = null, Kr = /(<\/|<)(s)(cript)/gi;
  function Zt(l, t, i, u) {
    return "" + t + (i === "s" ? "\\u0073" : "\\u0053") + u;
  }
  function lu(l, t, i, u, f) {
    return {
      idPrefix: l === void 0 ? "" : l,
      nextFormID: 0,
      streamingFormat: 0,
      bootstrapScriptContent: i,
      bootstrapScripts: u,
      bootstrapModules: f,
      instructions: 0,
      hasBody: !1,
      hasHtml: !1,
      unknownResources: {},
      dnsResources: {},
      connectResources: { default: {}, anonymous: {}, credentials: {} },
      imageResources: {},
      styleResources: {},
      scriptResources: {},
      moduleUnknownResources: {},
      moduleScriptResources: {}
    };
  }
  function xn(l, t, i, u) {
    return {
      insertionMode: l,
      selectedValue: t,
      tagScope: i,
      viewTransition: u
    };
  }
  function ua(l, t, i) {
    var u = l.tagScope & -25;
    switch (t) {
      case "noscript":
        return xn(2, null, u | 1, null);
      case "select":
        return xn(
          2,
          i.value != null ? i.value : i.defaultValue,
          u,
          null
        );
      case "svg":
        return xn(4, null, u, null);
      case "picture":
        return xn(2, null, u | 2, null);
      case "math":
        return xn(5, null, u, null);
      case "foreignObject":
        return xn(2, null, u, null);
      case "table":
        return xn(6, null, u, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return xn(7, null, u, null);
      case "colgroup":
        return xn(9, null, u, null);
      case "tr":
        return xn(8, null, u, null);
      case "head":
        if (2 > l.insertionMode)
          return xn(3, null, u, null);
        break;
      case "html":
        if (l.insertionMode === 0)
          return xn(1, null, u, null);
    }
    return 6 <= l.insertionMode || 2 > l.insertionMode ? xn(2, null, u, null) : l.tagScope !== u ? xn(
      l.insertionMode,
      l.selectedValue,
      u,
      null
    ) : l;
  }
  function N(l) {
    return l === null ? null : {
      update: l.update,
      enter: "none",
      exit: "none",
      share: l.update,
      name: l.autoName,
      autoName: l.autoName,
      nameIdx: 0
    };
  }
  function mr(l, t) {
    return t.tagScope & 32 && (l.instructions |= 128), xn(
      t.insertionMode,
      t.selectedValue,
      t.tagScope | 12,
      N(t.viewTransition)
    );
  }
  function Jt(l, t) {
    l = N(t.viewTransition);
    var i = t.tagScope | 16;
    return l !== null && l.share !== "none" && (i |= 64), xn(
      t.insertionMode,
      t.selectedValue,
      i,
      l
    );
  }
  var ca = /* @__PURE__ */ new Map();
  function Pe(l, t) {
    if (typeof t != "object") throw Error(R(62));
    var i = !0, u;
    for (u in t)
      if (nn.call(t, u)) {
        var f = t[u];
        if (f != null && typeof f != "boolean" && f !== "") {
          if (u.indexOf("--") === 0) {
            var o = k(u);
            f = k(("" + f).trim());
          } else
            o = ca.get(u), o === void 0 && (o = k(
              u.replace(Qr, "-$1").toLowerCase().replace(aa, "-ms-")
            ), ca.set(u, o)), f = typeof f == "number" ? f === 0 || Zn.has(u) ? "" + f : f + "px" : k(("" + f).trim());
          i ? (i = !1, l.push(' style="', o, ":", f)) : l.push(";", o, ":", f);
        }
      }
    i || l.push('"');
  }
  function Ll(l, t, i) {
    i && typeof i != "function" && typeof i != "symbol" && l.push(" ", t, '=""');
  }
  function wn(l, t, i) {
    typeof i != "function" && typeof i != "symbol" && typeof i != "boolean" && l.push(" ", t, '="', k(i), '"');
  }
  var fa = k(
    "javascript:throw new Error('React form unexpectedly submitted.')"
  );
  function hl(l, t) {
    this.push('<input type="hidden"'), Qn(l), wn(this, "name", t), wn(this, "value", l), this.push("/>");
  }
  function Qn(l) {
    if (typeof l != "string") throw Error(R(480));
  }
  function ie(l, t) {
    if (typeof t.$$FORM_ACTION == "function") {
      var i = l.nextFormID++;
      l = l.idPrefix + i;
      try {
        var u = t.$$FORM_ACTION(l);
        if (u) {
          var f = u.data;
          f?.forEach(Qn);
        }
        return u;
      } catch (o) {
        if (typeof o == "object" && o !== null && typeof o.then == "function")
          throw o;
      }
    }
    return null;
  }
  function ha(l, t, i, u, f, o, s, E) {
    var v = null;
    if (typeof u == "function") {
      var x = ie(t, u);
      x !== null ? (E = x.name, u = x.action || "", f = x.encType, o = x.method, s = x.target, v = x.data) : (l.push(" ", "formAction", '="', fa, '"'), s = o = f = u = E = null, qr(t, i));
    }
    return E != null && V(l, "name", E), u != null && V(l, "formAction", u), f != null && V(l, "formEncType", f), o != null && V(l, "formMethod", o), s != null && V(l, "formTarget", s), v;
  }
  function V(l, t, i) {
    switch (t) {
      case "className":
        wn(l, "class", i);
        break;
      case "tabIndex":
        wn(l, "tabindex", i);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        wn(l, t, i);
        break;
      case "style":
        Pe(l, i);
        break;
      case "src":
      case "href":
        if (i === "") break;
      case "action":
      case "formAction":
        if (i == null || typeof i == "function" || typeof i == "symbol" || typeof i == "boolean")
          break;
        i = C("" + i), l.push(" ", t, '="', k(i), '"');
        break;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "ref":
        break;
      case "autoFocus":
      case "multiple":
      case "muted":
        Ll(l, t.toLowerCase(), i);
        break;
      case "xlinkHref":
        if (typeof i == "function" || typeof i == "symbol" || typeof i == "boolean")
          break;
        i = C("" + i), l.push(" ", "xlink:href", '="', k(i), '"');
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        typeof i != "function" && typeof i != "symbol" && l.push(" ", t, '="', k(i), '"');
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        i && typeof i != "function" && typeof i != "symbol" && l.push(" ", t, '=""');
        break;
      case "capture":
      case "download":
        i === !0 ? l.push(" ", t, '=""') : i !== !1 && typeof i != "function" && typeof i != "symbol" && l.push(" ", t, '="', k(i), '"');
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        typeof i != "function" && typeof i != "symbol" && !isNaN(i) && 1 <= i && l.push(" ", t, '="', k(i), '"');
        break;
      case "rowSpan":
      case "start":
        typeof i == "function" || typeof i == "symbol" || isNaN(i) || l.push(" ", t, '="', k(i), '"');
        break;
      case "xlinkActuate":
        wn(l, "xlink:actuate", i);
        break;
      case "xlinkArcrole":
        wn(l, "xlink:arcrole", i);
        break;
      case "xlinkRole":
        wn(l, "xlink:role", i);
        break;
      case "xlinkShow":
        wn(l, "xlink:show", i);
        break;
      case "xlinkTitle":
        wn(l, "xlink:title", i);
        break;
      case "xlinkType":
        wn(l, "xlink:type", i);
        break;
      case "xmlBase":
        wn(l, "xml:base", i);
        break;
      case "xmlLang":
        wn(l, "xml:lang", i);
        break;
      case "xmlSpace":
        wn(l, "xml:space", i);
        break;
      default:
        if ((!(2 < t.length) || t[0] !== "o" && t[0] !== "O" || t[1] !== "n" && t[1] !== "N") && (t = Jn.get(t) || t, Xt(t))) {
          switch (typeof i) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              var u = t.toLowerCase().slice(0, 5);
              if (u !== "data-" && u !== "aria-") return;
          }
          l.push(" ", t, '="', k(i), '"');
        }
    }
  }
  function Vn(l, t, i) {
    if (t != null) {
      if (i != null) throw Error(R(60));
      if (typeof t != "object" || !("__html" in t))
        throw Error(R(61));
      t = t.__html, t != null && l.push("" + t);
    }
  }
  function eu(l) {
    var t = "";
    return Wn.Children.forEach(l, function(i) {
      i != null && (t += i);
    }), t;
  }
  function qr(l, t) {
    if ((l.instructions & 16) === 0) {
      l.instructions |= 16;
      var i = t.preamble, u = t.bootstrapChunks;
      (i.htmlChunks || i.headChunks) && u.length === 0 ? (u.push(t.startInlineScript), it(u, l), u.push(
        ">",
        `addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error('React form unexpectedly submitted.')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});`,
        "<\/script>"
      )) : u.unshift(
        t.startInlineScript,
        ">",
        `addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error('React form unexpectedly submitted.')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});`,
        "<\/script>"
      );
    }
  }
  function Rn(l, t) {
    l.push(an("link"));
    for (var i in t)
      if (nn.call(t, i)) {
        var u = t[i];
        if (u != null)
          switch (i) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(R(399, "link"));
            default:
              V(l, i, u);
          }
      }
    return l.push("/>"), null;
  }
  var pr = /(<\/|<)(s)(tyle)/gi;
  function jr(l, t, i, u) {
    return "" + t + (i === "s" ? "\\73 " : "\\53 ") + u;
  }
  function Me(l, t, i) {
    l.push(an(i));
    for (var u in t)
      if (nn.call(t, u)) {
        var f = t[u];
        if (f != null)
          switch (u) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(R(399, i));
            default:
              V(l, u, f);
          }
      }
    return l.push("/>"), null;
  }
  function Qt(l, t) {
    l.push(an("title"));
    var i = null, u = null, f;
    for (f in t)
      if (nn.call(t, f)) {
        var o = t[f];
        if (o != null)
          switch (f) {
            case "children":
              i = o;
              break;
            case "dangerouslySetInnerHTML":
              u = o;
              break;
            default:
              V(l, f, o);
          }
      }
    return l.push(">"), t = Array.isArray(i) ? 2 > i.length ? i[0] : null : i, typeof t != "function" && typeof t != "symbol" && t !== null && t !== void 0 && l.push(k("" + t)), Vn(l, u, i), l.push(Bl("title")), null;
  }
  function Ie(l, t) {
    l.push(an("script"));
    var i = null, u = null, f;
    for (f in t)
      if (nn.call(t, f)) {
        var o = t[f];
        if (o != null)
          switch (f) {
            case "children":
              i = o;
              break;
            case "dangerouslySetInnerHTML":
              u = o;
              break;
            default:
              V(l, f, o);
          }
      }
    return l.push(">"), Vn(l, u, i), typeof i == "string" && l.push(("" + i).replace(Kr, Zt)), l.push(Bl("script")), null;
  }
  function $r(l, t, i) {
    l.push(an(i));
    var u = i = null, f;
    for (f in t)
      if (nn.call(t, f)) {
        var o = t[f];
        if (o != null)
          switch (f) {
            case "children":
              i = o;
              break;
            case "dangerouslySetInnerHTML":
              u = o;
              break;
            default:
              V(l, f, o);
          }
      }
    return l.push(">"), Vn(l, u, i), i;
  }
  function Vt(l, t, i) {
    l.push(an(i));
    var u = i = null, f;
    for (f in t)
      if (nn.call(t, f)) {
        var o = t[f];
        if (o != null)
          switch (f) {
            case "children":
              i = o;
              break;
            case "dangerouslySetInnerHTML":
              u = o;
              break;
            default:
              V(l, f, o);
          }
      }
    return l.push(">"), Vn(l, u, i), typeof i == "string" ? (l.push(k(i)), null) : i;
  }
  var Kt = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, ni = /* @__PURE__ */ new Map();
  function an(l) {
    var t = ni.get(l);
    if (t === void 0) {
      if (!Kt.test(l))
        throw Error(R(65, l));
      t = "<" + l, ni.set(l, t);
    }
    return t;
  }
  function Cn(l, t, i, u, f, o, s, E, v) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
        break;
      case "a":
        l.push(an("a"));
        var x = null, A = null, S;
        for (S in i)
          if (nn.call(i, S)) {
            var M = i[S];
            if (M != null)
              switch (S) {
                case "children":
                  x = M;
                  break;
                case "dangerouslySetInnerHTML":
                  A = M;
                  break;
                case "href":
                  M === "" ? wn(l, "href", "") : V(l, S, M);
                  break;
                default:
                  V(l, S, M);
              }
          }
        if (l.push(">"), Vn(l, A, x), typeof x == "string") {
          l.push(k(x));
          var O = null;
        } else O = x;
        return O;
      case "g":
      case "p":
      case "li":
        break;
      case "select":
        l.push(an("select"));
        var G = null, z = null, D;
        for (D in i)
          if (nn.call(i, D)) {
            var B = i[D];
            if (B != null)
              switch (D) {
                case "children":
                  G = B;
                  break;
                case "dangerouslySetInnerHTML":
                  z = B;
                  break;
                case "defaultValue":
                case "value":
                  break;
                default:
                  V(
                    l,
                    D,
                    B
                  );
              }
          }
        return l.push(">"), Vn(l, z, G), G;
      case "option":
        var H = E.selectedValue;
        l.push(an("option"));
        var tn = null, fn = null, Z = null, K = null, Y;
        for (Y in i)
          if (nn.call(i, Y)) {
            var Gn = i[Y];
            if (Gn != null)
              switch (Y) {
                case "children":
                  tn = Gn;
                  break;
                case "selected":
                  Z = Gn;
                  break;
                case "dangerouslySetInnerHTML":
                  K = Gn;
                  break;
                case "value":
                  fn = Gn;
                default:
                  V(
                    l,
                    Y,
                    Gn
                  );
              }
          }
        if (H != null) {
          var J = fn !== null ? "" + fn : eu(tn);
          if (te(H)) {
            for (var pn = 0; pn < H.length; pn++)
              if ("" + H[pn] === J) {
                l.push(' selected=""');
                break;
              }
          } else
            "" + H === J && l.push(' selected=""');
        } else Z && l.push(' selected=""');
        return l.push(">"), Vn(l, K, tn), tn;
      case "textarea":
        l.push(an("textarea"));
        var q = null, gn = null, bn = null, rn;
        for (rn in i)
          if (nn.call(i, rn)) {
            var zn = i[rn];
            if (zn != null)
              switch (rn) {
                case "children":
                  bn = zn;
                  break;
                case "value":
                  q = zn;
                  break;
                case "defaultValue":
                  gn = zn;
                  break;
                case "dangerouslySetInnerHTML":
                  throw Error(R(91));
                default:
                  V(
                    l,
                    rn,
                    zn
                  );
              }
          }
        if (q === null && gn !== null && (q = gn), l.push(">"), bn != null) {
          if (q != null) throw Error(R(92));
          if (te(bn)) {
            if (1 < bn.length)
              throw Error(R(93));
            q = "" + bn[0];
          }
          q = "" + bn;
        }
        return typeof q == "string" && q[0] === `
` && l.push(`
`), q !== null && l.push(k("" + q)), null;
      case "input":
        l.push(an("input"));
        var be = null, jn = null, xt = null, He = null, kn = null, tl = null, dl = null, sl = null, wl = null, Xl;
        for (Xl in i)
          if (nn.call(i, Xl)) {
            var En = i[Xl];
            if (En != null)
              switch (Xl) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(R(399, "input"));
                case "name":
                  be = En;
                  break;
                case "formAction":
                  jn = En;
                  break;
                case "formEncType":
                  xt = En;
                  break;
                case "formMethod":
                  He = En;
                  break;
                case "formTarget":
                  kn = En;
                  break;
                case "defaultChecked":
                  wl = En;
                  break;
                case "defaultValue":
                  dl = En;
                  break;
                case "checked":
                  sl = En;
                  break;
                case "value":
                  tl = En;
                  break;
                default:
                  V(
                    l,
                    Xl,
                    En
                  );
              }
          }
        var ye = ha(
          l,
          u,
          f,
          jn,
          xt,
          He,
          kn,
          be
        );
        return sl !== null ? Ll(l, "checked", sl) : wl !== null && Ll(l, "checked", wl), tl !== null ? V(l, "value", tl) : dl !== null && V(l, "value", dl), l.push("/>"), ye?.forEach(hl, l), null;
      case "button":
        l.push(an("button"));
        var wt = null, Si = null, Ai = null, za = null, Pi = null, Rt = null, Da = null, Te;
        for (Te in i)
          if (nn.call(i, Te)) {
            var bl = i[Te];
            if (bl != null)
              switch (Te) {
                case "children":
                  wt = bl;
                  break;
                case "dangerouslySetInnerHTML":
                  Si = bl;
                  break;
                case "name":
                  Ai = bl;
                  break;
                case "formAction":
                  za = bl;
                  break;
                case "formEncType":
                  Pi = bl;
                  break;
                case "formMethod":
                  Rt = bl;
                  break;
                case "formTarget":
                  Da = bl;
                  break;
                default:
                  V(
                    l,
                    Te,
                    bl
                  );
              }
          }
        var Ee = ha(
          l,
          u,
          f,
          za,
          Pi,
          Rt,
          Da,
          Ai
        );
        if (l.push(">"), Ee?.forEach(hl, l), Vn(l, Si, wt), typeof wt == "string") {
          l.push(k(wt));
          var Fr = null;
        } else Fr = wt;
        return Fr;
      case "form":
        l.push(an("form"));
        var Zl = null, Mi = null, rl = null, Ct = null, We = null, Ue = null, Ft;
        for (Ft in i)
          if (nn.call(i, Ft)) {
            var Rl = i[Ft];
            if (Rl != null)
              switch (Ft) {
                case "children":
                  Zl = Rl;
                  break;
                case "dangerouslySetInnerHTML":
                  Mi = Rl;
                  break;
                case "action":
                  rl = Rl;
                  break;
                case "encType":
                  Ct = Rl;
                  break;
                case "method":
                  We = Rl;
                  break;
                case "target":
                  Ue = Rl;
                  break;
                default:
                  V(
                    l,
                    Ft,
                    Rl
                  );
              }
          }
        var Ii = null, yn = null;
        if (typeof rl == "function") {
          var Jl = ie(
            u,
            rl
          );
          Jl !== null ? (rl = Jl.action || "", Ct = Jl.encType, We = Jl.method, Ue = Jl.target, Ii = Jl.data, yn = Jl.name) : (l.push(
            " ",
            "action",
            '="',
            fa,
            '"'
          ), Ue = We = Ct = rl = null, qr(u, f));
        }
        if (rl != null && V(l, "action", rl), Ct != null && V(l, "encType", Ct), We != null && V(l, "method", We), Ue != null && V(l, "target", Ue), l.push(">"), yn !== null && (l.push('<input type="hidden"'), wn(l, "name", yn), l.push("/>"), Ii?.forEach(hl, l)), Vn(l, Mi, Zl), typeof Zl == "string") {
          l.push(k(Zl));
          var Ge = null;
        } else Ge = Zl;
        return Ge;
      case "menuitem":
        l.push(an("menuitem"));
        for (var Ql in i)
          if (nn.call(i, Ql)) {
            var Sr = i[Ql];
            if (Sr != null)
              switch (Ql) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(R(400));
                default:
                  V(
                    l,
                    Ql,
                    Sr
                  );
              }
          }
        return l.push(">"), null;
      case "object":
        l.push(an("object"));
        var il = null, Vl = null, xe;
        for (xe in i)
          if (nn.call(i, xe)) {
            var al = i[xe];
            if (al != null)
              switch (xe) {
                case "children":
                  il = al;
                  break;
                case "dangerouslySetInnerHTML":
                  Vl = al;
                  break;
                case "data":
                  var An = C("" + al);
                  if (An === "") break;
                  l.push(
                    " ",
                    "data",
                    '="',
                    k(An),
                    '"'
                  );
                  break;
                default:
                  V(
                    l,
                    xe,
                    al
                  );
              }
          }
        if (l.push(">"), Vn(l, Vl, il), typeof il == "string") {
          l.push(k(il));
          var Ye = null;
        } else Ye = il;
        return Ye;
      case "title":
        var On = E.tagScope & 1, _i = E.tagScope & 4;
        if (E.insertionMode === 4 || On || i.itemProp != null)
          var St = Qt(
            l,
            i
          );
        else
          _i ? St = null : (Qt(f.hoistableChunks, i), St = void 0);
        return St;
      case "link":
        var At = E.tagScope & 1, Ha = E.tagScope & 4, Wa = i.rel, Cl = i.href, we = i.precedence;
        if (E.insertionMode === 4 || At || i.itemProp != null || typeof Wa != "string" || typeof Cl != "string" || Cl === "") {
          Rn(l, i);
          var Kl = null;
        } else if (i.rel === "stylesheet")
          if (typeof we != "string" || i.disabled != null || i.onLoad || i.onError)
            Kl = Rn(
              l,
              i
            );
          else {
            var Pn = f.styles.get(we), Xe = u.styleResources.hasOwnProperty(Cl) ? u.styleResources[Cl] : void 0;
            if (Xe !== null) {
              u.styleResources[Cl] = null, Pn || (Pn = {
                precedence: k(we),
                rules: [],
                hrefs: [],
                sheets: /* @__PURE__ */ new Map()
              }, f.styles.set(we, Pn));
              var Ze = {
                state: 0,
                props: Bn({}, i, {
                  "data-precedence": i.precedence,
                  precedence: null
                })
              };
              if (Xe) {
                Xe.length === 2 && ut(Ze.props, Xe);
                var Ar = f.preloads.stylesheets.get(Cl);
                Ar && 0 < Ar.length ? Ar.length = 0 : Ze.state = 1;
              }
              Pn.sheets.set(Cl, Ze), s && s.stylesheets.add(Ze);
            } else if (Pn) {
              var Pr = Pn.sheets.get(Cl);
              Pr && s && s.stylesheets.add(Pr);
            }
            v && l.push("<!-- -->"), Kl = null;
          }
        else
          i.onLoad || i.onError ? Kl = Rn(
            l,
            i
          ) : (v && l.push("<!-- -->"), Kl = Ha ? null : Rn(f.hoistableChunks, i));
        return Kl;
      case "script":
        var ki = E.tagScope & 1, Mr = i.async;
        if (typeof i.src != "string" || !i.src || !Mr || typeof Mr == "function" || typeof Mr == "symbol" || i.onLoad || i.onError || E.insertionMode === 4 || ki || i.itemProp != null)
          var Oi = Ie(
            l,
            i
          );
        else {
          var dn = i.src;
          if (i.type === "module")
            var Ir = u.moduleScriptResources, Je = f.preloads.moduleScripts;
          else
            Ir = u.scriptResources, Je = f.preloads.scripts;
          var Qe = Ir.hasOwnProperty(dn) ? Ir[dn] : void 0;
          if (Qe !== null) {
            Ir[dn] = null;
            var Pt = i;
            if (Qe) {
              Qe.length === 2 && (Pt = Bn({}, i), ut(Pt, Qe));
              var _r = Je.get(dn);
              _r && (_r.length = 0);
            }
            var Mt = [];
            f.scripts.add(Mt), Ie(Mt, Pt);
          }
          v && l.push("<!-- -->"), Oi = null;
        }
        return Oi;
      case "style":
        var It = E.tagScope & 1, Fl = i.precedence, $n = i.href, Li = i.nonce;
        if (E.insertionMode === 4 || It || i.itemProp != null || typeof Fl != "string" || typeof $n != "string" || $n === "") {
          l.push(an("style"));
          var ml = null, Bi = null, Sl;
          for (Sl in i)
            if (nn.call(i, Sl)) {
              var Re = i[Sl];
              if (Re != null)
                switch (Sl) {
                  case "children":
                    ml = Re;
                    break;
                  case "dangerouslySetInnerHTML":
                    Bi = Re;
                    break;
                  default:
                    V(
                      l,
                      Sl,
                      Re
                    );
                }
            }
          l.push(">");
          var Al = Array.isArray(ml) ? 2 > ml.length ? ml[0] : null : ml;
          typeof Al != "function" && typeof Al != "symbol" && Al !== null && Al !== void 0 && l.push(("" + Al).replace(pr, jr)), Vn(l, Bi, ml), l.push(Bl("style"));
          var Ve = null;
        } else {
          var Pl = f.styles.get(Fl);
          if ((u.styleResources.hasOwnProperty($n) ? u.styleResources[$n] : void 0) !== null) {
            u.styleResources[$n] = null, Pl || (Pl = {
              precedence: k(Fl),
              rules: [],
              hrefs: [],
              sheets: /* @__PURE__ */ new Map()
            }, f.styles.set(Fl, Pl));
            var Ni = f.nonce.style;
            if (!Ni || Ni === Li) {
              Pl.hrefs.push(k($n));
              var zi = Pl.rules, Ml = null, _t = null, Ce;
              for (Ce in i)
                if (nn.call(i, Ce)) {
                  var Il = i[Ce];
                  if (Il != null)
                    switch (Ce) {
                      case "children":
                        Ml = Il;
                        break;
                      case "dangerouslySetInnerHTML":
                        _t = Il;
                    }
                }
              var ql = Array.isArray(Ml) ? 2 > Ml.length ? Ml[0] : null : Ml;
              typeof ql != "function" && typeof ql != "symbol" && ql !== null && ql !== void 0 && zi.push(
                ("" + ql).replace(pr, jr)
              ), Vn(zi, _t, Ml);
            }
          }
          Pl && s && s.styles.add(Pl), v && l.push("<!-- -->"), Ve = void 0;
        }
        return Ve;
      case "meta":
        var ul = E.tagScope & 1, kr = E.tagScope & 4;
        if (E.insertionMode === 4 || ul || i.itemProp != null)
          var Di = Me(
            l,
            i,
            "meta"
          );
        else
          v && l.push("<!-- -->"), Di = kr ? null : typeof i.charSet == "string" ? Me(f.charsetChunks, i, "meta") : i.name === "viewport" ? Me(f.viewportChunks, i, "meta") : Me(f.hoistableChunks, i, "meta");
        return Di;
      case "listing":
      case "pre":
        l.push(an(t));
        var Ke = null, n = null, e;
        for (e in i)
          if (nn.call(i, e)) {
            var r = i[e];
            if (r != null)
              switch (e) {
                case "children":
                  Ke = r;
                  break;
                case "dangerouslySetInnerHTML":
                  n = r;
                  break;
                default:
                  V(
                    l,
                    e,
                    r
                  );
              }
          }
        if (l.push(">"), n != null) {
          if (Ke != null) throw Error(R(60));
          if (typeof n != "object" || !("__html" in n))
            throw Error(R(61));
          var a = n.__html;
          a != null && (typeof a == "string" && 0 < a.length && a[0] === `
` ? l.push(`
`, a) : l.push("" + a));
        }
        return typeof Ke == "string" && Ke[0] === `
` && l.push(`
`), Ke;
      case "img":
        var c = E.tagScope & 3, h = i.src, d = i.srcSet;
        if (!(i.loading === "lazy" || !h && !d || typeof h != "string" && h != null || typeof d != "string" && d != null || i.fetchPriority === "low" || c) && (typeof h != "string" || h[4] !== ":" || h[0] !== "d" && h[0] !== "D" || h[1] !== "a" && h[1] !== "A" || h[2] !== "t" && h[2] !== "T" || h[3] !== "a" && h[3] !== "A") && (typeof d != "string" || d[4] !== ":" || d[0] !== "d" && d[0] !== "D" || d[1] !== "a" && d[1] !== "A" || d[2] !== "t" && d[2] !== "T" || d[3] !== "a" && d[3] !== "A")) {
          s !== null && E.tagScope & 64 && (s.suspenseyImages = !0);
          var b = typeof i.sizes == "string" ? i.sizes : void 0, g = d ? d + `
` + (b || "") : h, y = f.preloads.images, T = y.get(g);
          if (T)
            (i.fetchPriority === "high" || 10 > f.highImagePreloads.size) && (y.delete(g), f.highImagePreloads.add(T));
          else if (!u.imageResources.hasOwnProperty(g)) {
            u.imageResources[g] = nl;
            var w = i.crossOrigin, P = typeof w == "string" ? w === "use-credentials" ? w : "" : void 0, _ = f.headers, X;
            _ && 0 < _.remainingCapacity && typeof i.srcSet != "string" && (i.fetchPriority === "high" || 500 > _.highImagePreloads.length) && (X = vn(h, "image", {
              imageSrcSet: i.srcSet,
              imageSizes: i.sizes,
              crossOrigin: P,
              integrity: i.integrity,
              nonce: i.nonce,
              type: i.type,
              fetchPriority: i.fetchPriority,
              referrerPolicy: i.refererPolicy
            }), 0 <= (_.remainingCapacity -= X.length + 2)) ? (f.resets.image[g] = nl, _.highImagePreloads && (_.highImagePreloads += ", "), _.highImagePreloads += X) : (T = [], Rn(T, {
              rel: "preload",
              as: "image",
              href: d ? void 0 : h,
              imageSrcSet: d,
              imageSizes: b,
              crossOrigin: P,
              integrity: i.integrity,
              type: i.type,
              fetchPriority: i.fetchPriority,
              referrerPolicy: i.referrerPolicy
            }), i.fetchPriority === "high" || 10 > f.highImagePreloads.size ? f.highImagePreloads.add(T) : (f.bulkPreloads.add(T), y.set(g, T)));
          }
        }
        return Me(l, i, "img");
      case "base":
      case "area":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "param":
      case "source":
      case "track":
      case "wbr":
        return Me(l, i, t);
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        break;
      case "head":
        if (2 > E.insertionMode) {
          var W = o || f.preamble;
          if (W.headChunks)
            throw Error(R(545, "`<head>`"));
          o !== null && l.push("<!--head-->"), W.headChunks = [];
          var U = $r(
            W.headChunks,
            i,
            "head"
          );
        } else
          U = Vt(
            l,
            i,
            "head"
          );
        return U;
      case "body":
        if (2 > E.insertionMode) {
          var en = o || f.preamble;
          if (en.bodyChunks)
            throw Error(R(545, "`<body>`"));
          o !== null && l.push("<!--body-->"), en.bodyChunks = [];
          var p = $r(
            en.bodyChunks,
            i,
            "body"
          );
        } else
          p = Vt(
            l,
            i,
            "body"
          );
        return p;
      case "html":
        if (E.insertionMode === 0) {
          var Mn = o || f.preamble;
          if (Mn.htmlChunks)
            throw Error(R(545, "`<html>`"));
          o !== null && l.push("<!--html-->"), Mn.htmlChunks = [""];
          var Yn = $r(
            Mn.htmlChunks,
            i,
            "html"
          );
        } else
          Yn = Vt(
            l,
            i,
            "html"
          );
        return Yn;
      default:
        if (t.indexOf("-") !== -1) {
          l.push(an(t));
          var cl = null, L = null, Ln;
          for (Ln in i)
            if (nn.call(i, Ln)) {
              var hn = i[Ln];
              if (hn != null) {
                var Dn = Ln;
                switch (Ln) {
                  case "children":
                    cl = hn;
                    break;
                  case "dangerouslySetInnerHTML":
                    L = hn;
                    break;
                  case "style":
                    Pe(l, hn);
                    break;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "ref":
                    break;
                  case "className":
                    Dn = "class";
                  default:
                    if (Xt(Ln) && typeof hn != "function" && typeof hn != "symbol" && hn !== !1) {
                      if (hn === !0) hn = "";
                      else if (typeof hn == "object") continue;
                      l.push(
                        " ",
                        Dn,
                        '="',
                        k(hn),
                        '"'
                      );
                    }
                }
              }
            }
          return l.push(">"), Vn(l, L, cl), cl;
        }
    }
    return Vt(l, i, t);
  }
  var li = /* @__PURE__ */ new Map();
  function Bl(l) {
    var t = li.get(l);
    return t === void 0 && (t = "</" + l + ">", li.set(l, t)), t;
  }
  function ei(l, t) {
    l = l.preamble, l.htmlChunks === null && t.htmlChunks && (l.htmlChunks = t.htmlChunks), l.headChunks === null && t.headChunks && (l.headChunks = t.headChunks), l.bodyChunks === null && t.bodyChunks && (l.bodyChunks = t.bodyChunks);
  }
  function mt(l, t) {
    t = t.bootstrapChunks;
    for (var i = 0; i < t.length - 1; i++)
      l.push(t[i]);
    return i < t.length ? (i = t[i], t.length = 0, l.push(i)) : !0;
  }
  function et(l, t, i) {
    if (l.push('<!--$?--><template id="'), i === null) throw Error(R(395));
    return l.push(t.boundaryPrefix), t = i.toString(16), l.push(t), l.push('"></template>');
  }
  function ol(l, t, i, u) {
    switch (i.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return l.push('<div hidden id="'), l.push(t.segmentPrefix), t = u.toString(16), l.push(t), l.push('">');
      case 4:
        return l.push('<svg aria-hidden="true" style="display:none" id="'), l.push(t.segmentPrefix), t = u.toString(16), l.push(t), l.push('">');
      case 5:
        return l.push('<math aria-hidden="true" style="display:none" id="'), l.push(t.segmentPrefix), t = u.toString(16), l.push(t), l.push('">');
      case 6:
        return l.push('<table hidden id="'), l.push(t.segmentPrefix), t = u.toString(16), l.push(t), l.push('">');
      case 7:
        return l.push('<table hidden><tbody id="'), l.push(t.segmentPrefix), t = u.toString(16), l.push(t), l.push('">');
      case 8:
        return l.push('<table hidden><tr id="'), l.push(t.segmentPrefix), t = u.toString(16), l.push(t), l.push('">');
      case 9:
        return l.push('<table hidden><colgroup id="'), l.push(t.segmentPrefix), t = u.toString(16), l.push(t), l.push('">');
      default:
        throw Error(R(397));
    }
  }
  function oa(l, t) {
    switch (t.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return l.push("</div>");
      case 4:
        return l.push("</svg>");
      case 5:
        return l.push("</math>");
      case 6:
        return l.push("</table>");
      case 7:
        return l.push("</tbody></table>");
      case 8:
        return l.push("</tr></table>");
      case 9:
        return l.push("</colgroup></table>");
      default:
        throw Error(R(397));
    }
  }
  var da = /[<\u2028\u2029]/g;
  function tu(l) {
    return JSON.stringify(l).replace(
      da,
      function(t) {
        switch (t) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var sa = /[&><\u2028\u2029]/g;
  function tt(l) {
    return JSON.stringify(l).replace(
      sa,
      function(t) {
        switch (t) {
          case "&":
            return "\\u0026";
          case ">":
            return "\\u003e";
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSObjectForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var rt = !1, Fn = !0;
  function ll(l) {
    var t = l.rules, i = l.hrefs, u = 0;
    if (i.length) {
      for (this.push(re.startInlineStyle), this.push(' media="not all" data-precedence="'), this.push(l.precedence), this.push('" data-href="'); u < i.length - 1; u++)
        this.push(i[u]), this.push(" ");
      for (this.push(i[u]), this.push('">'), u = 0; u < t.length; u++) this.push(t[u]);
      Fn = this.push("</style>"), rt = !0, t.length = 0, i.length = 0;
    }
  }
  function un(l) {
    return l.state !== 2 ? rt = !0 : !1;
  }
  function qt(l, t, i) {
    return rt = !1, Fn = !0, re = i, t.styles.forEach(ll, l), re = null, t.stylesheets.forEach(un), rt && (i.stylesToHoist = !0), Fn;
  }
  function Kn(l) {
    for (var t = 0; t < l.length; t++) this.push(l[t]);
    l.length = 0;
  }
  var cn = [];
  function ga(l) {
    Rn(cn, l.props);
    for (var t = 0; t < cn.length; t++)
      this.push(cn[t]);
    cn.length = 0, l.state = 2;
  }
  function va(l) {
    var t = 0 < l.sheets.size;
    l.sheets.forEach(ga, this), l.sheets.clear();
    var i = l.rules, u = l.hrefs;
    if (!t || u.length) {
      if (this.push(re.startInlineStyle), this.push(' data-precedence="'), this.push(l.precedence), l = 0, u.length) {
        for (this.push('" data-href="'); l < u.length - 1; l++)
          this.push(u[l]), this.push(" ");
        this.push(u[l]);
      }
      for (this.push('">'), l = 0; l < i.length; l++)
        this.push(i[l]);
      this.push("</style>"), i.length = 0, u.length = 0;
    }
  }
  function ti(l) {
    if (l.state === 0) {
      l.state = 1;
      var t = l.props;
      for (Rn(cn, {
        rel: "preload",
        as: "style",
        href: l.props.href,
        crossOrigin: t.crossOrigin,
        fetchPriority: t.fetchPriority,
        integrity: t.integrity,
        media: t.media,
        hrefLang: t.hrefLang,
        referrerPolicy: t.referrerPolicy
      }), l = 0; l < cn.length; l++)
        this.push(cn[l]);
      cn.length = 0;
    }
  }
  function ba(l) {
    l.sheets.forEach(ti, this), l.sheets.clear();
  }
  function it(l, t) {
    (t.instructions & 32) === 0 && (t.instructions |= 32, l.push(
      ' id="',
      k("_" + t.idPrefix + "R_"),
      '"'
    ));
  }
  function ya(l, t) {
    l.push("[");
    var i = "[";
    t.stylesheets.forEach(function(u) {
      if (u.state !== 2)
        if (u.state === 3)
          l.push(i), u = tt(
            "" + u.props.href
          ), l.push(u), l.push("]"), i = ",[";
        else {
          l.push(i);
          var f = u.props["data-precedence"], o = u.props, s = C("" + u.props.href);
          s = tt(s), l.push(s), f = "" + f, l.push(","), f = tt(f), l.push(f);
          for (var E in o)
            if (nn.call(o, E) && (f = o[E], f != null))
              switch (E) {
                case "href":
                case "rel":
                case "precedence":
                case "data-precedence":
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(R(399, "link"));
                default:
                  m(
                    l,
                    E,
                    f
                  );
              }
          l.push("]"), i = ",[", u.state = 3;
        }
    }), l.push("]");
  }
  function m(l, t, i) {
    var u = t.toLowerCase();
    switch (typeof i) {
      case "function":
      case "symbol":
        return;
    }
    switch (t) {
      case "innerHTML":
      case "dangerouslySetInnerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "style":
      case "ref":
        return;
      case "className":
        u = "class", t = "" + i;
        break;
      case "hidden":
        if (i === !1) return;
        t = "";
        break;
      case "src":
      case "href":
        i = C(i), t = "" + i;
        break;
      default:
        if (2 < t.length && (t[0] === "o" || t[0] === "O") && (t[1] === "n" || t[1] === "N") || !Xt(t))
          return;
        t = "" + i;
    }
    l.push(","), u = tt(u), l.push(u), l.push(","), u = tt(t), l.push(u);
  }
  function ln() {
    return { styles: /* @__PURE__ */ new Set(), stylesheets: /* @__PURE__ */ new Set(), suspenseyImages: !1 };
  }
  function at(l) {
    var t = Sn || null;
    if (t) {
      var i = t.resumableState, u = t.renderState;
      if (typeof l == "string" && l) {
        if (!i.dnsResources.hasOwnProperty(l)) {
          i.dnsResources[l] = null, i = u.headers;
          var f, o;
          (o = i && 0 < i.remainingCapacity) && (o = (f = "<" + ("" + l).replace(
            pt,
            jt
          ) + ">; rel=dns-prefetch", 0 <= (i.remainingCapacity -= f.length + 2))), o ? (u.resets.dns[l] = null, i.preconnects && (i.preconnects += ", "), i.preconnects += f) : (f = [], Rn(f, { href: l, rel: "dns-prefetch" }), u.preconnects.add(f));
        }
        ve(t);
      }
    } else Q.D(l);
  }
  function mn(l, t) {
    var i = Sn || null;
    if (i) {
      var u = i.resumableState, f = i.renderState;
      if (typeof l == "string" && l) {
        var o = t === "use-credentials" ? "credentials" : typeof t == "string" ? "anonymous" : "default";
        if (!u.connectResources[o].hasOwnProperty(l)) {
          u.connectResources[o][l] = null, u = f.headers;
          var s, E;
          if (E = u && 0 < u.remainingCapacity) {
            if (E = "<" + ("" + l).replace(
              pt,
              jt
            ) + ">; rel=preconnect", typeof t == "string") {
              var v = ("" + t).replace(
                Nl,
                $t
              );
              E += '; crossorigin="' + v + '"';
            }
            E = (s = E, 0 <= (u.remainingCapacity -= s.length + 2));
          }
          E ? (f.resets.connect[o][l] = null, u.preconnects && (u.preconnects += ", "), u.preconnects += s) : (o = [], Rn(o, {
            rel: "preconnect",
            href: l,
            crossOrigin: t
          }), f.preconnects.add(o));
        }
        ve(i);
      }
    } else Q.C(l, t);
  }
  function ru(l, t, i) {
    var u = Sn || null;
    if (u) {
      var f = u.resumableState, o = u.renderState;
      if (t && l) {
        switch (t) {
          case "image":
            if (i)
              var s = i.imageSrcSet, E = i.imageSizes, v = i.fetchPriority;
            var x = s ? s + `
` + (E || "") : l;
            if (f.imageResources.hasOwnProperty(x)) return;
            f.imageResources[x] = nl, f = o.headers;
            var A;
            f && 0 < f.remainingCapacity && typeof s != "string" && v === "high" && (A = vn(l, t, i), 0 <= (f.remainingCapacity -= A.length + 2)) ? (o.resets.image[x] = nl, f.highImagePreloads && (f.highImagePreloads += ", "), f.highImagePreloads += A) : (f = [], Rn(
              f,
              Bn(
                { rel: "preload", href: s ? void 0 : l, as: t },
                i
              )
            ), v === "high" ? o.highImagePreloads.add(f) : (o.bulkPreloads.add(f), o.preloads.images.set(x, f)));
            break;
          case "style":
            if (f.styleResources.hasOwnProperty(l)) return;
            s = [], Rn(
              s,
              Bn({ rel: "preload", href: l, as: t }, i)
            ), f.styleResources[l] = !i || typeof i.crossOrigin != "string" && typeof i.integrity != "string" ? nl : [i.crossOrigin, i.integrity], o.preloads.stylesheets.set(l, s), o.bulkPreloads.add(s);
            break;
          case "script":
            if (f.scriptResources.hasOwnProperty(l)) return;
            s = [], o.preloads.scripts.set(l, s), o.bulkPreloads.add(s), Rn(
              s,
              Bn({ rel: "preload", href: l, as: t }, i)
            ), f.scriptResources[l] = !i || typeof i.crossOrigin != "string" && typeof i.integrity != "string" ? nl : [i.crossOrigin, i.integrity];
            break;
          default:
            if (f.unknownResources.hasOwnProperty(t)) {
              if (s = f.unknownResources[t], s.hasOwnProperty(l))
                return;
            } else
              s = {}, f.unknownResources[t] = s;
            if (s[l] = nl, (f = o.headers) && 0 < f.remainingCapacity && t === "font" && (x = vn(l, t, i), 0 <= (f.remainingCapacity -= x.length + 2)))
              o.resets.font[l] = nl, f.fontPreloads && (f.fontPreloads += ", "), f.fontPreloads += x;
            else
              switch (f = [], l = Bn({ rel: "preload", href: l, as: t }, i), Rn(f, l), t) {
                case "font":
                  o.fontPreloads.add(f);
                  break;
                default:
                  o.bulkPreloads.add(f);
              }
        }
        ve(u);
      }
    } else Q.L(l, t, i);
  }
  function ri(l, t) {
    var i = Sn || null;
    if (i) {
      var u = i.resumableState, f = i.renderState;
      if (l) {
        var o = t && typeof t.as == "string" ? t.as : "script";
        switch (o) {
          case "script":
            if (u.moduleScriptResources.hasOwnProperty(l)) return;
            o = [], u.moduleScriptResources[l] = !t || typeof t.crossOrigin != "string" && typeof t.integrity != "string" ? nl : [t.crossOrigin, t.integrity], f.preloads.moduleScripts.set(l, o);
            break;
          default:
            if (u.moduleUnknownResources.hasOwnProperty(o)) {
              var s = u.unknownResources[o];
              if (s.hasOwnProperty(l)) return;
            } else
              s = {}, u.moduleUnknownResources[o] = s;
            o = [], s[l] = nl;
        }
        Rn(o, Bn({ rel: "modulepreload", href: l }, t)), f.bulkPreloads.add(o), ve(i);
      }
    } else Q.m(l, t);
  }
  function Ta(l, t, i) {
    var u = Sn || null;
    if (u) {
      var f = u.resumableState, o = u.renderState;
      if (l) {
        t = t || "default";
        var s = o.styles.get(t), E = f.styleResources.hasOwnProperty(l) ? f.styleResources[l] : void 0;
        E !== null && (f.styleResources[l] = null, s || (s = {
          precedence: k(t),
          rules: [],
          hrefs: [],
          sheets: /* @__PURE__ */ new Map()
        }, o.styles.set(t, s)), t = {
          state: 0,
          props: Bn(
            { rel: "stylesheet", href: l, "data-precedence": t },
            i
          )
        }, E && (E.length === 2 && ut(t.props, E), (o = o.preloads.stylesheets.get(l)) && 0 < o.length ? o.length = 0 : t.state = 1), s.sheets.set(l, t), ve(u));
      }
    } else Q.S(l, t, i);
  }
  function Ea(l, t) {
    var i = Sn || null;
    if (i) {
      var u = i.resumableState, f = i.renderState;
      if (l) {
        var o = u.scriptResources.hasOwnProperty(l) ? u.scriptResources[l] : void 0;
        o !== null && (u.scriptResources[l] = null, t = Bn({ src: l, async: !0 }, t), o && (o.length === 2 && ut(t, o), l = f.preloads.scripts.get(l)) && (l.length = 0), l = [], f.scripts.add(l), Ie(l, t), ve(i));
      }
    } else Q.X(l, t);
  }
  function iu(l, t) {
    var i = Sn || null;
    if (i) {
      var u = i.resumableState, f = i.renderState;
      if (l) {
        var o = u.moduleScriptResources.hasOwnProperty(
          l
        ) ? u.moduleScriptResources[l] : void 0;
        o !== null && (u.moduleScriptResources[l] = null, t = Bn({ src: l, type: "module", async: !0 }, t), o && (o.length === 2 && ut(t, o), l = f.preloads.moduleScripts.get(l)) && (l.length = 0), l = [], f.scripts.add(l), Ie(l, t), ve(i));
      }
    } else Q.M(l, t);
  }
  function ut(l, t) {
    l.crossOrigin == null && (l.crossOrigin = t[0]), l.integrity == null && (l.integrity = t[1]);
  }
  function vn(l, t, i) {
    l = ("" + l).replace(
      pt,
      jt
    ), t = ("" + t).replace(
      Nl,
      $t
    ), t = "<" + l + '>; rel=preload; as="' + t + '"';
    for (var u in i)
      nn.call(i, u) && (l = i[u], typeof l == "string" && (t += "; " + u.toLowerCase() + '="' + ("" + l).replace(
        Nl,
        $t
      ) + '"'));
    return t;
  }
  var pt = /[<>\r\n]/g;
  function jt(l) {
    switch (l) {
      case "<":
        return "%3C";
      case ">":
        return "%3E";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeLinkHrefForHeaderContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  var Nl = /["';,\r\n]/g;
  function $t(l) {
    switch (l) {
      case '"':
        return "%22";
      case "'":
        return "%27";
      case ";":
        return "%3B";
      case ",":
        return "%2C";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeStringForLinkHeaderQuotedParamValueContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  function au(l) {
    this.styles.add(l);
  }
  function uu(l) {
    this.stylesheets.add(l);
  }
  function _e(l, t) {
    t.styles.forEach(au, l), t.stylesheets.forEach(uu, l), t.suspenseyImages && (l.suspenseyImages = !0);
  }
  function nr(l, t) {
    var i = l.idPrefix, u = [], f = l.bootstrapScriptContent, o = l.bootstrapScripts, s = l.bootstrapModules;
    f !== void 0 && (u.push("<script"), it(u, l), u.push(
      ">",
      ("" + f).replace(Kr, Zt),
      "<\/script>"
    )), f = i + "P:";
    var E = i + "S:";
    i += "B:";
    var v = /* @__PURE__ */ new Set(), x = /* @__PURE__ */ new Set(), A = /* @__PURE__ */ new Set(), S = /* @__PURE__ */ new Map(), M = /* @__PURE__ */ new Set(), O = /* @__PURE__ */ new Set(), G = /* @__PURE__ */ new Set(), z = {
      images: /* @__PURE__ */ new Map(),
      stylesheets: /* @__PURE__ */ new Map(),
      scripts: /* @__PURE__ */ new Map(),
      moduleScripts: /* @__PURE__ */ new Map()
    };
    if (o !== void 0)
      for (var D = 0; D < o.length; D++) {
        var B = o[D], H, tn = void 0, fn = void 0, Z = {
          rel: "preload",
          as: "script",
          fetchPriority: "low",
          nonce: void 0
        };
        typeof B == "string" ? Z.href = H = B : (Z.href = H = B.src, Z.integrity = fn = typeof B.integrity == "string" ? B.integrity : void 0, Z.crossOrigin = tn = typeof B == "string" || B.crossOrigin == null ? void 0 : B.crossOrigin === "use-credentials" ? "use-credentials" : ""), B = l;
        var K = H;
        B.scriptResources[K] = null, B.moduleScriptResources[K] = null, B = [], Rn(B, Z), M.add(B), u.push('<script src="', k(H), '"'), typeof fn == "string" && u.push(
          ' integrity="',
          k(fn),
          '"'
        ), typeof tn == "string" && u.push(
          ' crossorigin="',
          k(tn),
          '"'
        ), it(u, l), u.push(' async=""><\/script>');
      }
    if (s !== void 0)
      for (o = 0; o < s.length; o++)
        Z = s[o], tn = H = void 0, fn = {
          rel: "modulepreload",
          fetchPriority: "low",
          nonce: void 0
        }, typeof Z == "string" ? fn.href = D = Z : (fn.href = D = Z.src, fn.integrity = tn = typeof Z.integrity == "string" ? Z.integrity : void 0, fn.crossOrigin = H = typeof Z == "string" || Z.crossOrigin == null ? void 0 : Z.crossOrigin === "use-credentials" ? "use-credentials" : ""), Z = l, B = D, Z.scriptResources[B] = null, Z.moduleScriptResources[B] = null, Z = [], Rn(Z, fn), M.add(Z), u.push(
          '<script type="module" src="',
          k(D),
          '"'
        ), typeof tn == "string" && u.push(
          ' integrity="',
          k(tn),
          '"'
        ), typeof H == "string" && u.push(
          ' crossorigin="',
          k(H),
          '"'
        ), it(u, l), u.push(' async=""><\/script>');
    return {
      placeholderPrefix: f,
      segmentPrefix: E,
      boundaryPrefix: i,
      startInlineScript: "<script",
      startInlineStyle: "<style",
      preamble: { htmlChunks: null, headChunks: null, bodyChunks: null },
      externalRuntimeScript: null,
      bootstrapChunks: u,
      importMapChunks: [],
      onHeaders: void 0,
      headers: null,
      resets: {
        font: {},
        dns: {},
        connect: { default: {}, anonymous: {}, credentials: {} },
        image: {},
        style: {}
      },
      charsetChunks: [],
      viewportChunks: [],
      hoistableChunks: [],
      preconnects: v,
      fontPreloads: x,
      highImagePreloads: A,
      styles: S,
      bootstrapScripts: M,
      scripts: O,
      bulkPreloads: G,
      preloads: z,
      nonce: { script: void 0, style: void 0 },
      stylesToHoist: !1,
      generateStaticMarkup: t
    };
  }
  function lr(l, t, i, u) {
    return i.generateStaticMarkup ? (l.push(k(t)), !1) : (t === "" ? l = u : (u && l.push("<!-- -->"), l.push(k(t)), l = !0), l);
  }
  function zl(l, t, i, u) {
    t.generateStaticMarkup || i && u && l.push("<!-- -->");
  }
  var ii = Function.prototype.bind, cu = Symbol.for("react.client.reference");
  function ct(l) {
    if (l == null) return null;
    if (typeof l == "function")
      return l.$$typeof === cu ? null : l.displayName || l.name || null;
    if (typeof l == "string") return l;
    switch (l) {
      case Yt:
        return "Fragment";
      case Wr:
        return "Profiler";
      case Hr:
        return "StrictMode";
      case le:
        return "Suspense";
      case nt:
        return "SuspenseList";
      case Gr:
        return "Activity";
    }
    if (typeof l == "object")
      switch (l.$$typeof) {
        case je:
          return "Portal";
        case ne:
          return l.displayName || "Context";
        case Ur:
          return (l._context.displayName || "Context") + ".Consumer";
        case $e:
          var t = l.render;
          return l = l.displayName, l || (l = t.displayName || t.name || "", l = l !== "" ? "ForwardRef(" + l + ")" : "ForwardRef"), l;
        case lt:
          return t = l.displayName || null, t !== null ? t : ct(l.type) || "Memo";
        case ee:
          t = l._payload, l = l._init;
          try {
            return ct(l(t));
          } catch {
          }
      }
    return null;
  }
  var sn = {}, ae = null;
  function er(l, t) {
    if (l !== t) {
      l.context._currentValue2 = l.parentValue, l = l.parent;
      var i = t.parent;
      if (l === null) {
        if (i !== null) throw Error(R(401));
      } else {
        if (i === null) throw Error(R(401));
        er(l, i);
      }
      t.context._currentValue2 = t.value;
    }
  }
  function ai(l) {
    l.context._currentValue2 = l.parentValue, l = l.parent, l !== null && ai(l);
  }
  function Dl(l) {
    var t = l.parent;
    t !== null && Dl(t), l.context._currentValue2 = l.value;
  }
  function ui(l, t) {
    if (l.context._currentValue2 = l.parentValue, l = l.parent, l === null) throw Error(R(402));
    l.depth === t.depth ? er(l, t) : ui(l, t);
  }
  function ci(l, t) {
    var i = t.parent;
    if (i === null) throw Error(R(402));
    l.depth === i.depth ? er(l, i) : ci(l, i), t.context._currentValue2 = t.value;
  }
  function Hl(l) {
    var t = ae;
    t !== l && (t === null ? Dl(l) : l === null ? ai(t) : t.depth === l.depth ? er(t, l) : t.depth > l.depth ? ui(t, l) : ci(t, l), ae = l);
  }
  var xa = {
    enqueueSetState: function(l, t) {
      l = l._reactInternals, l.queue !== null && l.queue.push(t);
    },
    enqueueReplaceState: function(l, t) {
      l = l._reactInternals, l.replace = !0, l.queue = [t];
    },
    enqueueForceUpdate: function() {
    }
  }, fu = { id: 1, overflow: "" };
  function ue(l, t, i) {
    var u = l.id;
    l = l.overflow;
    var f = 32 - tr(u) - 1;
    u &= ~(1 << f), i += 1;
    var o = 32 - tr(t) + f;
    if (30 < o) {
      var s = f - f % 5;
      return o = (u & (1 << s) - 1).toString(32), u >>= s, f -= s, {
        id: 1 << 32 - tr(t) + f | i << f | u,
        overflow: o + l
      };
    }
    return {
      id: 1 << o | i << f | u,
      overflow: l
    };
  }
  var tr = Math.clz32 ? Math.clz32 : du, hu = Math.log, ou = Math.LN2;
  function du(l) {
    return l >>>= 0, l === 0 ? 32 : 31 - (hu(l) / ou | 0) | 0;
  }
  function Nn() {
  }
  var qn = Error(R(460));
  function su(l, t, i) {
    switch (i = l[i], i === void 0 ? l.push(t) : i !== t && (t.then(Nn, Nn), t = i), t.status) {
      case "fulfilled":
        return t.value;
      case "rejected":
        throw t.reason;
      default:
        switch (typeof t.status == "string" ? t.then(Nn, Nn) : (l = t, l.status = "pending", l.then(
          function(u) {
            if (t.status === "pending") {
              var f = t;
              f.status = "fulfilled", f.value = u;
            }
          },
          function(u) {
            if (t.status === "pending") {
              var f = t;
              f.status = "rejected", f.reason = u;
            }
          }
        )), t.status) {
          case "fulfilled":
            return t.value;
          case "rejected":
            throw t.reason;
        }
        throw rr = t, qn;
    }
  }
  var rr = null;
  function ir() {
    if (rr === null) throw Error(R(459));
    var l = rr;
    return rr = null, l;
  }
  function gu(l, t) {
    return l === t && (l !== 0 || 1 / l === 1 / t) || l !== l && t !== t;
  }
  var wa = typeof Object.is == "function" ? Object.is : gu, El = null, fi = null, hi = null, oi = null, ar = null, j = null, ft = !1, ur = !1, ht = 0, ot = 0, dt = -1, cr = 0, ke = null, Wl = null, fr = 0;
  function xl() {
    if (El === null)
      throw Error(R(321));
    return El;
  }
  function Ra() {
    if (0 < fr) throw Error(R(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function di() {
    return j === null ? ar === null ? (ft = !1, ar = j = Ra()) : (ft = !0, j = ar) : j.next === null ? (ft = !1, j = j.next = Ra()) : (ft = !0, j = j.next), j;
  }
  function Oe() {
    var l = ke;
    return ke = null, l;
  }
  function st() {
    oi = hi = fi = El = null, ur = !1, ar = null, fr = 0, j = Wl = null;
  }
  function Ca(l, t) {
    return typeof t == "function" ? t(l) : t;
  }
  function Fa(l, t, i) {
    if (El = xl(), j = di(), ft) {
      var u = j.queue;
      if (t = u.dispatch, Wl !== null && (i = Wl.get(u), i !== void 0)) {
        Wl.delete(u), u = j.memoizedState;
        do
          u = l(u, i.action), i = i.next;
        while (i !== null);
        return j.memoizedState = u, [u, t];
      }
      return [j.memoizedState, t];
    }
    return l = l === Ca ? typeof t == "function" ? t() : t : i !== void 0 ? i(t) : t, j.memoizedState = l, l = j.queue = { last: null, dispatch: null }, l = l.dispatch = vu.bind(
      null,
      El,
      l
    ), [j.memoizedState, l];
  }
  function Sa(l, t) {
    if (El = xl(), j = di(), t = t === void 0 ? null : t, j !== null) {
      var i = j.memoizedState;
      if (i !== null && t !== null) {
        var u = i[1];
        n: if (u === null) u = !1;
        else {
          for (var f = 0; f < u.length && f < t.length; f++)
            if (!wa(t[f], u[f])) {
              u = !1;
              break n;
            }
          u = !0;
        }
        if (u) return i[0];
      }
    }
    return l = l(), j.memoizedState = [l, t], l;
  }
  function vu(l, t, i) {
    if (25 <= fr) throw Error(R(301));
    if (l === El)
      if (ur = !0, l = { action: i, next: null }, Wl === null && (Wl = /* @__PURE__ */ new Map()), i = Wl.get(t), i === void 0)
        Wl.set(t, l);
      else {
        for (t = i; t.next !== null; ) t = t.next;
        t.next = l;
      }
  }
  function bu() {
    throw Error(R(440));
  }
  function yu() {
    throw Error(R(394));
  }
  function Tu() {
    throw Error(R(479));
  }
  function si(l, t, i) {
    xl();
    var u = ot++, f = hi;
    if (typeof l.$$FORM_ACTION == "function") {
      var o = null, s = oi;
      f = f.formState;
      var E = l.$$IS_SIGNATURE_EQUAL;
      if (f !== null && typeof E == "function") {
        var v = f[1];
        E.call(l, f[2], f[3]) && (o = i !== void 0 ? "p" + i : "k" + Zr(
          JSON.stringify([s, null, u]),
          0
        ), v === o && (dt = u, t = f[0]));
      }
      var x = l.bind(null, t);
      return l = function(S) {
        x(S);
      }, typeof x.$$FORM_ACTION == "function" && (l.$$FORM_ACTION = function(S) {
        S = x.$$FORM_ACTION(S), i !== void 0 && (i += "", S.action = i);
        var M = S.data;
        return M && (o === null && (o = i !== void 0 ? "p" + i : "k" + Zr(
          JSON.stringify([
            s,
            null,
            u
          ]),
          0
        )), M.append("$ACTION_KEY", o)), S;
      }), [t, l, !1];
    }
    var A = l.bind(null, t);
    return [
      t,
      function(S) {
        A(S);
      },
      !1
    ];
  }
  function Aa(l) {
    var t = cr;
    return cr += 1, ke === null && (ke = []), su(ke, l, t);
  }
  function Eu() {
    throw Error(R(393));
  }
  var Pa = {
    readContext: function(l) {
      return l._currentValue2;
    },
    use: function(l) {
      if (l !== null && typeof l == "object") {
        if (typeof l.then == "function") return Aa(l);
        if (l.$$typeof === ne)
          return l._currentValue2;
      }
      throw Error(R(438, String(l)));
    },
    useContext: function(l) {
      return xl(), l._currentValue2;
    },
    useMemo: Sa,
    useReducer: Fa,
    useRef: function(l) {
      El = xl(), j = di();
      var t = j.memoizedState;
      return t === null ? (l = { current: l }, j.memoizedState = l) : t;
    },
    useState: function(l) {
      return Fa(Ca, l);
    },
    useInsertionEffect: Nn,
    useLayoutEffect: Nn,
    useCallback: function(l, t) {
      return Sa(function() {
        return l;
      }, t);
    },
    useImperativeHandle: Nn,
    useEffect: Nn,
    useDebugValue: Nn,
    useDeferredValue: function(l, t) {
      return xl(), t !== void 0 ? t : l;
    },
    useTransition: function() {
      return xl(), [!1, yu];
    },
    useId: function() {
      var l = fi.treeContext, t = l.overflow;
      l = l.id, l = (l & ~(1 << 32 - tr(l) - 1)).toString(32) + t;
      var i = hr;
      if (i === null) throw Error(R(404));
      return t = ht++, l = "_" + i.idPrefix + "R_" + l, 0 < t && (l += "H" + t.toString(32)), l + "_";
    },
    useSyncExternalStore: function(l, t, i) {
      if (i === void 0)
        throw Error(R(407));
      return i();
    },
    useOptimistic: function(l) {
      return xl(), [l, Tu];
    },
    useActionState: si,
    useFormState: si,
    useHostTransitionStatus: function() {
      return xl(), Un;
    },
    useMemoCache: function(l) {
      for (var t = Array(l), i = 0; i < l; i++)
        t[i] = $a;
      return t;
    },
    useCacheRefresh: function() {
      return Eu;
    },
    useEffectEvent: function() {
      return bu;
    }
  }, hr = null, xu = {
    getCacheForType: function() {
      throw Error(R(248));
    },
    cacheSignal: function() {
      throw Error(R(248));
    }
  }, gi, Ma;
  function Le(l) {
    if (gi === void 0)
      try {
        throw Error();
      } catch (i) {
        var t = i.stack.trim().match(/\n( *(at )?)/);
        gi = t && t[1] || "", Ma = -1 < i.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < i.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + gi + l + Ma;
  }
  var vi = !1;
  function or(l, t) {
    if (!l || vi) return "";
    vi = !0;
    var i = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var u = {
        DetermineComponentFrameRoot: function() {
          try {
            if (t) {
              var S = function() {
                throw Error();
              };
              if (Object.defineProperty(S.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(S, []);
                } catch (O) {
                  var M = O;
                }
                Reflect.construct(l, [], S);
              } else {
                try {
                  S.call();
                } catch (O) {
                  M = O;
                }
                l.call(S.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (O) {
                M = O;
              }
              (S = l()) && typeof S.catch == "function" && S.catch(function() {
              });
            }
          } catch (O) {
            if (O && M && typeof O.stack == "string")
              return [O.stack, M.stack];
          }
          return [null, null];
        }
      };
      u.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var f = Object.getOwnPropertyDescriptor(
        u.DetermineComponentFrameRoot,
        "name"
      );
      f && f.configurable && Object.defineProperty(
        u.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var o = u.DetermineComponentFrameRoot(), s = o[0], E = o[1];
      if (s && E) {
        var v = s.split(`
`), x = E.split(`
`);
        for (f = u = 0; u < v.length && !v[u].includes("DetermineComponentFrameRoot"); )
          u++;
        for (; f < x.length && !x[f].includes(
          "DetermineComponentFrameRoot"
        ); )
          f++;
        if (u === v.length || f === x.length)
          for (u = v.length - 1, f = x.length - 1; 1 <= u && 0 <= f && v[u] !== x[f]; )
            f--;
        for (; 1 <= u && 0 <= f; u--, f--)
          if (v[u] !== x[f]) {
            if (u !== 1 || f !== 1)
              do
                if (u--, f--, 0 > f || v[u] !== x[f]) {
                  var A = `
` + v[u].replace(" at new ", " at ");
                  return l.displayName && A.includes("<anonymous>") && (A = A.replace("<anonymous>", l.displayName)), A;
                }
              while (1 <= u && 0 <= f);
            break;
          }
      }
    } finally {
      vi = !1, Error.prepareStackTrace = i;
    }
    return (i = l ? l.displayName || l.name : "") ? Le(i) : "";
  }
  function Ia(l) {
    if (typeof l == "string") return Le(l);
    if (typeof l == "function")
      return l.prototype && l.prototype.isReactComponent ? or(l, !0) : or(l, !1);
    if (typeof l == "object" && l !== null) {
      switch (l.$$typeof) {
        case $e:
          return or(l.render, !1);
        case lt:
          return or(l.type, !1);
        case ee:
          var t = l, i = t._payload;
          t = t._init;
          try {
            l = t(i);
          } catch {
            return Le("Lazy");
          }
          return Ia(l);
      }
      if (typeof l.name == "string") {
        n: {
          i = l.name, t = l.env;
          var u = l.debugLocation;
          if (u != null && (l = Error.prepareStackTrace, Error.prepareStackTrace = void 0, u = u.stack, Error.prepareStackTrace = l, u.startsWith(`Error: react-stack-top-frame
`) && (u = u.slice(29)), l = u.indexOf(`
`), l !== -1 && (u = u.slice(l + 1)), l = u.indexOf("react_stack_bottom_frame"), l !== -1 && (l = u.lastIndexOf(`
`, l)), l = l !== -1 ? u = u.slice(0, l) : "", u = l.lastIndexOf(`
`), l = u === -1 ? l : l.slice(u + 1), l.indexOf(i) !== -1)) {
            i = `
` + l;
            break n;
          }
          i = Le(
            i + (t ? " [" + t + "]" : "")
          );
        }
        return i;
      }
    }
    switch (l) {
      case nt:
        return Le("SuspenseList");
      case le:
        return Le("Suspense");
    }
    return "";
  }
  function Be(l, t) {
    return (500 < t.byteSize || !1) && t.contentPreamble === null;
  }
  function wu(l) {
    if (typeof l == "object" && l !== null && typeof l.environmentName == "string") {
      var t = l.environmentName;
      l = [l].slice(0), typeof l[0] == "string" ? l.splice(
        0,
        1,
        "[%s] " + l[0],
        " " + t + " "
      ) : l.splice(0, 0, "[%s]", " " + t + " "), l.unshift(console), t = ii.apply(console.error, l), t();
    } else console.error(l);
    return null;
  }
  function Ru(l, t, i, u, f, o, s, E, v, x, A) {
    var S = /* @__PURE__ */ new Set();
    this.destination = null, this.flushScheduled = !1, this.resumableState = l, this.renderState = t, this.rootFormatContext = i, this.progressiveChunkSize = u === void 0 ? 12800 : u, this.status = 10, this.fatalError = null, this.pendingRootTasks = this.allPendingTasks = this.nextSegmentId = 0, this.completedPreambleSegments = this.completedRootSegment = null, this.byteSize = 0, this.abortableTasks = S, this.pingedTasks = [], this.clientRenderedBoundaries = [], this.completedBoundaries = [], this.partialBoundaries = [], this.trackedPostpones = null, this.onError = f === void 0 ? wu : f, this.onPostpone = x === void 0 ? Nn : x, this.onAllReady = o === void 0 ? Nn : o, this.onShellReady = s === void 0 ? Nn : s, this.onShellError = E === void 0 ? Nn : E, this.onFatalError = v === void 0 ? Nn : v, this.formState = A === void 0 ? null : A;
  }
  function Cu(l, t, i, u, f, o, s, E, v, x, A, S) {
    return t = new Ru(
      t,
      i,
      u,
      f,
      o,
      s,
      E,
      v,
      x,
      A,
      S
    ), i = ce(
      t,
      0,
      null,
      u,
      !1,
      !1
    ), i.parentFlushed = !0, l = dr(
      t,
      null,
      l,
      -1,
      null,
      i,
      null,
      null,
      t.abortableTasks,
      null,
      u,
      null,
      fu,
      null,
      null
    ), Ul(l), t.pingedTasks.push(l), t;
  }
  var Sn = null;
  function Ne(l, t) {
    l.pingedTasks.push(t), l.pingedTasks.length === 1 && (l.flushScheduled = l.destination !== null, La(l));
  }
  function bi(l, t, i, u, f) {
    return i = {
      status: 0,
      rootSegmentID: -1,
      parentFlushed: !1,
      pendingTasks: 0,
      row: t,
      completedSegments: [],
      byteSize: 0,
      fallbackAbortableTasks: i,
      errorDigest: null,
      contentState: ln(),
      fallbackState: ln(),
      contentPreamble: u,
      fallbackPreamble: f,
      trackedContentKeyPath: null,
      trackedFallbackNode: null
    }, t !== null && (t.pendingTasks++, u = t.boundaries, u !== null && (l.allPendingTasks++, i.pendingTasks++, u.push(i)), l = t.inheritedHoistables, l !== null && _e(i.contentState, l)), i;
  }
  function dr(l, t, i, u, f, o, s, E, v, x, A, S, M, O, G) {
    l.allPendingTasks++, f === null ? l.pendingRootTasks++ : f.pendingTasks++, O !== null && O.pendingTasks++;
    var z = {
      replay: null,
      node: i,
      childIndex: u,
      ping: function() {
        return Ne(l, z);
      },
      blockedBoundary: f,
      blockedSegment: o,
      blockedPreamble: s,
      hoistableState: E,
      abortSet: v,
      keyPath: x,
      formatContext: A,
      context: S,
      treeContext: M,
      row: O,
      componentStack: G,
      thenableState: t
    };
    return v.add(z), z;
  }
  function _a(l, t, i, u, f, o, s, E, v, x, A, S, M, O) {
    l.allPendingTasks++, o === null ? l.pendingRootTasks++ : o.pendingTasks++, M !== null && M.pendingTasks++, i.pendingTasks++;
    var G = {
      replay: i,
      node: u,
      childIndex: f,
      ping: function() {
        return Ne(l, G);
      },
      blockedBoundary: o,
      blockedSegment: null,
      blockedPreamble: null,
      hoistableState: s,
      abortSet: E,
      keyPath: v,
      formatContext: x,
      context: A,
      treeContext: S,
      row: M,
      componentStack: O,
      thenableState: t
    };
    return E.add(G), G;
  }
  function ce(l, t, i, u, f, o) {
    return {
      status: 0,
      parentFlushed: !1,
      id: -1,
      index: t,
      chunks: [],
      children: [],
      preambleChildren: [],
      parentFormatContext: u,
      boundary: i,
      lastPushedText: f,
      textEmbedded: o
    };
  }
  function Ul(l) {
    var t = l.node;
    if (typeof t == "object" && t !== null)
      switch (t.$$typeof) {
        case $l:
          l.componentStack = { parent: l.componentStack, type: t.type };
      }
  }
  function gt(l) {
    return l === null ? null : { parent: l.parent, type: "Suspense Fallback" };
  }
  function Gl(l) {
    var t = {};
    return l && Object.defineProperty(t, "componentStack", {
      configurable: !0,
      enumerable: !0,
      get: function() {
        try {
          var i = "", u = l;
          do
            i += Ia(u.type), u = u.parent;
          while (u);
          var f = i;
        } catch (o) {
          f = `
Error generating stack: ` + o.message + `
` + o.stack;
        }
        return Object.defineProperty(t, "componentStack", {
          value: f
        }), f;
      }
    }), t;
  }
  function _n(l, t, i) {
    if (l = l.onError, t = l(t, i), t == null || typeof t == "string") return t;
  }
  function ze(l, t) {
    var i = l.onShellError, u = l.onFatalError;
    i(t), u(t), l.destination !== null ? (l.status = 14, l.destination.destroy(t)) : (l.status = 13, l.fatalError = t);
  }
  function $(l, t) {
    gl(l, t.next, t.hoistables);
  }
  function gl(l, t, i) {
    for (; t !== null; ) {
      i !== null && (_e(t.hoistables, i), t.inheritedHoistables = i);
      var u = t.boundaries;
      if (u !== null) {
        t.boundaries = null;
        for (var f = 0; f < u.length; f++) {
          var o = u[f];
          i !== null && _e(o.contentState, i), Yl(l, o, null, null);
        }
      }
      if (t.pendingTasks--, 0 < t.pendingTasks) break;
      i = t.hoistables, t = t.next;
    }
  }
  function yi(l, t) {
    var i = t.boundaries;
    if (i !== null && t.pendingTasks === i.length) {
      for (var u = !0, f = 0; f < i.length; f++) {
        var o = i[f];
        if (o.pendingTasks !== 1 || o.parentFlushed || Be(l, o)) {
          u = !1;
          break;
        }
      }
      u && gl(l, t, t.hoistables);
    }
  }
  function vt(l) {
    var t = {
      pendingTasks: 1,
      boundaries: null,
      hoistables: ln(),
      inheritedHoistables: null,
      together: !1,
      next: null
    };
    return l !== null && 0 < l.pendingTasks && (t.pendingTasks++, t.boundaries = [], l.next = t), t;
  }
  function ka(l, t, i, u, f) {
    var o = t.keyPath, s = t.treeContext, E = t.row;
    t.keyPath = i, i = u.length;
    var v = null;
    if (t.replay !== null) {
      var x = t.replay.slots;
      if (x !== null && typeof x == "object")
        for (var A = 0; A < i; A++) {
          var S = f !== "backwards" && f !== "unstable_legacy-backwards" ? A : i - 1 - A, M = u[S];
          t.row = v = vt(
            v
          ), t.treeContext = ue(s, i, S);
          var O = x[S];
          typeof O == "number" ? (gr(l, t, O, M, S), delete x[S]) : Tn(l, t, M, S), --v.pendingTasks === 0 && $(l, v);
        }
      else
        for (x = 0; x < i; x++)
          A = f !== "backwards" && f !== "unstable_legacy-backwards" ? x : i - 1 - x, S = u[A], t.row = v = vt(v), t.treeContext = ue(s, i, A), Tn(l, t, S, A), --v.pendingTasks === 0 && $(l, v);
    } else if (f !== "backwards" && f !== "unstable_legacy-backwards")
      for (f = 0; f < i; f++)
        x = u[f], t.row = v = vt(v), t.treeContext = ue(
          s,
          i,
          f
        ), Tn(l, t, x, f), --v.pendingTasks === 0 && $(l, v);
    else {
      for (f = t.blockedSegment, x = f.children.length, A = f.chunks.length, S = i - 1; 0 <= S; S--) {
        M = u[S], t.row = v = vt(
          v
        ), t.treeContext = ue(s, i, S), O = ce(
          l,
          A,
          null,
          t.formatContext,
          S === 0 ? f.lastPushedText : !0,
          !0
        ), f.children.splice(x, 0, O), t.blockedSegment = O;
        try {
          Tn(l, t, M, S), zl(
            O.chunks,
            l.renderState,
            O.lastPushedText,
            O.textEmbedded
          ), O.status = 1, --v.pendingTasks === 0 && $(l, v);
        } catch (G) {
          throw O.status = l.status === 12 ? 3 : 4, G;
        }
      }
      t.blockedSegment = f, f.lastPushedText = !1;
    }
    E !== null && v !== null && 0 < v.pendingTasks && (E.pendingTasks++, v.next = E), t.treeContext = s, t.row = E, t.keyPath = o;
  }
  function Ti(l, t, i, u, f, o) {
    var s = t.thenableState;
    for (t.thenableState = null, El = {}, fi = t, hi = l, oi = i, ot = ht = 0, dt = -1, cr = 0, ke = s, l = u(f, o); ur; )
      ur = !1, ot = ht = 0, dt = -1, cr = 0, fr += 1, j = null, l = u(f, o);
    return st(), l;
  }
  function Oa(l, t, i, u, f, o, s) {
    var E = !1;
    if (o !== 0 && l.formState !== null) {
      var v = t.blockedSegment;
      if (v !== null) {
        E = !0, v = v.chunks;
        for (var x = 0; x < o; x++)
          x === s ? v.push("<!--F!-->") : v.push("<!--F-->");
      }
    }
    o = t.keyPath, t.keyPath = i, f ? (i = t.treeContext, t.treeContext = ue(i, 1, 0), Tn(l, t, u, -1), t.treeContext = i) : E ? Tn(l, t, u, -1) : el(l, t, u, -1), t.keyPath = o;
  }
  function sr(l, t, i, u, f, o) {
    if (typeof u == "function")
      if (u.prototype && u.prototype.isReactComponent) {
        var s = f;
        if ("ref" in f) {
          s = {};
          for (var E in f)
            E !== "ref" && (s[E] = f[E]);
        }
        var v = u.defaultProps;
        if (v) {
          s === f && (s = Bn({}, s, f));
          for (var x in v)
            s[x] === void 0 && (s[x] = v[x]);
        }
        f = s, s = sn, v = u.contextType, typeof v == "object" && v !== null && (s = v._currentValue2), s = new u(f, s);
        var A = s.state !== void 0 ? s.state : null;
        if (s.updater = xa, s.props = f, s.state = A, v = { queue: [], replace: !1 }, s._reactInternals = v, o = u.contextType, s.context = typeof o == "object" && o !== null ? o._currentValue2 : sn, o = u.getDerivedStateFromProps, typeof o == "function" && (o = o(f, A), A = o == null ? A : Bn({}, A, o), s.state = A), typeof u.getDerivedStateFromProps != "function" && typeof s.getSnapshotBeforeUpdate != "function" && (typeof s.UNSAFE_componentWillMount == "function" || typeof s.componentWillMount == "function"))
          if (u = s.state, typeof s.componentWillMount == "function" && s.componentWillMount(), typeof s.UNSAFE_componentWillMount == "function" && s.UNSAFE_componentWillMount(), u !== s.state && xa.enqueueReplaceState(
            s,
            s.state,
            null
          ), v.queue !== null && 0 < v.queue.length)
            if (u = v.queue, o = v.replace, v.queue = null, v.replace = !1, o && u.length === 1)
              s.state = u[0];
            else {
              for (v = o ? u[0] : s.state, A = !0, o = o ? 1 : 0; o < u.length; o++)
                x = u[o], x = typeof x == "function" ? x.call(s, v, f, void 0) : x, x != null && (A ? (A = !1, v = Bn({}, v, x)) : Bn(v, x));
              s.state = v;
            }
          else v.queue = null;
        if (u = s.render(), l.status === 12) throw null;
        f = t.keyPath, t.keyPath = i, el(l, t, u, -1), t.keyPath = f;
      } else {
        if (u = Ti(l, t, i, u, f, void 0), l.status === 12) throw null;
        Oa(
          l,
          t,
          i,
          u,
          ht !== 0,
          ot,
          dt
        );
      }
    else if (typeof u == "string")
      if (s = t.blockedSegment, s === null)
        s = f.children, v = t.formatContext, A = t.keyPath, t.formatContext = ua(v, u, f), t.keyPath = i, Tn(l, t, s, -1), t.formatContext = v, t.keyPath = A;
      else {
        if (A = Cn(
          s.chunks,
          u,
          f,
          l.resumableState,
          l.renderState,
          t.blockedPreamble,
          t.hoistableState,
          t.formatContext,
          s.lastPushedText
        ), s.lastPushedText = !1, v = t.formatContext, o = t.keyPath, t.keyPath = i, (t.formatContext = ua(v, u, f)).insertionMode === 3) {
          i = ce(
            l,
            0,
            null,
            t.formatContext,
            !1,
            !1
          ), s.preambleChildren.push(i), t.blockedSegment = i;
          try {
            i.status = 6, Tn(l, t, A, -1), zl(
              i.chunks,
              l.renderState,
              i.lastPushedText,
              i.textEmbedded
            ), i.status = 1;
          } finally {
            t.blockedSegment = s;
          }
        } else Tn(l, t, A, -1);
        t.formatContext = v, t.keyPath = o;
        n: {
          switch (t = s.chunks, l = l.resumableState, u) {
            case "title":
            case "style":
            case "script":
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
              break n;
            case "body":
              if (1 >= v.insertionMode) {
                l.hasBody = !0;
                break n;
              }
              break;
            case "html":
              if (v.insertionMode === 0) {
                l.hasHtml = !0;
                break n;
              }
              break;
            case "head":
              if (1 >= v.insertionMode) break n;
          }
          t.push(Bl(u));
        }
        s.lastPushedText = !1;
      }
    else {
      switch (u) {
        case ja:
        case Hr:
        case Wr:
        case Yt:
          u = t.keyPath, t.keyPath = i, el(l, t, f.children, -1), t.keyPath = u;
          return;
        case Gr:
          u = t.blockedSegment, u === null ? f.mode !== "hidden" && (u = t.keyPath, t.keyPath = i, Tn(l, t, f.children, -1), t.keyPath = u) : f.mode !== "hidden" && (l.renderState.generateStaticMarkup || u.chunks.push("<!--&-->"), u.lastPushedText = !1, s = t.keyPath, t.keyPath = i, Tn(l, t, f.children, -1), t.keyPath = s, l.renderState.generateStaticMarkup || u.chunks.push("<!--/&-->"), u.lastPushedText = !1);
          return;
        case nt:
          n: {
            if (u = f.children, f = f.revealOrder, f === "forwards" || f === "backwards" || f === "unstable_legacy-backwards") {
              if (te(u)) {
                ka(l, t, i, u, f);
                break n;
              }
              if ((s = Xr(u)) && (s = s.call(u))) {
                if (v = s.next(), !v.done) {
                  do
                    v = s.next();
                  while (!v.done);
                  ka(l, t, i, u, f);
                }
                break n;
              }
            }
            f === "together" ? (f = t.keyPath, s = t.row, v = t.row = vt(null), v.boundaries = [], v.together = !0, t.keyPath = i, el(l, t, u, -1), --v.pendingTasks === 0 && $(l, v), t.keyPath = f, t.row = s, s !== null && 0 < v.pendingTasks && (s.pendingTasks++, v.next = s)) : (f = t.keyPath, t.keyPath = i, el(l, t, u, -1), t.keyPath = f);
          }
          return;
        case nu:
        case pa:
          throw Error(R(343));
        case le:
          n: if (t.replay !== null) {
            u = t.keyPath, s = t.formatContext, v = t.row, t.keyPath = i, t.formatContext = Jt(
              l.resumableState,
              s
            ), t.row = null, i = f.children;
            try {
              Tn(l, t, i, -1);
            } finally {
              t.keyPath = u, t.formatContext = s, t.row = v;
            }
          } else {
            u = t.keyPath, o = t.formatContext;
            var S = t.row, M = t.blockedBoundary;
            x = t.blockedPreamble;
            var O = t.hoistableState;
            E = t.blockedSegment;
            var G = f.fallback;
            f = f.children;
            var z = /* @__PURE__ */ new Set(), D = bi(
              l,
              t.row,
              z,
              null,
              null
            );
            l.trackedPostpones !== null && (D.trackedContentKeyPath = i);
            var B = ce(
              l,
              E.chunks.length,
              D,
              t.formatContext,
              !1,
              !1
            );
            E.children.push(B), E.lastPushedText = !1;
            var H = ce(
              l,
              0,
              null,
              t.formatContext,
              !1,
              !1
            );
            if (H.parentFlushed = !0, l.trackedPostpones !== null) {
              s = t.componentStack, v = [i[0], "Suspense Fallback", i[2]], A = [v[1], v[2], [], null], l.trackedPostpones.workingMap.set(v, A), D.trackedFallbackNode = A, t.blockedSegment = B, t.blockedPreamble = D.fallbackPreamble, t.keyPath = v, t.formatContext = mr(
                l.resumableState,
                o
              ), t.componentStack = gt(s), B.status = 6;
              try {
                Tn(l, t, G, -1), zl(
                  B.chunks,
                  l.renderState,
                  B.lastPushedText,
                  B.textEmbedded
                ), B.status = 1;
              } catch (tn) {
                throw B.status = l.status === 12 ? 3 : 4, tn;
              } finally {
                t.blockedSegment = E, t.blockedPreamble = x, t.keyPath = u, t.formatContext = o;
              }
              t = dr(
                l,
                null,
                f,
                -1,
                D,
                H,
                D.contentPreamble,
                D.contentState,
                t.abortSet,
                i,
                Jt(
                  l.resumableState,
                  t.formatContext
                ),
                t.context,
                t.treeContext,
                null,
                s
              ), Ul(t), l.pingedTasks.push(t);
            } else {
              t.blockedBoundary = D, t.blockedPreamble = D.contentPreamble, t.hoistableState = D.contentState, t.blockedSegment = H, t.keyPath = i, t.formatContext = Jt(
                l.resumableState,
                o
              ), t.row = null, H.status = 6;
              try {
                if (Tn(l, t, f, -1), zl(
                  H.chunks,
                  l.renderState,
                  H.lastPushedText,
                  H.textEmbedded
                ), H.status = 1, yt(D, H), D.pendingTasks === 0 && D.status === 0) {
                  if (D.status = 1, !Be(l, D)) {
                    S !== null && --S.pendingTasks === 0 && $(l, S), l.pendingRootTasks === 0 && t.blockedPreamble && oe(l);
                    break n;
                  }
                } else
                  S !== null && S.together && yi(l, S);
              } catch (tn) {
                D.status = 4, l.status === 12 ? (H.status = 3, s = l.fatalError) : (H.status = 4, s = tn), v = Gl(t.componentStack), A = _n(
                  l,
                  s,
                  v
                ), D.errorDigest = A, yr(l, D);
              } finally {
                t.blockedBoundary = M, t.blockedPreamble = x, t.hoistableState = O, t.blockedSegment = E, t.keyPath = u, t.formatContext = o, t.row = S;
              }
              t = dr(
                l,
                null,
                G,
                -1,
                M,
                B,
                D.fallbackPreamble,
                D.fallbackState,
                z,
                [i[0], "Suspense Fallback", i[2]],
                mr(
                  l.resumableState,
                  t.formatContext
                ),
                t.context,
                t.treeContext,
                t.row,
                gt(
                  t.componentStack
                )
              ), Ul(t), l.pingedTasks.push(t);
            }
          }
          return;
      }
      if (typeof u == "object" && u !== null)
        switch (u.$$typeof) {
          case $e:
            if ("ref" in f)
              for (G in s = {}, f)
                G !== "ref" && (s[G] = f[G]);
            else s = f;
            u = Ti(
              l,
              t,
              i,
              u.render,
              s,
              o
            ), Oa(
              l,
              t,
              i,
              u,
              ht !== 0,
              ot,
              dt
            );
            return;
          case lt:
            sr(l, t, i, u.type, f, o);
            return;
          case ne:
            if (v = f.children, s = t.keyPath, f = f.value, A = u._currentValue2, u._currentValue2 = f, o = ae, ae = u = {
              parent: o,
              depth: o === null ? 0 : o.depth + 1,
              context: u,
              parentValue: A,
              value: f
            }, t.context = u, t.keyPath = i, el(l, t, v, -1), l = ae, l === null) throw Error(R(403));
            l.context._currentValue2 = l.parentValue, l = ae = l.parent, t.context = l, t.keyPath = s;
            return;
          case Ur:
            f = f.children, u = f(u._context._currentValue2), f = t.keyPath, t.keyPath = i, el(l, t, u, -1), t.keyPath = f;
            return;
          case ee:
            if (s = u._init, u = s(u._payload), l.status === 12) throw null;
            sr(l, t, i, u, f, o);
            return;
        }
      throw Error(
        R(130, u == null ? u : typeof u, "")
      );
    }
  }
  function gr(l, t, i, u, f) {
    var o = t.replay, s = t.blockedBoundary, E = ce(
      l,
      0,
      null,
      t.formatContext,
      !1,
      !1
    );
    E.id = i, E.parentFlushed = !0;
    try {
      t.replay = null, t.blockedSegment = E, Tn(l, t, u, f), E.status = 1, s === null ? l.completedRootSegment = E : (yt(s, E), s.parentFlushed && l.partialBoundaries.push(s));
    } finally {
      t.replay = o, t.blockedSegment = null;
    }
  }
  function el(l, t, i, u) {
    t.replay !== null && typeof t.replay.slots == "number" ? gr(l, t, t.replay.slots, i, u) : (t.node = i, t.childIndex = u, i = t.componentStack, Ul(t), Ei(l, t), t.componentStack = i);
  }
  function Ei(l, t) {
    var i = t.node, u = t.childIndex;
    if (i !== null) {
      if (typeof i == "object") {
        switch (i.$$typeof) {
          case $l:
            var f = i.type, o = i.key, s = i.props;
            i = s.ref;
            var E = i !== void 0 ? i : null, v = ct(f), x = o ?? (u === -1 ? 0 : u);
            if (o = [t.keyPath, v, x], t.replay !== null)
              n: {
                var A = t.replay;
                for (u = A.nodes, i = 0; i < u.length; i++) {
                  var S = u[i];
                  if (x === S[1]) {
                    if (S.length === 4) {
                      if (v !== null && v !== S[0])
                        throw Error(
                          R(490, S[0], v)
                        );
                      var M = S[2];
                      v = S[3], x = t.node, t.replay = {
                        nodes: M,
                        slots: v,
                        pendingTasks: 1
                      };
                      try {
                        if (sr(l, t, o, f, s, E), t.replay.pendingTasks === 1 && 0 < t.replay.nodes.length)
                          throw Error(R(488));
                        t.replay.pendingTasks--;
                      } catch (K) {
                        if (typeof K == "object" && K !== null && (K === qn || typeof K.then == "function"))
                          throw t.node === x ? t.replay = A : u.splice(i, 1), K;
                        t.replay.pendingTasks--, s = Gl(t.componentStack), o = l, l = t.blockedBoundary, f = K, s = _n(o, f, s), fe(
                          o,
                          l,
                          M,
                          v,
                          f,
                          s
                        );
                      }
                      t.replay = A;
                    } else {
                      if (f !== le)
                        throw Error(
                          R(
                            490,
                            "Suspense",
                            ct(f) || "Unknown"
                          )
                        );
                      l: {
                        A = void 0, f = S[5], E = S[2], v = S[3], x = S[4] === null ? [] : S[4][2], S = S[4] === null ? null : S[4][3];
                        var O = t.keyPath, G = t.formatContext, z = t.row, D = t.replay, B = t.blockedBoundary, H = t.hoistableState, tn = s.children, fn = s.fallback, Z = /* @__PURE__ */ new Set();
                        s = bi(
                          l,
                          t.row,
                          Z,
                          null,
                          null
                        ), s.parentFlushed = !0, s.rootSegmentID = f, t.blockedBoundary = s, t.hoistableState = s.contentState, t.keyPath = o, t.formatContext = Jt(
                          l.resumableState,
                          G
                        ), t.row = null, t.replay = {
                          nodes: E,
                          slots: v,
                          pendingTasks: 1
                        };
                        try {
                          if (Tn(l, t, tn, -1), t.replay.pendingTasks === 1 && 0 < t.replay.nodes.length)
                            throw Error(R(488));
                          if (t.replay.pendingTasks--, s.pendingTasks === 0 && s.status === 0) {
                            s.status = 1, l.completedBoundaries.push(s);
                            break l;
                          }
                        } catch (K) {
                          s.status = 4, M = Gl(t.componentStack), A = _n(
                            l,
                            K,
                            M
                          ), s.errorDigest = A, t.replay.pendingTasks--, l.clientRenderedBoundaries.push(s);
                        } finally {
                          t.blockedBoundary = B, t.hoistableState = H, t.replay = D, t.keyPath = O, t.formatContext = G, t.row = z;
                        }
                        M = _a(
                          l,
                          null,
                          {
                            nodes: x,
                            slots: S,
                            pendingTasks: 0
                          },
                          fn,
                          -1,
                          B,
                          s.fallbackState,
                          Z,
                          [o[0], "Suspense Fallback", o[2]],
                          mr(
                            l.resumableState,
                            t.formatContext
                          ),
                          t.context,
                          t.treeContext,
                          t.row,
                          gt(
                            t.componentStack
                          )
                        ), Ul(M), l.pingedTasks.push(M);
                      }
                    }
                    u.splice(i, 1);
                    break n;
                  }
                }
              }
            else sr(l, t, o, f, s, E);
            return;
          case je:
            throw Error(R(257));
          case ee:
            if (M = i._init, i = M(i._payload), l.status === 12) throw null;
            el(l, t, i, u);
            return;
        }
        if (te(i)) {
          vr(l, t, i, u);
          return;
        }
        if ((M = Xr(i)) && (M = M.call(i))) {
          if (i = M.next(), !i.done) {
            s = [];
            do
              s.push(i.value), i = M.next();
            while (!i.done);
            vr(l, t, s, u);
          }
          return;
        }
        if (typeof i.then == "function")
          return t.thenableState = null, el(l, t, Aa(i), u);
        if (i.$$typeof === ne)
          return el(
            l,
            t,
            i._currentValue2,
            u
          );
        throw u = Object.prototype.toString.call(i), Error(
          R(
            31,
            u === "[object Object]" ? "object with keys {" + Object.keys(i).join(", ") + "}" : u
          )
        );
      }
      typeof i == "string" ? (u = t.blockedSegment, u !== null && (u.lastPushedText = lr(
        u.chunks,
        i,
        l.renderState,
        u.lastPushedText
      ))) : (typeof i == "number" || typeof i == "bigint") && (u = t.blockedSegment, u !== null && (u.lastPushedText = lr(
        u.chunks,
        "" + i,
        l.renderState,
        u.lastPushedText
      )));
    }
  }
  function vr(l, t, i, u) {
    var f = t.keyPath;
    if (u !== -1 && (t.keyPath = [t.keyPath, "Fragment", u], t.replay !== null)) {
      for (var o = t.replay, s = o.nodes, E = 0; E < s.length; E++) {
        var v = s[E];
        if (v[1] === u) {
          u = v[2], v = v[3], t.replay = { nodes: u, slots: v, pendingTasks: 1 };
          try {
            if (vr(l, t, i, -1), t.replay.pendingTasks === 1 && 0 < t.replay.nodes.length)
              throw Error(R(488));
            t.replay.pendingTasks--;
          } catch (S) {
            if (typeof S == "object" && S !== null && (S === qn || typeof S.then == "function"))
              throw S;
            t.replay.pendingTasks--, i = Gl(t.componentStack);
            var x = t.blockedBoundary, A = S;
            i = _n(l, A, i), fe(
              l,
              x,
              u,
              v,
              A,
              i
            );
          }
          t.replay = o, s.splice(E, 1);
          break;
        }
      }
      t.keyPath = f;
      return;
    }
    if (o = t.treeContext, s = i.length, t.replay !== null && (E = t.replay.slots, E !== null && typeof E == "object")) {
      for (u = 0; u < s; u++)
        v = i[u], t.treeContext = ue(o, s, u), x = E[u], typeof x == "number" ? (gr(l, t, x, v, u), delete E[u]) : Tn(l, t, v, u);
      t.treeContext = o, t.keyPath = f;
      return;
    }
    for (E = 0; E < s; E++)
      u = i[E], t.treeContext = ue(o, s, E), Tn(l, t, u, E);
    t.treeContext = o, t.keyPath = f;
  }
  function bt(l, t, i) {
    if (i.status = 5, i.rootSegmentID = l.nextSegmentId++, l = i.trackedContentKeyPath, l === null) throw Error(R(486));
    var u = i.trackedFallbackNode, f = [], o = t.workingMap.get(l);
    return o === void 0 ? (i = [
      l[1],
      l[2],
      f,
      null,
      u,
      i.rootSegmentID
    ], t.workingMap.set(l, i), vl(i, l[0], t), i) : (o[4] = u, o[5] = i.rootSegmentID, o);
  }
  function br(l, t, i, u) {
    u.status = 5;
    var f = i.keyPath, o = i.blockedBoundary;
    if (o === null)
      u.id = l.nextSegmentId++, t.rootSlots = u.id, l.completedRootSegment !== null && (l.completedRootSegment.status = 5);
    else {
      if (o !== null && o.status === 0) {
        var s = bt(
          l,
          t,
          o
        );
        if (o.trackedContentKeyPath === f && i.childIndex === -1) {
          u.id === -1 && (u.id = u.parentFlushed ? o.rootSegmentID : l.nextSegmentId++), s[3] = u.id;
          return;
        }
      }
      if (u.id === -1 && (u.id = u.parentFlushed && o !== null ? o.rootSegmentID : l.nextSegmentId++), i.childIndex === -1)
        f === null ? t.rootSlots = u.id : (i = t.workingMap.get(f), i === void 0 ? (i = [f[1], f[2], [], u.id], vl(i, f[0], t)) : i[3] = u.id);
      else {
        if (f === null) {
          if (l = t.rootSlots, l === null)
            l = t.rootSlots = {};
          else if (typeof l == "number")
            throw Error(R(491));
        } else if (o = t.workingMap, s = o.get(f), s === void 0)
          l = {}, s = [f[1], f[2], [], l], o.set(f, s), vl(s, f[0], t);
        else if (l = s[3], l === null)
          l = s[3] = {};
        else if (typeof l == "number")
          throw Error(R(491));
        l[i.childIndex] = u.id;
      }
    }
  }
  function yr(l, t) {
    l = l.trackedPostpones, l !== null && (t = t.trackedContentKeyPath, t !== null && (t = l.workingMap.get(t), t !== void 0 && (t.length = 4, t[2] = [], t[3] = null)));
  }
  function Tr(l, t, i) {
    return _a(
      l,
      i,
      t.replay,
      t.node,
      t.childIndex,
      t.blockedBoundary,
      t.hoistableState,
      t.abortSet,
      t.keyPath,
      t.formatContext,
      t.context,
      t.treeContext,
      t.row,
      t.componentStack
    );
  }
  function Er(l, t, i) {
    var u = t.blockedSegment, f = ce(
      l,
      u.chunks.length,
      null,
      t.formatContext,
      u.lastPushedText,
      !0
    );
    return u.children.push(f), u.lastPushedText = !1, dr(
      l,
      i,
      t.node,
      t.childIndex,
      t.blockedBoundary,
      f,
      t.blockedPreamble,
      t.hoistableState,
      t.abortSet,
      t.keyPath,
      t.formatContext,
      t.context,
      t.treeContext,
      t.row,
      t.componentStack
    );
  }
  function Tn(l, t, i, u) {
    var f = t.formatContext, o = t.context, s = t.keyPath, E = t.treeContext, v = t.componentStack, x = t.blockedSegment;
    if (x === null) {
      x = t.replay;
      try {
        return el(l, t, i, u);
      } catch (M) {
        if (st(), i = M === qn ? ir() : M, l.status !== 12 && typeof i == "object" && i !== null) {
          if (typeof i.then == "function") {
            u = M === qn ? Oe() : null, l = Tr(l, t, u).ping, i.then(l, l), t.formatContext = f, t.context = o, t.keyPath = s, t.treeContext = E, t.componentStack = v, t.replay = x, Hl(o);
            return;
          }
          if (i.message === "Maximum call stack size exceeded") {
            i = M === qn ? Oe() : null, i = Tr(l, t, i), l.pingedTasks.push(i), t.formatContext = f, t.context = o, t.keyPath = s, t.treeContext = E, t.componentStack = v, t.replay = x, Hl(o);
            return;
          }
        }
      }
    } else {
      var A = x.children.length, S = x.chunks.length;
      try {
        return el(l, t, i, u);
      } catch (M) {
        if (st(), x.children.length = A, x.chunks.length = S, i = M === qn ? ir() : M, l.status !== 12 && typeof i == "object" && i !== null) {
          if (typeof i.then == "function") {
            x = i, i = M === qn ? Oe() : null, l = Er(l, t, i).ping, x.then(l, l), t.formatContext = f, t.context = o, t.keyPath = s, t.treeContext = E, t.componentStack = v, Hl(o);
            return;
          }
          if (i.message === "Maximum call stack size exceeded") {
            x = M === qn ? Oe() : null, x = Er(l, t, x), l.pingedTasks.push(x), t.formatContext = f, t.context = o, t.keyPath = s, t.treeContext = E, t.componentStack = v, Hl(o);
            return;
          }
        }
      }
    }
    throw t.formatContext = f, t.context = o, t.keyPath = s, t.treeContext = E, Hl(o), i;
  }
  function Fu(l) {
    var t = l.blockedBoundary, i = l.blockedSegment;
    i !== null && (i.status = 3, Yl(this, t, l.row, i));
  }
  function fe(l, t, i, u, f, o) {
    for (var s = 0; s < i.length; s++) {
      var E = i[s];
      if (E.length === 4)
        fe(
          l,
          t,
          E[2],
          E[3],
          f,
          o
        );
      else {
        E = E[5];
        var v = l, x = o, A = bi(
          v,
          null,
          /* @__PURE__ */ new Set(),
          null,
          null
        );
        A.parentFlushed = !0, A.rootSegmentID = E, A.status = 4, A.errorDigest = x, A.parentFlushed && v.clientRenderedBoundaries.push(A);
      }
    }
    if (i.length = 0, u !== null) {
      if (t === null) throw Error(R(487));
      if (t.status !== 4 && (t.status = 4, t.errorDigest = o, t.parentFlushed && l.clientRenderedBoundaries.push(t)), typeof u == "object") for (var S in u) delete u[S];
    }
  }
  function xi(l, t, i) {
    var u = l.blockedBoundary, f = l.blockedSegment;
    if (f !== null) {
      if (f.status === 6) return;
      f.status = 3;
    }
    var o = Gl(l.componentStack);
    if (u === null) {
      if (t.status !== 13 && t.status !== 14) {
        if (u = l.replay, u === null) {
          t.trackedPostpones !== null && f !== null ? (u = t.trackedPostpones, _n(t, i, o), br(t, u, l, f), Yl(t, null, l.row, f)) : (_n(t, i, o), ze(t, i));
          return;
        }
        u.pendingTasks--, u.pendingTasks === 0 && 0 < u.nodes.length && (f = _n(t, i, o), fe(
          t,
          null,
          u.nodes,
          u.slots,
          i,
          f
        )), t.pendingRootTasks--, t.pendingRootTasks === 0 && Ri(t);
      }
    } else {
      var s = t.trackedPostpones;
      if (u.status !== 4) {
        if (s !== null && f !== null)
          return _n(t, i, o), br(t, s, l, f), u.fallbackAbortableTasks.forEach(function(E) {
            return xi(E, t, i);
          }), u.fallbackAbortableTasks.clear(), Yl(t, u, l.row, f);
        u.status = 4, f = _n(t, i, o), u.status = 4, u.errorDigest = f, yr(t, u), u.parentFlushed && t.clientRenderedBoundaries.push(u);
      }
      u.pendingTasks--, f = u.row, f !== null && --f.pendingTasks === 0 && $(t, f), u.fallbackAbortableTasks.forEach(function(E) {
        return xi(E, t, i);
      }), u.fallbackAbortableTasks.clear();
    }
    l = l.row, l !== null && --l.pendingTasks === 0 && $(t, l), t.allPendingTasks--, t.allPendingTasks === 0 && xr(t);
  }
  function wi(l, t) {
    try {
      var i = l.renderState, u = i.onHeaders;
      if (u) {
        var f = i.headers;
        if (f) {
          i.headers = null;
          var o = f.preconnects;
          if (f.fontPreloads && (o && (o += ", "), o += f.fontPreloads), f.highImagePreloads && (o && (o += ", "), o += f.highImagePreloads), !t) {
            var s = i.styles.values(), E = s.next();
            n: for (; 0 < f.remainingCapacity && !E.done; E = s.next())
              for (var v = E.value.sheets.values(), x = v.next(); 0 < f.remainingCapacity && !x.done; x = v.next()) {
                var A = x.value, S = A.props, M = S.href, O = A.props, G = vn(O.href, "style", {
                  crossOrigin: O.crossOrigin,
                  integrity: O.integrity,
                  nonce: O.nonce,
                  type: O.type,
                  fetchPriority: O.fetchPriority,
                  referrerPolicy: O.referrerPolicy,
                  media: O.media
                });
                if (0 <= (f.remainingCapacity -= G.length + 2))
                  i.resets.style[M] = nl, o && (o += ", "), o += G, i.resets.style[M] = typeof S.crossOrigin == "string" || typeof S.integrity == "string" ? [S.crossOrigin, S.integrity] : nl;
                else break n;
              }
          }
          u(o ? { Link: o } : {});
        }
      }
    } catch (z) {
      _n(l, z, {});
    }
  }
  function Ri(l) {
    l.trackedPostpones === null && wi(l, !0), l.trackedPostpones === null && oe(l), l.onShellError = Nn, l = l.onShellReady, l();
  }
  function xr(l) {
    wi(
      l,
      l.trackedPostpones === null ? !0 : l.completedRootSegment === null || l.completedRootSegment.status !== 5
    ), oe(l), l = l.onAllReady, l();
  }
  function yt(l, t) {
    if (t.chunks.length === 0 && t.children.length === 1 && t.children[0].boundary === null && t.children[0].id === -1) {
      var i = t.children[0];
      i.id = t.id, i.parentFlushed = !0, i.status !== 1 && i.status !== 3 && i.status !== 4 || yt(l, i);
    } else l.completedSegments.push(t);
  }
  function Yl(l, t, i, u) {
    if (i !== null && (--i.pendingTasks === 0 ? $(l, i) : i.together && yi(l, i)), l.allPendingTasks--, t === null) {
      if (u !== null && u.parentFlushed) {
        if (l.completedRootSegment !== null)
          throw Error(R(389));
        l.completedRootSegment = u;
      }
      l.pendingRootTasks--, l.pendingRootTasks === 0 && Ri(l);
    } else if (t.pendingTasks--, t.status !== 4)
      if (t.pendingTasks === 0) {
        if (t.status === 0 && (t.status = 1), u !== null && u.parentFlushed && (u.status === 1 || u.status === 3) && yt(t, u), t.parentFlushed && l.completedBoundaries.push(t), t.status === 1)
          i = t.row, i !== null && _e(i.hoistables, t.contentState), Be(l, t) || (t.fallbackAbortableTasks.forEach(Fu, l), t.fallbackAbortableTasks.clear(), i !== null && --i.pendingTasks === 0 && $(l, i)), l.pendingRootTasks === 0 && l.trackedPostpones === null && t.contentPreamble !== null && oe(l);
        else if (t.status === 5 && (t = t.row, t !== null)) {
          if (l.trackedPostpones !== null) {
            i = l.trackedPostpones;
            var f = t.next;
            if (f !== null && (u = f.boundaries, u !== null))
              for (f.boundaries = null, f = 0; f < u.length; f++) {
                var o = u[f];
                bt(l, i, o), Yl(l, o, null, null);
              }
          }
          --t.pendingTasks === 0 && $(l, t);
        }
      } else
        u === null || !u.parentFlushed || u.status !== 1 && u.status !== 3 || (yt(t, u), t.completedSegments.length === 1 && t.parentFlushed && l.partialBoundaries.push(t)), t = t.row, t !== null && t.together && yi(l, t);
    l.allPendingTasks === 0 && xr(l);
  }
  function La(l) {
    if (l.status !== 14 && l.status !== 13) {
      var t = ae, i = Ae.H;
      Ae.H = Pa;
      var u = Ae.A;
      Ae.A = xu;
      var f = Sn;
      Sn = l;
      var o = hr;
      hr = l.resumableState;
      try {
        var s = l.pingedTasks, E;
        for (E = 0; E < s.length; E++) {
          var v = s[E], x = l, A = v.blockedSegment;
          if (A === null) {
            var S = x;
            if (v.replay.pendingTasks !== 0) {
              Hl(v.context);
              try {
                if (typeof v.replay.slots == "number" ? gr(
                  S,
                  v,
                  v.replay.slots,
                  v.node,
                  v.childIndex
                ) : Ei(S, v), v.replay.pendingTasks === 1 && 0 < v.replay.nodes.length)
                  throw Error(R(488));
                v.replay.pendingTasks--, v.abortSet.delete(v), Yl(
                  S,
                  v.blockedBoundary,
                  v.row,
                  null
                );
              } catch (rn) {
                st();
                var M = rn === qn ? ir() : rn;
                if (typeof M == "object" && M !== null && typeof M.then == "function") {
                  var O = v.ping;
                  M.then(O, O), v.thenableState = rn === qn ? Oe() : null;
                } else {
                  v.replay.pendingTasks--, v.abortSet.delete(v);
                  var G = Gl(v.componentStack);
                  x = void 0;
                  var z = S, D = v.blockedBoundary, B = S.status === 12 ? S.fatalError : M, H = v.replay.nodes, tn = v.replay.slots;
                  x = _n(
                    z,
                    B,
                    G
                  ), fe(
                    z,
                    D,
                    H,
                    tn,
                    B,
                    x
                  ), S.pendingRootTasks--, S.pendingRootTasks === 0 && Ri(S), S.allPendingTasks--, S.allPendingTasks === 0 && xr(S);
                }
              } finally {
              }
            }
          } else if (S = void 0, z = A, z.status === 0) {
            z.status = 6, Hl(v.context);
            var fn = z.children.length, Z = z.chunks.length;
            try {
              Ei(x, v), zl(
                z.chunks,
                x.renderState,
                z.lastPushedText,
                z.textEmbedded
              ), v.abortSet.delete(v), z.status = 1, Yl(
                x,
                v.blockedBoundary,
                v.row,
                z
              );
            } catch (rn) {
              st(), z.children.length = fn, z.chunks.length = Z;
              var K = rn === qn ? ir() : x.status === 12 ? x.fatalError : rn;
              if (x.status === 12 && x.trackedPostpones !== null) {
                var Y = x.trackedPostpones, Gn = Gl(v.componentStack);
                v.abortSet.delete(v), _n(x, K, Gn), br(x, Y, v, z), Yl(
                  x,
                  v.blockedBoundary,
                  v.row,
                  z
                );
              } else if (typeof K == "object" && K !== null && typeof K.then == "function") {
                z.status = 0, v.thenableState = rn === qn ? Oe() : null;
                var J = v.ping;
                K.then(J, J);
              } else {
                var pn = Gl(v.componentStack);
                v.abortSet.delete(v), z.status = 4;
                var q = v.blockedBoundary, gn = v.row;
                if (gn !== null && --gn.pendingTasks === 0 && $(x, gn), x.allPendingTasks--, S = _n(
                  x,
                  K,
                  pn
                ), q === null) ze(x, K);
                else if (q.pendingTasks--, q.status !== 4) {
                  q.status = 4, q.errorDigest = S, yr(x, q);
                  var bn = q.row;
                  bn !== null && --bn.pendingTasks === 0 && $(x, bn), q.parentFlushed && x.clientRenderedBoundaries.push(q), x.pendingRootTasks === 0 && x.trackedPostpones === null && q.contentPreamble !== null && oe(x);
                }
                x.allPendingTasks === 0 && xr(x);
              }
            } finally {
            }
          }
        }
        s.splice(0, E), l.destination !== null && wr(l, l.destination);
      } catch (rn) {
        _n(l, rn, {}), ze(l, rn);
      } finally {
        hr = o, Ae.H = i, Ae.A = u, i === Pa && Hl(t), Sn = f;
      }
    }
  }
  function he(l, t, i) {
    t.preambleChildren.length && i.push(t.preambleChildren);
    for (var u = !1, f = 0; f < t.children.length; f++)
      u = Tt(
        l,
        t.children[f],
        i
      ) || u;
    return u;
  }
  function Tt(l, t, i) {
    var u = t.boundary;
    if (u === null)
      return he(
        l,
        t,
        i
      );
    var f = u.contentPreamble, o = u.fallbackPreamble;
    if (f === null || o === null) return !1;
    switch (u.status) {
      case 1:
        if (ei(l.renderState, f), l.byteSize += u.byteSize, t = u.completedSegments[0], !t) throw Error(R(391));
        return he(
          l,
          t,
          i
        );
      case 5:
        if (l.trackedPostpones !== null) return !0;
      case 4:
        if (t.status === 1)
          return ei(l.renderState, o), he(
            l,
            t,
            i
          );
      default:
        return !0;
    }
  }
  function oe(l) {
    if (l.completedRootSegment && l.completedPreambleSegments === null) {
      var t = [], i = l.byteSize, u = Tt(
        l,
        l.completedRootSegment,
        t
      ), f = l.renderState.preamble;
      u === !1 || f.headChunks && f.bodyChunks ? l.completedPreambleSegments = t : l.byteSize = i;
    }
  }
  function De(l, t, i, u) {
    switch (i.parentFlushed = !0, i.status) {
      case 0:
        i.id = l.nextSegmentId++;
      case 5:
        return u = i.id, i.lastPushedText = !1, i.textEmbedded = !1, l = l.renderState, t.push('<template id="'), t.push(l.placeholderPrefix), l = u.toString(16), t.push(l), t.push('"></template>');
      case 1:
        i.status = 2;
        var f = !0, o = i.chunks, s = 0;
        i = i.children;
        for (var E = 0; E < i.length; E++) {
          for (f = i[E]; s < f.index; s++)
            t.push(o[s]);
          f = se(l, t, f, u);
        }
        for (; s < o.length - 1; s++)
          t.push(o[s]);
        return s < o.length && (f = t.push(o[s])), f;
      case 3:
        return !0;
      default:
        throw Error(R(390));
    }
  }
  var de = 0;
  function se(l, t, i, u) {
    var f = i.boundary;
    if (f === null)
      return De(l, t, i, u);
    if (f.parentFlushed = !0, f.status === 4) {
      var o = f.row;
      return o !== null && --o.pendingTasks === 0 && $(l, o), l.renderState.generateStaticMarkup || (f = f.errorDigest, t.push("<!--$!-->"), t.push("<template"), f && (t.push(' data-dgst="'), f = k(f), t.push(f), t.push('"')), t.push("></template>")), De(l, t, i, u), l = l.renderState.generateStaticMarkup ? !0 : t.push("<!--/$-->"), l;
    }
    if (f.status !== 1)
      return f.status === 0 && (f.rootSegmentID = l.nextSegmentId++), 0 < f.completedSegments.length && l.partialBoundaries.push(f), et(
        t,
        l.renderState,
        f.rootSegmentID
      ), u && _e(u, f.fallbackState), De(l, t, i, u), t.push("<!--/$-->");
    if (!Et && Be(l, f) && de + f.byteSize > l.progressiveChunkSize)
      return f.rootSegmentID = l.nextSegmentId++, l.completedBoundaries.push(f), et(
        t,
        l.renderState,
        f.rootSegmentID
      ), De(l, t, i, u), t.push("<!--/$-->");
    if (de += f.byteSize, u && _e(u, f.contentState), i = f.row, i !== null && Be(l, f) && --i.pendingTasks === 0 && $(l, i), l.renderState.generateStaticMarkup || t.push("<!--$-->"), i = f.completedSegments, i.length !== 1) throw Error(R(391));
    return se(l, t, i[0], u), l = l.renderState.generateStaticMarkup ? !0 : t.push("<!--/$-->"), l;
  }
  function Ci(l, t, i, u) {
    return ol(
      t,
      l.renderState,
      i.parentFormatContext,
      i.id
    ), se(l, t, i, u), oa(t, i.parentFormatContext);
  }
  function Ba(l, t, i) {
    de = i.byteSize;
    for (var u = i.completedSegments, f = 0; f < u.length; f++)
      ge(
        l,
        t,
        i,
        u[f]
      );
    u.length = 0, u = i.row, u !== null && Be(l, i) && --u.pendingTasks === 0 && $(l, u), qt(
      t,
      i.contentState,
      l.renderState
    ), u = l.resumableState, l = l.renderState, f = i.rootSegmentID, i = i.contentState;
    var o = l.stylesToHoist;
    return l.stylesToHoist = !1, t.push(l.startInlineScript), t.push(">"), o ? ((u.instructions & 4) === 0 && (u.instructions |= 4, t.push(
      '$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};'
    )), (u.instructions & 2) === 0 && (u.instructions |= 2, t.push(
      `$RB=[];$RV=function(a){$RT=performance.now();for(var b=0;b<a.length;b+=2){var c=a[b],e=a[b+1];null!==e.parentNode&&e.parentNode.removeChild(e);var f=c.parentNode;if(f){var g=c.previousSibling,h=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d||"/&"===d)if(0===h)break;else h--;else"$"!==d&&"$?"!==d&&"$~"!==d&&"$!"!==d&&"&"!==d||h++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;e.firstChild;)f.insertBefore(e.firstChild,c);g.data="$";g._reactRetry&&requestAnimationFrame(g._reactRetry)}}a.length=0};
$RC=function(a,b){if(b=document.getElementById(b))(a=document.getElementById(a))?(a.previousSibling.data="$~",$RB.push(a,b),2===$RB.length&&("number"!==typeof $RT?requestAnimationFrame($RV.bind(null,$RB)):(a=performance.now(),setTimeout($RV.bind(null,$RB),2300>a&&2E3<a?2300-a:$RT+300-a)))):b.parentNode.removeChild(b)};`
    )), (u.instructions & 8) === 0 ? (u.instructions |= 8, t.push(
      `$RM=new Map;$RR=function(n,w,p){function u(q){this._p=null;q()}for(var r=new Map,t=document,h,b,e=t.querySelectorAll("link[data-precedence],style[data-precedence]"),v=[],k=0;b=e[k++];)"not all"===b.getAttribute("media")?v.push(b):("LINK"===b.tagName&&$RM.set(b.getAttribute("href"),b),r.set(b.dataset.precedence,h=b));e=0;b=[];var l,a;for(k=!0;;){if(k){var f=p[e++];if(!f){k=!1;e=0;continue}var c=!1,m=0;var d=f[m++];if(a=$RM.get(d)){var g=a._p;c=!0}else{a=t.createElement("link");a.href=d;a.rel=
"stylesheet";for(a.dataset.precedence=l=f[m++];g=f[m++];)a.setAttribute(g,f[m++]);g=a._p=new Promise(function(q,x){a.onload=u.bind(a,q);a.onerror=u.bind(a,x)});$RM.set(d,a)}d=a.getAttribute("media");!g||d&&!matchMedia(d).matches||b.push(g);if(c)continue}else{a=v[e++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=r.get(l)||h;c===h&&(h=a);r.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=t.head,c.insertBefore(a,c.firstChild))}if(p=document.getElementById(n))p.previousSibling.data=
"$~";Promise.all(b).then($RC.bind(null,n,w),$RX.bind(null,n,"CSS failed to load"))};$RR("`
    )) : t.push('$RR("')) : ((u.instructions & 2) === 0 && (u.instructions |= 2, t.push(
      `$RB=[];$RV=function(a){$RT=performance.now();for(var b=0;b<a.length;b+=2){var c=a[b],e=a[b+1];null!==e.parentNode&&e.parentNode.removeChild(e);var f=c.parentNode;if(f){var g=c.previousSibling,h=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d||"/&"===d)if(0===h)break;else h--;else"$"!==d&&"$?"!==d&&"$~"!==d&&"$!"!==d&&"&"!==d||h++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;e.firstChild;)f.insertBefore(e.firstChild,c);g.data="$";g._reactRetry&&requestAnimationFrame(g._reactRetry)}}a.length=0};
$RC=function(a,b){if(b=document.getElementById(b))(a=document.getElementById(a))?(a.previousSibling.data="$~",$RB.push(a,b),2===$RB.length&&("number"!==typeof $RT?requestAnimationFrame($RV.bind(null,$RB)):(a=performance.now(),setTimeout($RV.bind(null,$RB),2300>a&&2E3<a?2300-a:$RT+300-a)))):b.parentNode.removeChild(b)};`
    )), t.push('$RC("')), u = f.toString(16), t.push(l.boundaryPrefix), t.push(u), t.push('","'), t.push(l.segmentPrefix), t.push(u), o ? (t.push('",'), ya(t, i)) : t.push('"'), i = t.push(")<\/script>"), mt(t, l) && i;
  }
  function ge(l, t, i, u) {
    if (u.status === 2) return !0;
    var f = i.contentState, o = u.id;
    if (o === -1) {
      if ((u.id = i.rootSegmentID) === -1)
        throw Error(R(392));
      return Ci(l, t, u, f);
    }
    return o === i.rootSegmentID ? Ci(l, t, u, f) : (Ci(l, t, u, f), i = l.resumableState, l = l.renderState, t.push(l.startInlineScript), t.push(">"), (i.instructions & 1) === 0 ? (i.instructions |= 1, t.push(
      '$RS=function(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'
    )) : t.push('$RS("'), t.push(l.segmentPrefix), o = o.toString(16), t.push(o), t.push('","'), t.push(l.placeholderPrefix), t.push(o), t = t.push('")<\/script>'), t);
  }
  var Et = !1;
  function wr(l, t) {
    try {
      if (!(0 < l.pendingRootTasks)) {
        var i, u = l.completedRootSegment;
        if (u !== null) {
          if (u.status === 5) return;
          var f = l.completedPreambleSegments;
          if (f === null) return;
          de = l.byteSize;
          var o = l.resumableState, s = l.renderState, E = s.preamble, v = E.htmlChunks, x = E.headChunks, A;
          if (v) {
            for (A = 0; A < v.length; A++)
              t.push(v[A]);
            if (x)
              for (A = 0; A < x.length; A++)
                t.push(x[A]);
            else {
              var S = an("head");
              t.push(S), t.push(">");
            }
          } else if (x)
            for (A = 0; A < x.length; A++)
              t.push(x[A]);
          var M = s.charsetChunks;
          for (A = 0; A < M.length; A++)
            t.push(M[A]);
          M.length = 0, s.preconnects.forEach(Kn, t), s.preconnects.clear();
          var O = s.viewportChunks;
          for (A = 0; A < O.length; A++)
            t.push(O[A]);
          O.length = 0, s.fontPreloads.forEach(Kn, t), s.fontPreloads.clear(), s.highImagePreloads.forEach(Kn, t), s.highImagePreloads.clear(), re = s, s.styles.forEach(va, t), re = null;
          var G = s.importMapChunks;
          for (A = 0; A < G.length; A++)
            t.push(G[A]);
          G.length = 0, s.bootstrapScripts.forEach(Kn, t), s.scripts.forEach(Kn, t), s.scripts.clear(), s.bulkPreloads.forEach(Kn, t), s.bulkPreloads.clear(), o.instructions |= 32;
          var z = s.hoistableChunks;
          for (A = 0; A < z.length; A++)
            t.push(z[A]);
          for (o = z.length = 0; o < f.length; o++) {
            var D = f[o];
            for (s = 0; s < D.length; s++)
              se(l, t, D[s], null);
          }
          var B = l.renderState.preamble, H = B.headChunks;
          if (B.htmlChunks || H) {
            var tn = Bl("head");
            t.push(tn);
          }
          var fn = B.bodyChunks;
          if (fn)
            for (f = 0; f < fn.length; f++)
              t.push(fn[f]);
          se(l, t, u, null), l.completedRootSegment = null;
          var Z = l.renderState;
          if (l.allPendingTasks !== 0 || l.clientRenderedBoundaries.length !== 0 || l.completedBoundaries.length !== 0 || l.trackedPostpones !== null && (l.trackedPostpones.rootNodes.length !== 0 || l.trackedPostpones.rootSlots !== null)) {
            var K = l.resumableState;
            if ((K.instructions & 64) === 0) {
              if (K.instructions |= 64, t.push(Z.startInlineScript), (K.instructions & 32) === 0) {
                K.instructions |= 32;
                var Y = "_" + K.idPrefix + "R_";
                t.push(' id="');
                var Gn = k(Y);
                t.push(Gn), t.push('"');
              }
              t.push(">"), t.push(
                "requestAnimationFrame(function(){$RT=performance.now()});"
              ), t.push("<\/script>");
            }
          }
          mt(t, Z);
        }
        var J = l.renderState;
        u = 0;
        var pn = J.viewportChunks;
        for (u = 0; u < pn.length; u++)
          t.push(pn[u]);
        pn.length = 0, J.preconnects.forEach(Kn, t), J.preconnects.clear(), J.fontPreloads.forEach(Kn, t), J.fontPreloads.clear(), J.highImagePreloads.forEach(
          Kn,
          t
        ), J.highImagePreloads.clear(), J.styles.forEach(ba, t), J.scripts.forEach(Kn, t), J.scripts.clear(), J.bulkPreloads.forEach(Kn, t), J.bulkPreloads.clear();
        var q = J.hoistableChunks;
        for (u = 0; u < q.length; u++)
          t.push(q[u]);
        q.length = 0;
        var gn = l.clientRenderedBoundaries;
        for (i = 0; i < gn.length; i++) {
          var bn = gn[i];
          J = t;
          var rn = l.resumableState, zn = l.renderState, be = bn.rootSegmentID, jn = bn.errorDigest;
          J.push(zn.startInlineScript), J.push(">"), (rn.instructions & 4) === 0 ? (rn.instructions |= 4, J.push(
            '$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};;$RX("'
          )) : J.push('$RX("'), J.push(zn.boundaryPrefix);
          var xt = be.toString(16);
          if (J.push(xt), J.push('"'), jn) {
            J.push(",");
            var He = tu(
              jn || ""
            );
            J.push(He);
          }
          var kn = J.push(")<\/script>");
          if (!kn) {
            l.destination = null, i++, gn.splice(0, i);
            return;
          }
        }
        gn.splice(0, i);
        var tl = l.completedBoundaries;
        for (i = 0; i < tl.length; i++)
          if (!Ba(l, t, tl[i])) {
            l.destination = null, i++, tl.splice(0, i);
            return;
          }
        tl.splice(0, i), Et = !0;
        var dl = l.partialBoundaries;
        for (i = 0; i < dl.length; i++) {
          var sl = dl[i];
          n: {
            gn = l, bn = t, de = sl.byteSize;
            var wl = sl.completedSegments;
            for (kn = 0; kn < wl.length; kn++)
              if (!ge(
                gn,
                bn,
                sl,
                wl[kn]
              )) {
                kn++, wl.splice(0, kn);
                var Xl = !1;
                break n;
              }
            wl.splice(0, kn);
            var En = sl.row;
            En !== null && En.together && sl.pendingTasks === 1 && (En.pendingTasks === 1 ? gl(
              gn,
              En,
              En.hoistables
            ) : En.pendingTasks--), Xl = qt(
              bn,
              sl.contentState,
              gn.renderState
            );
          }
          if (!Xl) {
            l.destination = null, i++, dl.splice(0, i);
            return;
          }
        }
        dl.splice(0, i), Et = !1;
        var ye = l.completedBoundaries;
        for (i = 0; i < ye.length; i++)
          if (!Ba(l, t, ye[i])) {
            l.destination = null, i++, ye.splice(0, i);
            return;
          }
        ye.splice(0, i);
      }
    } finally {
      Et = !1, l.allPendingTasks === 0 && l.clientRenderedBoundaries.length === 0 && l.completedBoundaries.length === 0 && (l.flushScheduled = !1, i = l.resumableState, i.hasBody && (dl = Bl("body"), t.push(dl)), i.hasHtml && (i = Bl("html"), t.push(i)), l.status = 14, t.push(null), l.destination = null);
    }
  }
  function ve(l) {
    if (l.flushScheduled === !1 && l.pingedTasks.length === 0 && l.destination !== null) {
      l.flushScheduled = !0;
      var t = l.destination;
      t ? wr(l, t) : l.flushScheduled = !1;
    }
  }
  function Rr(l, t) {
    if (l.status === 13)
      l.status = 14, t.destroy(l.fatalError);
    else if (l.status !== 14 && l.destination === null) {
      l.destination = t;
      try {
        wr(l, t);
      } catch (i) {
        _n(l, i, {}), ze(l, i);
      }
    }
  }
  function Na(l, t) {
    (l.status === 11 || l.status === 10) && (l.status = 12);
    try {
      var i = l.abortableTasks;
      if (0 < i.size) {
        var u = t === void 0 ? Error(R(432)) : typeof t == "object" && t !== null && typeof t.then == "function" ? Error(R(530)) : t;
        l.fatalError = u, i.forEach(function(f) {
          return xi(f, l, u);
        }), i.clear();
      }
      l.destination !== null && wr(l, l.destination);
    } catch (f) {
      _n(l, f, {}), ze(l, f);
    }
  }
  function vl(l, t, i) {
    if (t === null) i.rootNodes.push(l);
    else {
      var u = i.workingMap, f = u.get(t);
      f === void 0 && (f = [t[1], t[2], [], null], u.set(t, f), vl(f, t[0], i)), f[2].push(l);
    }
  }
  function Cr() {
  }
  function Fi(l, t, i, u) {
    var f = !1, o = null, s = "", E = !1;
    if (t = lu(t ? t.identifierPrefix : void 0), l = Cu(
      l,
      t,
      nr(t, i),
      xn(0, null, 0, null),
      1 / 0,
      Cr,
      void 0,
      function() {
        E = !0;
      },
      void 0,
      void 0,
      void 0
    ), l.flushScheduled = l.destination !== null, La(l), l.status === 10 && (l.status = 11), l.trackedPostpones === null && wi(l, l.pendingRootTasks === 0), Na(l, u), Rr(l, {
      push: function(v) {
        return v !== null && (s += v), !0;
      },
      destroy: function(v) {
        f = !0, o = v;
      }
    }), f && o !== u) throw o;
    if (!E) throw Error(R(426));
    return s;
  }
  return ta.renderToStaticMarkup = function(l, t) {
    return Fi(
      l,
      t,
      !0,
      'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server'
    );
  }, ta.renderToString = function(l, t) {
    return Fi(
      l,
      t,
      !1,
      'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server'
    );
  }, ta.version = "19.2.0", ta;
}
var Gt = {};
var Rc;
function Yc() {
  if (Rc) return Gt;
  Rc = 1;
  var Wn = Fc(), Tl = Sc();
  function R(n) {
    var e = "https://react.dev/errors/" + n;
    if (1 < arguments.length) {
      e += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var r = 2; r < arguments.length; r++)
        e += "&args[]=" + encodeURIComponent(arguments[r]);
    }
    return "Minified React error #" + n + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var $l = Symbol.for("react.transitional.element"), je = Symbol.for("react.portal"), Yt = Symbol.for("react.fragment"), Hr = Symbol.for("react.strict_mode"), Wr = Symbol.for("react.profiler"), Ur = Symbol.for("react.consumer"), ne = Symbol.for("react.context"), $e = Symbol.for("react.forward_ref"), le = Symbol.for("react.suspense"), nt = Symbol.for("react.suspense_list"), lt = Symbol.for("react.memo"), ee = Symbol.for("react.lazy"), pa = Symbol.for("react.scope"), Gr = Symbol.for("react.activity"), ja = Symbol.for("react.legacy_hidden"), $a = Symbol.for("react.memo_cache_sentinel"), nu = Symbol.for("react.view_transition"), Yr = Symbol.iterator;
  function Xr(n) {
    return n === null || typeof n != "object" ? null : (n = Yr && n[Yr] || n["@@iterator"], typeof n == "function" ? n : null);
  }
  var te = Array.isArray;
  function Zr(n, e) {
    var r = n.length & 3, a = n.length - r, c = e;
    for (e = 0; e < a; ) {
      var h = n.charCodeAt(e) & 255 | (n.charCodeAt(++e) & 255) << 8 | (n.charCodeAt(++e) & 255) << 16 | (n.charCodeAt(++e) & 255) << 24;
      ++e, h = 3432918353 * (h & 65535) + ((3432918353 * (h >>> 16) & 65535) << 16) & 4294967295, h = h << 15 | h >>> 17, h = 461845907 * (h & 65535) + ((461845907 * (h >>> 16) & 65535) << 16) & 4294967295, c ^= h, c = c << 13 | c >>> 19, c = 5 * (c & 65535) + ((5 * (c >>> 16) & 65535) << 16) & 4294967295, c = (c & 65535) + 27492 + (((c >>> 16) + 58964 & 65535) << 16);
    }
    switch (h = 0, r) {
      case 3:
        h ^= (n.charCodeAt(e + 2) & 255) << 16;
      case 2:
        h ^= (n.charCodeAt(e + 1) & 255) << 8;
      case 1:
        h ^= n.charCodeAt(e) & 255, h = 3432918353 * (h & 65535) + ((3432918353 * (h >>> 16) & 65535) << 16) & 4294967295, h = h << 15 | h >>> 17, c ^= 461845907 * (h & 65535) + ((461845907 * (h >>> 16) & 65535) << 16) & 4294967295;
    }
    return c ^= n.length, c ^= c >>> 16, c = 2246822507 * (c & 65535) + ((2246822507 * (c >>> 16) & 65535) << 16) & 4294967295, c ^= c >>> 13, c = 3266489909 * (c & 65535) + ((3266489909 * (c >>> 16) & 65535) << 16) & 4294967295, (c ^ c >>> 16) >>> 0;
  }
  var Bn = new MessageChannel(), nn = [];
  Bn.port1.onmessage = function() {
    var n = nn.shift();
    n && n();
  };
  function Jr(n) {
    nn.push(n), Bn.port2.postMessage(null);
  }
  function ra(n) {
    setTimeout(function() {
      throw n;
    });
  }
  var ia = Promise, Xt = typeof queueMicrotask == "function" ? queueMicrotask : function(n) {
    ia.resolve(null).then(n).catch(ra);
  }, Zn = null, Jn = 0;
  function F(n, e) {
    if (e.byteLength !== 0)
      if (2048 < e.byteLength)
        0 < Jn && (n.enqueue(
          new Uint8Array(Zn.buffer, 0, Jn)
        ), Zn = new Uint8Array(2048), Jn = 0), n.enqueue(e);
      else {
        var r = Zn.length - Jn;
        r < e.byteLength && (r === 0 ? n.enqueue(Zn) : (Zn.set(e.subarray(0, r), Jn), n.enqueue(Zn), e = e.subarray(r)), Zn = new Uint8Array(2048), Jn = 0), Zn.set(e, Jn), Jn += e.byteLength;
      }
  }
  function k(n, e) {
    return F(n, e), !0;
  }
  function Qr(n) {
    Zn && 0 < Jn && (n.enqueue(new Uint8Array(Zn.buffer, 0, Jn)), Zn = null, Jn = 0);
  }
  var aa = new TextEncoder();
  function I(n) {
    return aa.encode(n);
  }
  function C(n) {
    return aa.encode(n);
  }
  function Ae(n) {
    return n.byteLength;
  }
  function Vr(n, e) {
    typeof n.error == "function" ? n.error(e) : n.close();
  }
  var Un = Object.assign, Q = Object.prototype.hasOwnProperty, nl = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), re = {}, Kr = {};
  function Zt(n) {
    return Q.call(Kr, n) ? !0 : Q.call(re, n) ? !1 : nl.test(n) ? Kr[n] = !0 : (re[n] = !0, !1);
  }
  var lu = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  ), xn = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), ua = /["'&<>]/;
  function N(n) {
    if (typeof n == "boolean" || typeof n == "number" || typeof n == "bigint")
      return "" + n;
    n = "" + n;
    var e = ua.exec(n);
    if (e) {
      var r = "", a, c = 0;
      for (a = e.index; a < n.length; a++) {
        switch (n.charCodeAt(a)) {
          case 34:
            e = "&quot;";
            break;
          case 38:
            e = "&amp;";
            break;
          case 39:
            e = "&#x27;";
            break;
          case 60:
            e = "&lt;";
            break;
          case 62:
            e = "&gt;";
            break;
          default:
            continue;
        }
        c !== a && (r += n.slice(c, a)), c = a + 1, r += e;
      }
      n = c !== a ? r + n.slice(c, a) : r;
    }
    return n;
  }
  var mr = /([A-Z])/g, Jt = /^ms-/, ca = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Pe(n) {
    return ca.test("" + n) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : n;
  }
  var Ll = Wn.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, wn = Tl.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, fa = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, hl = wn.d;
  wn.d = {
    f: hl.f,
    r: hl.r,
    D: xi,
    C: wi,
    L: Ri,
    m: xr,
    X: Yl,
    S: yt,
    M: La
  };
  var Qn = [], ie = null;
  C('"></template>');
  var ha = C("<script"), V = C("<\/script>"), Vn = C('<script src="'), eu = C('<script type="module" src="'), qr = C(' nonce="'), Rn = C(' integrity="'), pr = C(' crossorigin="'), jr = C(' async=""><\/script>'), Me = C("<style"), Qt = /(<\/|<)(s)(cript)/gi;
  function Ie(n, e, r, a) {
    return "" + e + (r === "s" ? "\\u0073" : "\\u0053") + a;
  }
  var $r = C(
    '<script type="importmap">'
  ), Vt = C("<\/script>");
  function Kt(n, e, r, a, c, h) {
    r = typeof e == "string" ? e : e && e.script;
    var d = r === void 0 ? ha : C(
      '<script nonce="' + N(r) + '"'
    ), b = typeof e == "string" ? void 0 : e && e.style, g = b === void 0 ? Me : C(
      '<style nonce="' + N(b) + '"'
    ), y = n.idPrefix, T = [], w = n.bootstrapScriptContent, P = n.bootstrapScripts, _ = n.bootstrapModules;
    if (w !== void 0 && (T.push(d), bt(T, n), T.push(
      ln,
      I(
        ("" + w).replace(Qt, Ie)
      ),
      V
    )), w = [], a !== void 0 && (w.push($r), w.push(
      I(
        ("" + JSON.stringify(a)).replace(Qt, Ie)
      )
    ), w.push(Vt)), a = c ? {
      preconnects: "",
      fontPreloads: "",
      highImagePreloads: "",
      remainingCapacity: 2 + (typeof h == "number" ? h : 2e3)
    } : null, c = {
      placeholderPrefix: C(y + "P:"),
      segmentPrefix: C(y + "S:"),
      boundaryPrefix: C(y + "B:"),
      startInlineScript: d,
      startInlineStyle: g,
      preamble: an(),
      externalRuntimeScript: null,
      bootstrapChunks: T,
      importMapChunks: w,
      onHeaders: c,
      headers: a,
      resets: {
        font: {},
        dns: {},
        connect: { default: {}, anonymous: {}, credentials: {} },
        image: {},
        style: {}
      },
      charsetChunks: [],
      viewportChunks: [],
      hoistableChunks: [],
      preconnects: /* @__PURE__ */ new Set(),
      fontPreloads: /* @__PURE__ */ new Set(),
      highImagePreloads: /* @__PURE__ */ new Set(),
      styles: /* @__PURE__ */ new Map(),
      bootstrapScripts: /* @__PURE__ */ new Set(),
      scripts: /* @__PURE__ */ new Set(),
      bulkPreloads: /* @__PURE__ */ new Set(),
      preloads: {
        images: /* @__PURE__ */ new Map(),
        stylesheets: /* @__PURE__ */ new Map(),
        scripts: /* @__PURE__ */ new Map(),
        moduleScripts: /* @__PURE__ */ new Map()
      },
      nonce: { script: r, style: b },
      hoistableState: null,
      stylesToHoist: !1
    }, P !== void 0)
      for (a = 0; a < P.length; a++)
        y = P[a], b = d = void 0, g = {
          rel: "preload",
          as: "script",
          fetchPriority: "low",
          nonce: e
        }, typeof y == "string" ? g.href = h = y : (g.href = h = y.src, g.integrity = b = typeof y.integrity == "string" ? y.integrity : void 0, g.crossOrigin = d = typeof y == "string" || y.crossOrigin == null ? void 0 : y.crossOrigin === "use-credentials" ? "use-credentials" : ""), y = n, w = h, y.scriptResources[w] = null, y.moduleScriptResources[w] = null, y = [], vn(y, g), c.bootstrapScripts.add(y), T.push(
          Vn,
          I(N(h)),
          un
        ), r && T.push(
          qr,
          I(N(r)),
          un
        ), typeof b == "string" && T.push(
          Rn,
          I(N(b)),
          un
        ), typeof d == "string" && T.push(
          pr,
          I(N(d)),
          un
        ), bt(T, n), T.push(jr);
    if (_ !== void 0)
      for (e = 0; e < _.length; e++)
        b = _[e], h = a = void 0, d = {
          rel: "modulepreload",
          fetchPriority: "low",
          nonce: r
        }, typeof b == "string" ? d.href = P = b : (d.href = P = b.src, d.integrity = h = typeof b.integrity == "string" ? b.integrity : void 0, d.crossOrigin = a = typeof b == "string" || b.crossOrigin == null ? void 0 : b.crossOrigin === "use-credentials" ? "use-credentials" : ""), b = n, g = P, b.scriptResources[g] = null, b.moduleScriptResources[g] = null, b = [], vn(b, d), c.bootstrapScripts.add(b), T.push(
          eu,
          I(N(P)),
          un
        ), r && T.push(
          qr,
          I(N(r)),
          un
        ), typeof h == "string" && T.push(
          Rn,
          I(N(h)),
          un
        ), typeof a == "string" && T.push(
          pr,
          I(N(a)),
          un
        ), bt(T, n), T.push(jr);
    return c;
  }
  function ni(n, e, r, a, c) {
    return {
      idPrefix: n === void 0 ? "" : n,
      nextFormID: 0,
      streamingFormat: 0,
      bootstrapScriptContent: r,
      bootstrapScripts: a,
      bootstrapModules: c,
      instructions: 0,
      hasBody: !1,
      hasHtml: !1,
      unknownResources: {},
      dnsResources: {},
      connectResources: { default: {}, anonymous: {}, credentials: {} },
      imageResources: {},
      styleResources: {},
      scriptResources: {},
      moduleUnknownResources: {},
      moduleScriptResources: {}
    };
  }
  function an() {
    return { htmlChunks: null, headChunks: null, bodyChunks: null };
  }
  function Cn(n, e, r, a) {
    return {
      insertionMode: n,
      selectedValue: e,
      tagScope: r,
      viewTransition: a
    };
  }
  function li(n) {
    return Cn(
      n === "http://www.w3.org/2000/svg" ? 4 : n === "http://www.w3.org/1998/Math/MathML" ? 5 : 0,
      null,
      0,
      null
    );
  }
  function Bl(n, e, r) {
    var a = n.tagScope & -25;
    switch (e) {
      case "noscript":
        return Cn(2, null, a | 1, null);
      case "select":
        return Cn(
          2,
          r.value != null ? r.value : r.defaultValue,
          a,
          null
        );
      case "svg":
        return Cn(4, null, a, null);
      case "picture":
        return Cn(2, null, a | 2, null);
      case "math":
        return Cn(5, null, a, null);
      case "foreignObject":
        return Cn(2, null, a, null);
      case "table":
        return Cn(6, null, a, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return Cn(7, null, a, null);
      case "colgroup":
        return Cn(9, null, a, null);
      case "tr":
        return Cn(8, null, a, null);
      case "head":
        if (2 > n.insertionMode)
          return Cn(3, null, a, null);
        break;
      case "html":
        if (n.insertionMode === 0)
          return Cn(1, null, a, null);
    }
    return 6 <= n.insertionMode || 2 > n.insertionMode ? Cn(2, null, a, null) : n.tagScope !== a ? Cn(
      n.insertionMode,
      n.selectedValue,
      a,
      null
    ) : n;
  }
  function ei(n) {
    return n === null ? null : {
      update: n.update,
      enter: "none",
      exit: "none",
      share: n.update,
      name: n.autoName,
      autoName: n.autoName,
      nameIdx: 0
    };
  }
  function mt(n, e) {
    return e.tagScope & 32 && (n.instructions |= 128), Cn(
      e.insertionMode,
      e.selectedValue,
      e.tagScope | 12,
      ei(e.viewTransition)
    );
  }
  function et(n, e) {
    n = ei(e.viewTransition);
    var r = e.tagScope | 16;
    return n !== null && n.share !== "none" && (r |= 64), Cn(
      e.insertionMode,
      e.selectedValue,
      r,
      n
    );
  }
  var ol = C("<!-- -->");
  function oa(n, e, r, a) {
    return e === "" ? a : (a && n.push(ol), n.push(I(N(e))), !0);
  }
  var da = /* @__PURE__ */ new Map(), tu = C(' style="'), sa = C(":"), tt = C(";");
  function rt(n, e) {
    if (typeof e != "object") throw Error(R(62));
    var r = !0, a;
    for (a in e)
      if (Q.call(e, a)) {
        var c = e[a];
        if (c != null && typeof c != "boolean" && c !== "") {
          if (a.indexOf("--") === 0) {
            var h = I(N(a));
            c = I(
              N(("" + c).trim())
            );
          } else
            h = da.get(a), h === void 0 && (h = C(
              N(
                a.replace(mr, "-$1").toLowerCase().replace(Jt, "-ms-")
              )
            ), da.set(a, h)), c = typeof c == "number" ? c === 0 || lu.has(a) ? I("" + c) : I(c + "px") : I(
              N(("" + c).trim())
            );
          r ? (r = !1, n.push(
            tu,
            h,
            sa,
            c
          )) : n.push(tt, h, sa, c);
        }
      }
    r || n.push(un);
  }
  var Fn = C(" "), ll = C('="'), un = C('"'), qt = C('=""');
  function Kn(n, e, r) {
    r && typeof r != "function" && typeof r != "symbol" && n.push(Fn, I(e), qt);
  }
  function cn(n, e, r) {
    typeof r != "function" && typeof r != "symbol" && typeof r != "boolean" && n.push(
      Fn,
      I(e),
      ll,
      I(N(r)),
      un
    );
  }
  var ga = C(
    N(
      "javascript:throw new Error('React form unexpectedly submitted.')"
    )
  ), va = C('<input type="hidden"');
  function ti(n, e) {
    this.push(va), ba(n), cn(this, "name", e), cn(this, "value", n), this.push(at);
  }
  function ba(n) {
    if (typeof n != "string") throw Error(R(480));
  }
  function it(n, e) {
    if (typeof e.$$FORM_ACTION == "function") {
      var r = n.nextFormID++;
      n = n.idPrefix + r;
      try {
        var a = e.$$FORM_ACTION(n);
        if (a) {
          var c = a.data;
          c?.forEach(ba);
        }
        return a;
      } catch (h) {
        if (typeof h == "object" && h !== null && typeof h.then == "function")
          throw h;
      }
    }
    return null;
  }
  function ya(n, e, r, a, c, h, d, b) {
    var g = null;
    if (typeof a == "function") {
      var y = it(e, a);
      y !== null ? (b = y.name, a = y.action || "", c = y.encType, h = y.method, d = y.target, g = y.data) : (n.push(
        Fn,
        I("formAction"),
        ll,
        ga,
        un
      ), d = h = c = a = b = null, Ea(e, r));
    }
    return b != null && m(n, "name", b), a != null && m(n, "formAction", a), c != null && m(n, "formEncType", c), h != null && m(n, "formMethod", h), d != null && m(n, "formTarget", d), g;
  }
  function m(n, e, r) {
    switch (e) {
      case "className":
        cn(n, "class", r);
        break;
      case "tabIndex":
        cn(n, "tabindex", r);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        cn(n, e, r);
        break;
      case "style":
        rt(n, r);
        break;
      case "src":
      case "href":
        if (r === "") break;
      case "action":
      case "formAction":
        if (r == null || typeof r == "function" || typeof r == "symbol" || typeof r == "boolean")
          break;
        r = Pe("" + r), n.push(
          Fn,
          I(e),
          ll,
          I(N(r)),
          un
        );
        break;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "ref":
        break;
      case "autoFocus":
      case "multiple":
      case "muted":
        Kn(n, e.toLowerCase(), r);
        break;
      case "xlinkHref":
        if (typeof r == "function" || typeof r == "symbol" || typeof r == "boolean")
          break;
        r = Pe("" + r), n.push(
          Fn,
          I("xlink:href"),
          ll,
          I(N(r)),
          un
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        typeof r != "function" && typeof r != "symbol" && n.push(
          Fn,
          I(e),
          ll,
          I(N(r)),
          un
        );
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        r && typeof r != "function" && typeof r != "symbol" && n.push(
          Fn,
          I(e),
          qt
        );
        break;
      case "capture":
      case "download":
        r === !0 ? n.push(
          Fn,
          I(e),
          qt
        ) : r !== !1 && typeof r != "function" && typeof r != "symbol" && n.push(
          Fn,
          I(e),
          ll,
          I(N(r)),
          un
        );
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        typeof r != "function" && typeof r != "symbol" && !isNaN(r) && 1 <= r && n.push(
          Fn,
          I(e),
          ll,
          I(N(r)),
          un
        );
        break;
      case "rowSpan":
      case "start":
        typeof r == "function" || typeof r == "symbol" || isNaN(r) || n.push(
          Fn,
          I(e),
          ll,
          I(N(r)),
          un
        );
        break;
      case "xlinkActuate":
        cn(n, "xlink:actuate", r);
        break;
      case "xlinkArcrole":
        cn(n, "xlink:arcrole", r);
        break;
      case "xlinkRole":
        cn(n, "xlink:role", r);
        break;
      case "xlinkShow":
        cn(n, "xlink:show", r);
        break;
      case "xlinkTitle":
        cn(n, "xlink:title", r);
        break;
      case "xlinkType":
        cn(n, "xlink:type", r);
        break;
      case "xmlBase":
        cn(n, "xml:base", r);
        break;
      case "xmlLang":
        cn(n, "xml:lang", r);
        break;
      case "xmlSpace":
        cn(n, "xml:space", r);
        break;
      default:
        if ((!(2 < e.length) || e[0] !== "o" && e[0] !== "O" || e[1] !== "n" && e[1] !== "N") && (e = xn.get(e) || e, Zt(e))) {
          switch (typeof r) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              var a = e.toLowerCase().slice(0, 5);
              if (a !== "data-" && a !== "aria-") return;
          }
          n.push(
            Fn,
            I(e),
            ll,
            I(N(r)),
            un
          );
        }
    }
  }
  var ln = C(">"), at = C("/>");
  function mn(n, e, r) {
    if (e != null) {
      if (r != null) throw Error(R(60));
      if (typeof e != "object" || !("__html" in e))
        throw Error(R(61));
      e = e.__html, e != null && n.push(I("" + e));
    }
  }
  function ru(n) {
    var e = "";
    return Wn.Children.forEach(n, function(r) {
      r != null && (e += r);
    }), e;
  }
  var ri = C(' selected=""'), Ta = C(
    `addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error('React form unexpectedly submitted.')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});`
  );
  function Ea(n, e) {
    if ((n.instructions & 16) === 0) {
      n.instructions |= 16;
      var r = e.preamble, a = e.bootstrapChunks;
      (r.htmlChunks || r.headChunks) && a.length === 0 ? (a.push(e.startInlineScript), bt(a, n), a.push(
        ln,
        Ta,
        V
      )) : a.unshift(
        e.startInlineScript,
        ln,
        Ta,
        V
      );
    }
  }
  var iu = C("<!--F!-->"), ut = C("<!--F-->");
  function vn(n, e) {
    n.push(sn("link"));
    for (var r in e)
      if (Q.call(e, r)) {
        var a = e[r];
        if (a != null)
          switch (r) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(R(399, "link"));
            default:
              m(n, r, a);
          }
      }
    return n.push(at), null;
  }
  var pt = /(<\/|<)(s)(tyle)/gi;
  function jt(n, e, r, a) {
    return "" + e + (r === "s" ? "\\73 " : "\\53 ") + a;
  }
  function Nl(n, e, r) {
    n.push(sn(r));
    for (var a in e)
      if (Q.call(e, a)) {
        var c = e[a];
        if (c != null)
          switch (a) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(R(399, r));
            default:
              m(n, a, c);
          }
      }
    return n.push(at), null;
  }
  function $t(n, e) {
    n.push(sn("title"));
    var r = null, a = null, c;
    for (c in e)
      if (Q.call(e, c)) {
        var h = e[c];
        if (h != null)
          switch (c) {
            case "children":
              r = h;
              break;
            case "dangerouslySetInnerHTML":
              a = h;
              break;
            default:
              m(n, c, h);
          }
      }
    return n.push(ln), e = Array.isArray(r) ? 2 > r.length ? r[0] : null : r, typeof e != "function" && typeof e != "symbol" && e !== null && e !== void 0 && n.push(I(N("" + e))), mn(n, a, r), n.push(Dl("title")), null;
  }
  var au = C("<!--head-->"), uu = C("<!--body-->"), _e = C("<!--html-->");
  function nr(n, e) {
    n.push(sn("script"));
    var r = null, a = null, c;
    for (c in e)
      if (Q.call(e, c)) {
        var h = e[c];
        if (h != null)
          switch (c) {
            case "children":
              r = h;
              break;
            case "dangerouslySetInnerHTML":
              a = h;
              break;
            default:
              m(n, c, h);
          }
      }
    return n.push(ln), mn(n, a, r), typeof r == "string" && n.push(
      I(("" + r).replace(Qt, Ie))
    ), n.push(Dl("script")), null;
  }
  function lr(n, e, r) {
    n.push(sn(r));
    var a = r = null, c;
    for (c in e)
      if (Q.call(e, c)) {
        var h = e[c];
        if (h != null)
          switch (c) {
            case "children":
              r = h;
              break;
            case "dangerouslySetInnerHTML":
              a = h;
              break;
            default:
              m(n, c, h);
          }
      }
    return n.push(ln), mn(n, a, r), r;
  }
  function zl(n, e, r) {
    n.push(sn(r));
    var a = r = null, c;
    for (c in e)
      if (Q.call(e, c)) {
        var h = e[c];
        if (h != null)
          switch (c) {
            case "children":
              r = h;
              break;
            case "dangerouslySetInnerHTML":
              a = h;
              break;
            default:
              m(n, c, h);
          }
      }
    return n.push(ln), mn(n, a, r), typeof r == "string" ? (n.push(I(N(r))), null) : r;
  }
  var ii = C(`
`), cu = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, ct = /* @__PURE__ */ new Map();
  function sn(n) {
    var e = ct.get(n);
    if (e === void 0) {
      if (!cu.test(n))
        throw Error(R(65, n));
      e = C("<" + n), ct.set(n, e);
    }
    return e;
  }
  var ae = C("<!DOCTYPE html>");
  function er(n, e, r, a, c, h, d, b, g) {
    switch (e) {
      case "div":
      case "span":
      case "svg":
      case "path":
        break;
      case "a":
        n.push(sn("a"));
        var y = null, T = null, w;
        for (w in r)
          if (Q.call(r, w)) {
            var P = r[w];
            if (P != null)
              switch (w) {
                case "children":
                  y = P;
                  break;
                case "dangerouslySetInnerHTML":
                  T = P;
                  break;
                case "href":
                  P === "" ? cn(n, "href", "") : m(n, w, P);
                  break;
                default:
                  m(n, w, P);
              }
          }
        if (n.push(ln), mn(n, T, y), typeof y == "string") {
          n.push(I(N(y)));
          var _ = null;
        } else _ = y;
        return _;
      case "g":
      case "p":
      case "li":
        break;
      case "select":
        n.push(sn("select"));
        var X = null, W = null, U;
        for (U in r)
          if (Q.call(r, U)) {
            var en = r[U];
            if (en != null)
              switch (U) {
                case "children":
                  X = en;
                  break;
                case "dangerouslySetInnerHTML":
                  W = en;
                  break;
                case "defaultValue":
                case "value":
                  break;
                default:
                  m(
                    n,
                    U,
                    en
                  );
              }
          }
        return n.push(ln), mn(n, W, X), X;
      case "option":
        var p = b.selectedValue;
        n.push(sn("option"));
        var Mn = null, Yn = null, cl = null, L = null, Ln;
        for (Ln in r)
          if (Q.call(r, Ln)) {
            var hn = r[Ln];
            if (hn != null)
              switch (Ln) {
                case "children":
                  Mn = hn;
                  break;
                case "selected":
                  cl = hn;
                  break;
                case "dangerouslySetInnerHTML":
                  L = hn;
                  break;
                case "value":
                  Yn = hn;
                default:
                  m(
                    n,
                    Ln,
                    hn
                  );
              }
          }
        if (p != null) {
          var Dn = Yn !== null ? "" + Yn : ru(Mn);
          if (te(p)) {
            for (var _l = 0; _l < p.length; _l++)
              if ("" + p[_l] === Dn) {
                n.push(ri);
                break;
              }
          } else
            "" + p === Dn && n.push(ri);
        } else cl && n.push(ri);
        return n.push(ln), mn(n, L, Mn), Mn;
      case "textarea":
        n.push(sn("textarea"));
        var on = null, pl = null, yl = null, In;
        for (In in r)
          if (Q.call(r, In)) {
            var fl = r[In];
            if (fl != null)
              switch (In) {
                case "children":
                  yl = fl;
                  break;
                case "value":
                  on = fl;
                  break;
                case "defaultValue":
                  pl = fl;
                  break;
                case "dangerouslySetInnerHTML":
                  throw Error(R(91));
                default:
                  m(
                    n,
                    In,
                    fl
                  );
              }
          }
        if (on === null && pl !== null && (on = pl), n.push(ln), yl != null) {
          if (on != null) throw Error(R(92));
          if (te(yl)) {
            if (1 < yl.length)
              throw Error(R(93));
            on = "" + yl[0];
          }
          on = "" + yl;
        }
        return typeof on == "string" && on[0] === `
` && n.push(ii), on !== null && n.push(
          I(N("" + on))
        ), null;
      case "input":
        n.push(sn("input"));
        var kt = null, Ot = null, Fe = null, Lt = null, Hi = null, jl = null, me = null, Su = null, Au = null, Wi;
        for (Wi in r)
          if (Q.call(r, Wi)) {
            var kl = r[Wi];
            if (kl != null)
              switch (Wi) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(R(399, "input"));
                case "name":
                  kt = kl;
                  break;
                case "formAction":
                  Ot = kl;
                  break;
                case "formEncType":
                  Fe = kl;
                  break;
                case "formMethod":
                  Lt = kl;
                  break;
                case "formTarget":
                  Hi = kl;
                  break;
                case "defaultChecked":
                  Au = kl;
                  break;
                case "defaultValue":
                  me = kl;
                  break;
                case "checked":
                  Su = kl;
                  break;
                case "value":
                  jl = kl;
                  break;
                default:
                  m(
                    n,
                    Wi,
                    kl
                  );
              }
          }
        var Yu = ya(
          n,
          a,
          c,
          Ot,
          Fe,
          Lt,
          Hi,
          kt
        );
        return Su !== null ? Kn(n, "checked", Su) : Au !== null && Kn(n, "checked", Au), jl !== null ? m(n, "value", jl) : me !== null && m(n, "value", me), n.push(at), Yu?.forEach(ti, n), null;
      case "button":
        n.push(sn("button"));
        var Ui = null, Xu = null, Zu = null, Ju = null, Qu = null, Vu = null, Ku = null, Gi;
        for (Gi in r)
          if (Q.call(r, Gi)) {
            var Se = r[Gi];
            if (Se != null)
              switch (Gi) {
                case "children":
                  Ui = Se;
                  break;
                case "dangerouslySetInnerHTML":
                  Xu = Se;
                  break;
                case "name":
                  Zu = Se;
                  break;
                case "formAction":
                  Ju = Se;
                  break;
                case "formEncType":
                  Qu = Se;
                  break;
                case "formMethod":
                  Vu = Se;
                  break;
                case "formTarget":
                  Ku = Se;
                  break;
                default:
                  m(
                    n,
                    Gi,
                    Se
                  );
              }
          }
        var mu = ya(
          n,
          a,
          c,
          Ju,
          Qu,
          Vu,
          Ku,
          Zu
        );
        if (n.push(ln), mu?.forEach(ti, n), mn(n, Xu, Ui), typeof Ui == "string") {
          n.push(
            I(N(Ui))
          );
          var qu = null;
        } else qu = Ui;
        return qu;
      case "form":
        n.push(sn("form"));
        var Yi = null, pu = null, Bt = null, Xi = null, Zi = null, Ji = null, Qi;
        for (Qi in r)
          if (Q.call(r, Qi)) {
            var qe = r[Qi];
            if (qe != null)
              switch (Qi) {
                case "children":
                  Yi = qe;
                  break;
                case "dangerouslySetInnerHTML":
                  pu = qe;
                  break;
                case "action":
                  Bt = qe;
                  break;
                case "encType":
                  Xi = qe;
                  break;
                case "method":
                  Zi = qe;
                  break;
                case "target":
                  Ji = qe;
                  break;
                default:
                  m(
                    n,
                    Qi,
                    qe
                  );
              }
          }
        var Pu = null, Mu = null;
        if (typeof Bt == "function") {
          var Nt = it(
            a,
            Bt
          );
          Nt !== null ? (Bt = Nt.action || "", Xi = Nt.encType, Zi = Nt.method, Ji = Nt.target, Pu = Nt.data, Mu = Nt.name) : (n.push(
            Fn,
            I("action"),
            ll,
            ga,
            un
          ), Ji = Zi = Xi = Bt = null, Ea(a, c));
        }
        if (Bt != null && m(n, "action", Bt), Xi != null && m(n, "encType", Xi), Zi != null && m(n, "method", Zi), Ji != null && m(n, "target", Ji), n.push(ln), Mu !== null && (n.push(va), cn(n, "name", Mu), n.push(at), Pu?.forEach(ti, n)), mn(n, pu, Yi), typeof Yi == "string") {
          n.push(
            I(N(Yi))
          );
          var ju = null;
        } else ju = Yi;
        return ju;
      case "menuitem":
        n.push(sn("menuitem"));
        for (var Ua in r)
          if (Q.call(r, Ua)) {
            var $u = r[Ua];
            if ($u != null)
              switch (Ua) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(R(400));
                default:
                  m(
                    n,
                    Ua,
                    $u
                  );
              }
          }
        return n.push(ln), null;
      case "object":
        n.push(sn("object"));
        var Vi = null, nc = null, Ki;
        for (Ki in r)
          if (Q.call(r, Ki)) {
            var mi = r[Ki];
            if (mi != null)
              switch (Ki) {
                case "children":
                  Vi = mi;
                  break;
                case "dangerouslySetInnerHTML":
                  nc = mi;
                  break;
                case "data":
                  var lc = Pe("" + mi);
                  if (lc === "") break;
                  n.push(
                    Fn,
                    I("data"),
                    ll,
                    I(N(lc)),
                    un
                  );
                  break;
                default:
                  m(
                    n,
                    Ki,
                    mi
                  );
              }
          }
        if (n.push(ln), mn(n, nc, Vi), typeof Vi == "string") {
          n.push(
            I(N(Vi))
          );
          var ec = null;
        } else ec = Vi;
        return ec;
      case "title":
        var Ac = b.tagScope & 1, Pc = b.tagScope & 4;
        if (b.insertionMode === 4 || Ac || r.itemProp != null)
          var Iu = $t(
            n,
            r
          );
        else
          Pc ? Iu = null : ($t(c.hoistableChunks, r), Iu = void 0);
        return Iu;
      case "link":
        var Mc = b.tagScope & 1, Ic = b.tagScope & 4, _c = r.rel, pe = r.href, Ga = r.precedence;
        if (b.insertionMode === 4 || Mc || r.itemProp != null || typeof _c != "string" || typeof pe != "string" || pe === "") {
          vn(n, r);
          var qi = null;
        } else if (r.rel === "stylesheet")
          if (typeof Ga != "string" || r.disabled != null || r.onLoad || r.onError)
            qi = vn(
              n,
              r
            );
          else {
            var Or = c.styles.get(Ga), Ya = a.styleResources.hasOwnProperty(pe) ? a.styleResources[pe] : void 0;
            if (Ya !== null) {
              a.styleResources[pe] = null, Or || (Or = {
                precedence: I(N(Ga)),
                rules: [],
                hrefs: [],
                sheets: /* @__PURE__ */ new Map()
              }, c.styles.set(Ga, Or));
              var Xa = {
                state: 0,
                props: Un({}, r, {
                  "data-precedence": r.precedence,
                  precedence: null
                })
              };
              if (Ya) {
                Ya.length === 2 && he(Xa.props, Ya);
                var _u = c.preloads.stylesheets.get(pe);
                _u && 0 < _u.length ? _u.length = 0 : Xa.state = 1;
              }
              Or.sheets.set(pe, Xa), d && d.stylesheets.add(Xa);
            } else if (Or) {
              var tc = Or.sheets.get(pe);
              tc && d && d.stylesheets.add(tc);
            }
            g && n.push(ol), qi = null;
          }
        else
          r.onLoad || r.onError ? qi = vn(
            n,
            r
          ) : (g && n.push(ol), qi = Ic ? null : vn(c.hoistableChunks, r));
        return qi;
      case "script":
        var kc = b.tagScope & 1, ku = r.async;
        if (typeof r.src != "string" || !r.src || !ku || typeof ku == "function" || typeof ku == "symbol" || r.onLoad || r.onError || b.insertionMode === 4 || kc || r.itemProp != null)
          var rc = nr(
            n,
            r
          );
        else {
          var Za = r.src;
          if (r.type === "module")
            var Ja = a.moduleScriptResources, ic = c.preloads.moduleScripts;
          else
            Ja = a.scriptResources, ic = c.preloads.scripts;
          var Qa = Ja.hasOwnProperty(Za) ? Ja[Za] : void 0;
          if (Qa !== null) {
            Ja[Za] = null;
            var Ou = r;
            if (Qa) {
              Qa.length === 2 && (Ou = Un({}, r), he(Ou, Qa));
              var ac = ic.get(Za);
              ac && (ac.length = 0);
            }
            var uc = [];
            c.scripts.add(uc), nr(uc, Ou);
          }
          g && n.push(ol), rc = null;
        }
        return rc;
      case "style":
        var Oc = b.tagScope & 1, Va = r.precedence, Lr = r.href, Lc = r.nonce;
        if (b.insertionMode === 4 || Oc || r.itemProp != null || typeof Va != "string" || typeof Lr != "string" || Lr === "") {
          n.push(sn("style"));
          var Br = null, cc = null, pi;
          for (pi in r)
            if (Q.call(r, pi)) {
              var Ka = r[pi];
              if (Ka != null)
                switch (pi) {
                  case "children":
                    Br = Ka;
                    break;
                  case "dangerouslySetInnerHTML":
                    cc = Ka;
                    break;
                  default:
                    m(
                      n,
                      pi,
                      Ka
                    );
                }
            }
          n.push(ln);
          var ji = Array.isArray(Br) ? 2 > Br.length ? Br[0] : null : Br;
          typeof ji != "function" && typeof ji != "symbol" && ji !== null && ji !== void 0 && n.push(
            I(("" + ji).replace(pt, jt))
          ), mn(n, cc, Br), n.push(Dl("style"));
          var fc = null;
        } else {
          var zt = c.styles.get(Va);
          if ((a.styleResources.hasOwnProperty(Lr) ? a.styleResources[Lr] : void 0) !== null) {
            a.styleResources[Lr] = null, zt || (zt = {
              precedence: I(
                N(Va)
              ),
              rules: [],
              hrefs: [],
              sheets: /* @__PURE__ */ new Map()
            }, c.styles.set(Va, zt));
            var hc = c.nonce.style;
            if (!hc || hc === Lc) {
              zt.hrefs.push(
                I(N(Lr))
              );
              var oc = zt.rules, Nr = null, dc = null, ma;
              for (ma in r)
                if (Q.call(r, ma)) {
                  var Lu = r[ma];
                  if (Lu != null)
                    switch (ma) {
                      case "children":
                        Nr = Lu;
                        break;
                      case "dangerouslySetInnerHTML":
                        dc = Lu;
                    }
                }
              var $i = Array.isArray(Nr) ? 2 > Nr.length ? Nr[0] : null : Nr;
              typeof $i != "function" && typeof $i != "symbol" && $i !== null && $i !== void 0 && oc.push(
                I(
                  ("" + $i).replace(pt, jt)
                )
              ), mn(oc, dc, Nr);
            }
          }
          zt && d && d.styles.add(zt), g && n.push(ol), fc = void 0;
        }
        return fc;
      case "meta":
        var Bc = b.tagScope & 1, Nc = b.tagScope & 4;
        if (b.insertionMode === 4 || Bc || r.itemProp != null)
          var sc = Nl(
            n,
            r,
            "meta"
          );
        else
          g && n.push(ol), sc = Nc ? null : typeof r.charSet == "string" ? Nl(c.charsetChunks, r, "meta") : r.name === "viewport" ? Nl(c.viewportChunks, r, "meta") : Nl(c.hoistableChunks, r, "meta");
        return sc;
      case "listing":
      case "pre":
        n.push(sn(e));
        var na = null, la = null, ea;
        for (ea in r)
          if (Q.call(r, ea)) {
            var qa = r[ea];
            if (qa != null)
              switch (ea) {
                case "children":
                  na = qa;
                  break;
                case "dangerouslySetInnerHTML":
                  la = qa;
                  break;
                default:
                  m(
                    n,
                    ea,
                    qa
                  );
              }
          }
        if (n.push(ln), la != null) {
          if (na != null) throw Error(R(60));
          if (typeof la != "object" || !("__html" in la))
            throw Error(R(61));
          var Dt = la.__html;
          Dt != null && (typeof Dt == "string" && 0 < Dt.length && Dt[0] === `
` ? n.push(ii, I(Dt)) : n.push(I("" + Dt)));
        }
        return typeof na == "string" && na[0] === `
` && n.push(ii), na;
      case "img":
        var zc = b.tagScope & 3, Xn = r.src, Hn = r.srcSet;
        if (!(r.loading === "lazy" || !Xn && !Hn || typeof Xn != "string" && Xn != null || typeof Hn != "string" && Hn != null || r.fetchPriority === "low" || zc) && (typeof Xn != "string" || Xn[4] !== ":" || Xn[0] !== "d" && Xn[0] !== "D" || Xn[1] !== "a" && Xn[1] !== "A" || Xn[2] !== "t" && Xn[2] !== "T" || Xn[3] !== "a" && Xn[3] !== "A") && (typeof Hn != "string" || Hn[4] !== ":" || Hn[0] !== "d" && Hn[0] !== "D" || Hn[1] !== "a" && Hn[1] !== "A" || Hn[2] !== "t" && Hn[2] !== "T" || Hn[3] !== "a" && Hn[3] !== "A")) {
          d !== null && b.tagScope & 64 && (d.suspenseyImages = !0);
          var gc = typeof r.sizes == "string" ? r.sizes : void 0, zr = Hn ? Hn + `
` + (gc || "") : Xn, Bu = c.preloads.images, Ht = Bu.get(zr);
          if (Ht)
            (r.fetchPriority === "high" || 10 > c.highImagePreloads.size) && (Bu.delete(zr), c.highImagePreloads.add(Ht));
          else if (!a.imageResources.hasOwnProperty(zr)) {
            a.imageResources[zr] = Qn;
            var Nu = r.crossOrigin, vc = typeof Nu == "string" ? Nu === "use-credentials" ? Nu : "" : void 0, Wt = c.headers, zu;
            Wt && 0 < Wt.remainingCapacity && typeof r.srcSet != "string" && (r.fetchPriority === "high" || 500 > Wt.highImagePreloads.length) && (zu = Tt(Xn, "image", {
              imageSrcSet: r.srcSet,
              imageSizes: r.sizes,
              crossOrigin: vc,
              integrity: r.integrity,
              nonce: r.nonce,
              type: r.type,
              fetchPriority: r.fetchPriority,
              referrerPolicy: r.refererPolicy
            }), 0 <= (Wt.remainingCapacity -= zu.length + 2)) ? (c.resets.image[zr] = Qn, Wt.highImagePreloads && (Wt.highImagePreloads += ", "), Wt.highImagePreloads += zu) : (Ht = [], vn(Ht, {
              rel: "preload",
              as: "image",
              href: Hn ? void 0 : Xn,
              imageSrcSet: Hn,
              imageSizes: gc,
              crossOrigin: vc,
              integrity: r.integrity,
              type: r.type,
              fetchPriority: r.fetchPriority,
              referrerPolicy: r.referrerPolicy
            }), r.fetchPriority === "high" || 10 > c.highImagePreloads.size ? c.highImagePreloads.add(Ht) : (c.bulkPreloads.add(Ht), Bu.set(zr, Ht)));
          }
        }
        return Nl(n, r, "img");
      case "base":
      case "area":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "param":
      case "source":
      case "track":
      case "wbr":
        return Nl(n, r, e);
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        break;
      case "head":
        if (2 > b.insertionMode) {
          var Du = h || c.preamble;
          if (Du.headChunks)
            throw Error(R(545, "`<head>`"));
          h !== null && n.push(au), Du.headChunks = [];
          var bc = lr(
            Du.headChunks,
            r,
            "head"
          );
        } else
          bc = zl(
            n,
            r,
            "head"
          );
        return bc;
      case "body":
        if (2 > b.insertionMode) {
          var Hu = h || c.preamble;
          if (Hu.bodyChunks)
            throw Error(R(545, "`<body>`"));
          h !== null && n.push(uu), Hu.bodyChunks = [];
          var yc = lr(
            Hu.bodyChunks,
            r,
            "body"
          );
        } else
          yc = zl(
            n,
            r,
            "body"
          );
        return yc;
      case "html":
        if (b.insertionMode === 0) {
          var Wu = h || c.preamble;
          if (Wu.htmlChunks)
            throw Error(R(545, "`<html>`"));
          h !== null && n.push(_e), Wu.htmlChunks = [ae];
          var Tc = lr(
            Wu.htmlChunks,
            r,
            "html"
          );
        } else
          Tc = zl(
            n,
            r,
            "html"
          );
        return Tc;
      default:
        if (e.indexOf("-") !== -1) {
          n.push(sn(e));
          var Uu = null, Ec = null, Dr;
          for (Dr in r)
            if (Q.call(r, Dr)) {
              var Ol = r[Dr];
              if (Ol != null) {
                var xc = Dr;
                switch (Dr) {
                  case "children":
                    Uu = Ol;
                    break;
                  case "dangerouslySetInnerHTML":
                    Ec = Ol;
                    break;
                  case "style":
                    rt(n, Ol);
                    break;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "ref":
                    break;
                  case "className":
                    xc = "class";
                  default:
                    if (Zt(Dr) && typeof Ol != "function" && typeof Ol != "symbol" && Ol !== !1) {
                      if (Ol === !0) Ol = "";
                      else if (typeof Ol == "object") continue;
                      n.push(
                        Fn,
                        I(xc),
                        ll,
                        I(N(Ol)),
                        un
                      );
                    }
                }
              }
            }
          return n.push(ln), mn(n, Ec, Uu), Uu;
        }
    }
    return zl(n, r, e);
  }
  var ai = /* @__PURE__ */ new Map();
  function Dl(n) {
    var e = ai.get(n);
    return e === void 0 && (e = C("</" + n + ">"), ai.set(n, e)), e;
  }
  function ui(n, e) {
    n = n.preamble, n.htmlChunks === null && e.htmlChunks && (n.htmlChunks = e.htmlChunks), n.headChunks === null && e.headChunks && (n.headChunks = e.headChunks), n.bodyChunks === null && e.bodyChunks && (n.bodyChunks = e.bodyChunks);
  }
  function ci(n, e) {
    e = e.bootstrapChunks;
    for (var r = 0; r < e.length - 1; r++)
      F(n, e[r]);
    return r < e.length ? (r = e[r], e.length = 0, k(n, r)) : !0;
  }
  var Hl = C(
    "requestAnimationFrame(function(){$RT=performance.now()});"
  ), xa = C('<template id="'), fu = C('"></template>'), ue = C("<!--&-->"), tr = C("<!--/&-->"), hu = C("<!--$-->"), ou = C(
    '<!--$?--><template id="'
  ), du = C('"></template>'), Nn = C("<!--$!-->"), qn = C("<!--/$-->"), su = C("<template"), rr = C('"'), ir = C(' data-dgst="');
  C(' data-msg="'), C(' data-stck="'), C(' data-cstck="');
  var gu = C("></template>");
  function wa(n, e, r) {
    if (F(n, ou), r === null) throw Error(R(395));
    return F(n, e.boundaryPrefix), F(n, I(r.toString(16))), k(n, du);
  }
  var El = C('<div hidden id="'), fi = C('">'), hi = C("</div>"), oi = C(
    '<svg aria-hidden="true" style="display:none" id="'
  ), ar = C('">'), j = C("</svg>"), ft = C(
    '<math aria-hidden="true" style="display:none" id="'
  ), ur = C('">'), ht = C("</math>"), ot = C('<table hidden id="'), dt = C('">'), cr = C("</table>"), ke = C('<table hidden><tbody id="'), Wl = C('">'), fr = C("</tbody></table>"), xl = C('<table hidden><tr id="'), Ra = C('">'), di = C("</tr></table>"), Oe = C(
    '<table hidden><colgroup id="'
  ), st = C('">'), Ca = C("</colgroup></table>");
  function Fa(n, e, r, a) {
    switch (r.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return F(n, El), F(n, e.segmentPrefix), F(n, I(a.toString(16))), k(n, fi);
      case 4:
        return F(n, oi), F(n, e.segmentPrefix), F(n, I(a.toString(16))), k(n, ar);
      case 5:
        return F(n, ft), F(n, e.segmentPrefix), F(n, I(a.toString(16))), k(n, ur);
      case 6:
        return F(n, ot), F(n, e.segmentPrefix), F(n, I(a.toString(16))), k(n, dt);
      case 7:
        return F(n, ke), F(n, e.segmentPrefix), F(n, I(a.toString(16))), k(n, Wl);
      case 8:
        return F(n, xl), F(n, e.segmentPrefix), F(n, I(a.toString(16))), k(n, Ra);
      case 9:
        return F(n, Oe), F(n, e.segmentPrefix), F(n, I(a.toString(16))), k(n, st);
      default:
        throw Error(R(397));
    }
  }
  function Sa(n, e) {
    switch (e.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return k(n, hi);
      case 4:
        return k(n, j);
      case 5:
        return k(n, ht);
      case 6:
        return k(n, cr);
      case 7:
        return k(n, fr);
      case 8:
        return k(n, di);
      case 9:
        return k(n, Ca);
      default:
        throw Error(R(397));
    }
  }
  var vu = C(
    '$RS=function(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'
  ), bu = C('$RS("'), yu = C('","'), Tu = C('")<\/script>');
  C('<template data-rsi="" data-sid="'), C('" data-pid="');
  var si = C(
    `$RB=[];$RV=function(a){$RT=performance.now();for(var b=0;b<a.length;b+=2){var c=a[b],e=a[b+1];null!==e.parentNode&&e.parentNode.removeChild(e);var f=c.parentNode;if(f){var g=c.previousSibling,h=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d||"/&"===d)if(0===h)break;else h--;else"$"!==d&&"$?"!==d&&"$~"!==d&&"$!"!==d&&"&"!==d||h++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;e.firstChild;)f.insertBefore(e.firstChild,c);g.data="$";g._reactRetry&&requestAnimationFrame(g._reactRetry)}}a.length=0};
$RC=function(a,b){if(b=document.getElementById(b))(a=document.getElementById(a))?(a.previousSibling.data="$~",$RB.push(a,b),2===$RB.length&&("number"!==typeof $RT?requestAnimationFrame($RV.bind(null,$RB)):(a=performance.now(),setTimeout($RV.bind(null,$RB),2300>a&&2E3<a?2300-a:$RT+300-a)))):b.parentNode.removeChild(b)};`
  );
  I(
    `$RV=function(A,g){function k(a,b){var e=a.getAttribute(b);e&&(b=a.style,l.push(a,b.viewTransitionName,b.viewTransitionClass),"auto"!==e&&(b.viewTransitionClass=e),(a=a.getAttribute("vt-name"))||(a="_T_"+K++ +"_"),b.viewTransitionName=a,B=!0)}var B=!1,K=0,l=[];try{var f=document.__reactViewTransition;if(f){f.finished.finally($RV.bind(null,g));return}var m=new Map;for(f=1;f<g.length;f+=2)for(var h=g[f].querySelectorAll("[vt-share]"),d=0;d<h.length;d++){var c=h[d];m.set(c.getAttribute("vt-name"),c)}var u=[];for(h=0;h<g.length;h+=2){var C=g[h],x=C.parentNode;if(x){var v=x.getBoundingClientRect();if(v.left||v.top||v.width||v.height){c=C;for(f=0;c;){if(8===c.nodeType){var r=c.data;if("/$"===r)if(0===f)break;else f--;else"$"!==r&&"$?"!==r&&"$~"!==r&&"$!"!==r||f++}else if(1===c.nodeType){d=c;var D=d.getAttribute("vt-name"),y=m.get(D);k(d,y?"vt-share":"vt-exit");y&&(k(y,"vt-share"),m.set(D,null));var E=d.querySelectorAll("[vt-share]");for(d=0;d<E.length;d++){var F=E[d],G=F.getAttribute("vt-name"),
H=m.get(G);H&&(k(F,"vt-share"),k(H,"vt-share"),m.set(G,null))}}c=c.nextSibling}for(var I=g[h+1],t=I.firstElementChild;t;)null!==m.get(t.getAttribute("vt-name"))&&k(t,"vt-enter"),t=t.nextElementSibling;c=x;do for(var n=c.firstElementChild;n;){var J=n.getAttribute("vt-update");J&&"none"!==J&&!l.includes(n)&&k(n,"vt-update");n=n.nextElementSibling}while((c=c.parentNode)&&1===c.nodeType&&"none"!==c.getAttribute("vt-update"));u.push.apply(u,I.querySelectorAll('img[src]:not([loading="lazy"])'))}}}if(B){var z=
document.__reactViewTransition=document.startViewTransition({update:function(){A(g);for(var a=[document.documentElement.clientHeight,document.fonts.ready],b={},e=0;e<u.length;b={g:b.g},e++)if(b.g=u[e],!b.g.complete){var p=b.g.getBoundingClientRect();0<p.bottom&&0<p.right&&p.top<window.innerHeight&&p.left<window.innerWidth&&(p=new Promise(function(w){return function(q){w.g.addEventListener("load",q);w.g.addEventListener("error",q)}}(b)),a.push(p))}return Promise.race([Promise.all(a),new Promise(function(w){var q=
performance.now();setTimeout(w,2300>q&&2E3<q?2300-q:500)})])},types:[]});z.ready.finally(function(){for(var a=l.length-3;0<=a;a-=3){var b=l[a],e=b.style;e.viewTransitionName=l[a+1];e.viewTransitionClass=l[a+1];""===b.getAttribute("style")&&b.removeAttribute("style")}});z.finished.finally(function(){document.__reactViewTransition===z&&(document.__reactViewTransition=null)});$RB=[];return}}catch(a){}A(g)}.bind(null,$RV);`
  );
  var Aa = C('$RC("'), Eu = C(
    `$RM=new Map;$RR=function(n,w,p){function u(q){this._p=null;q()}for(var r=new Map,t=document,h,b,e=t.querySelectorAll("link[data-precedence],style[data-precedence]"),v=[],k=0;b=e[k++];)"not all"===b.getAttribute("media")?v.push(b):("LINK"===b.tagName&&$RM.set(b.getAttribute("href"),b),r.set(b.dataset.precedence,h=b));e=0;b=[];var l,a;for(k=!0;;){if(k){var f=p[e++];if(!f){k=!1;e=0;continue}var c=!1,m=0;var d=f[m++];if(a=$RM.get(d)){var g=a._p;c=!0}else{a=t.createElement("link");a.href=d;a.rel=
"stylesheet";for(a.dataset.precedence=l=f[m++];g=f[m++];)a.setAttribute(g,f[m++]);g=a._p=new Promise(function(q,x){a.onload=u.bind(a,q);a.onerror=u.bind(a,x)});$RM.set(d,a)}d=a.getAttribute("media");!g||d&&!matchMedia(d).matches||b.push(g);if(c)continue}else{a=v[e++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=r.get(l)||h;c===h&&(h=a);r.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=t.head,c.insertBefore(a,c.firstChild))}if(p=document.getElementById(n))p.previousSibling.data=
"$~";Promise.all(b).then($RC.bind(null,n,w),$RX.bind(null,n,"CSS failed to load"))};$RR("`
  ), Pa = C('$RR("'), hr = C('","'), xu = C('",'), gi = C('"'), Ma = C(")<\/script>");
  C('<template data-rci="" data-bid="'), C('<template data-rri="" data-bid="'), C('" data-sid="'), C('" data-sty="');
  var Le = C(
    '$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};'
  ), vi = C(
    '$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};;$RX("'
  ), or = C('$RX("'), Ia = C('"'), Be = C(","), wu = C(")<\/script>");
  C('<template data-rxi="" data-bid="'), C('" data-dgst="'), C('" data-msg="'), C('" data-stck="'), C('" data-cstck="');
  var Ru = /[<\u2028\u2029]/g;
  function Cu(n) {
    return JSON.stringify(n).replace(
      Ru,
      function(e) {
        switch (e) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var Sn = /[&><\u2028\u2029]/g;
  function Ne(n) {
    return JSON.stringify(n).replace(
      Sn,
      function(e) {
        switch (e) {
          case "&":
            return "\\u0026";
          case ">":
            return "\\u003e";
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSObjectForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var bi = C(
    ' media="not all" data-precedence="'
  ), dr = C('" data-href="'), _a = C('">'), ce = C("</style>"), Ul = !1, gt = !0;
  function Gl(n) {
    var e = n.rules, r = n.hrefs, a = 0;
    if (r.length) {
      for (F(this, ie.startInlineStyle), F(this, bi), F(this, n.precedence), F(this, dr); a < r.length - 1; a++)
        F(this, r[a]), F(this, Ti);
      for (F(this, r[a]), F(this, _a), a = 0; a < e.length; a++) F(this, e[a]);
      gt = k(
        this,
        ce
      ), Ul = !0, e.length = 0, r.length = 0;
    }
  }
  function _n(n) {
    return n.state !== 2 ? Ul = !0 : !1;
  }
  function ze(n, e, r) {
    return Ul = !1, gt = !0, ie = r, e.styles.forEach(Gl, n), ie = null, e.stylesheets.forEach(_n), Ul && (r.stylesToHoist = !0), gt;
  }
  function $(n) {
    for (var e = 0; e < n.length; e++) F(this, n[e]);
    n.length = 0;
  }
  var gl = [];
  function yi(n) {
    vn(gl, n.props);
    for (var e = 0; e < gl.length; e++)
      F(this, gl[e]);
    gl.length = 0, n.state = 2;
  }
  var vt = C(' data-precedence="'), ka = C('" data-href="'), Ti = C(" "), Oa = C('">'), sr = C("</style>");
  function gr(n) {
    var e = 0 < n.sheets.size;
    n.sheets.forEach(yi, this), n.sheets.clear();
    var r = n.rules, a = n.hrefs;
    if (!e || a.length) {
      if (F(this, ie.startInlineStyle), F(this, vt), F(this, n.precedence), n = 0, a.length) {
        for (F(this, ka); n < a.length - 1; n++)
          F(this, a[n]), F(this, Ti);
        F(this, a[n]);
      }
      for (F(this, Oa), n = 0; n < r.length; n++)
        F(this, r[n]);
      F(this, sr), r.length = 0, a.length = 0;
    }
  }
  function el(n) {
    if (n.state === 0) {
      n.state = 1;
      var e = n.props;
      for (vn(gl, {
        rel: "preload",
        as: "style",
        href: n.props.href,
        crossOrigin: e.crossOrigin,
        fetchPriority: e.fetchPriority,
        integrity: e.integrity,
        media: e.media,
        hrefLang: e.hrefLang,
        referrerPolicy: e.referrerPolicy
      }), n = 0; n < gl.length; n++)
        F(this, gl[n]);
      gl.length = 0;
    }
  }
  function Ei(n) {
    n.sheets.forEach(el, this), n.sheets.clear();
  }
  C('<link rel="expect" href="#'), C('" blocking="render"/>');
  var vr = C(' id="');
  function bt(n, e) {
    (e.instructions & 32) === 0 && (e.instructions |= 32, n.push(
      vr,
      I(N("_" + e.idPrefix + "R_")),
      un
    ));
  }
  var br = C("["), yr = C(",["), Tr = C(","), Er = C("]");
  function Tn(n, e) {
    F(n, br);
    var r = br;
    e.stylesheets.forEach(function(a) {
      if (a.state !== 2)
        if (a.state === 3)
          F(n, r), F(
            n,
            I(
              Ne("" + a.props.href)
            )
          ), F(n, Er), r = yr;
        else {
          F(n, r);
          var c = a.props["data-precedence"], h = a.props, d = Pe("" + a.props.href);
          F(
            n,
            I(Ne(d))
          ), c = "" + c, F(n, Tr), F(
            n,
            I(Ne(c))
          );
          for (var b in h)
            if (Q.call(h, b) && (c = h[b], c != null))
              switch (b) {
                case "href":
                case "rel":
                case "precedence":
                case "data-precedence":
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(R(399, "link"));
                default:
                  Fu(
                    n,
                    b,
                    c
                  );
              }
          F(n, Er), r = yr, a.state = 3;
        }
    }), F(n, Er);
  }
  function Fu(n, e, r) {
    var a = e.toLowerCase();
    switch (typeof r) {
      case "function":
      case "symbol":
        return;
    }
    switch (e) {
      case "innerHTML":
      case "dangerouslySetInnerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "style":
      case "ref":
        return;
      case "className":
        a = "class", e = "" + r;
        break;
      case "hidden":
        if (r === !1) return;
        e = "";
        break;
      case "src":
      case "href":
        r = Pe(r), e = "" + r;
        break;
      default:
        if (2 < e.length && (e[0] === "o" || e[0] === "O") && (e[1] === "n" || e[1] === "N") || !Zt(e))
          return;
        e = "" + r;
    }
    F(n, Tr), F(
      n,
      I(Ne(a))
    ), F(n, Tr), F(
      n,
      I(Ne(e))
    );
  }
  function fe() {
    return { styles: /* @__PURE__ */ new Set(), stylesheets: /* @__PURE__ */ new Set(), suspenseyImages: !1 };
  }
  function xi(n) {
    var e = yn || null;
    if (e) {
      var r = e.resumableState, a = e.renderState;
      if (typeof n == "string" && n) {
        if (!r.dnsResources.hasOwnProperty(n)) {
          r.dnsResources[n] = null, r = a.headers;
          var c, h;
          (h = r && 0 < r.remainingCapacity) && (h = (c = "<" + ("" + n).replace(
            oe,
            De
          ) + ">; rel=dns-prefetch", 0 <= (r.remainingCapacity -= c.length + 2))), h ? (a.resets.dns[n] = null, r.preconnects && (r.preconnects += ", "), r.preconnects += c) : (c = [], vn(c, { href: n, rel: "dns-prefetch" }), a.preconnects.add(c));
        }
        Il(e);
      }
    } else hl.D(n);
  }
  function wi(n, e) {
    var r = yn || null;
    if (r) {
      var a = r.resumableState, c = r.renderState;
      if (typeof n == "string" && n) {
        var h = e === "use-credentials" ? "credentials" : typeof e == "string" ? "anonymous" : "default";
        if (!a.connectResources[h].hasOwnProperty(n)) {
          a.connectResources[h][n] = null, a = c.headers;
          var d, b;
          if (b = a && 0 < a.remainingCapacity) {
            if (b = "<" + ("" + n).replace(
              oe,
              De
            ) + ">; rel=preconnect", typeof e == "string") {
              var g = ("" + e).replace(
                de,
                se
              );
              b += '; crossorigin="' + g + '"';
            }
            b = (d = b, 0 <= (a.remainingCapacity -= d.length + 2));
          }
          b ? (c.resets.connect[h][n] = null, a.preconnects && (a.preconnects += ", "), a.preconnects += d) : (h = [], vn(h, {
            rel: "preconnect",
            href: n,
            crossOrigin: e
          }), c.preconnects.add(h));
        }
        Il(r);
      }
    } else hl.C(n, e);
  }
  function Ri(n, e, r) {
    var a = yn || null;
    if (a) {
      var c = a.resumableState, h = a.renderState;
      if (e && n) {
        switch (e) {
          case "image":
            if (r)
              var d = r.imageSrcSet, b = r.imageSizes, g = r.fetchPriority;
            var y = d ? d + `
` + (b || "") : n;
            if (c.imageResources.hasOwnProperty(y)) return;
            c.imageResources[y] = Qn, c = h.headers;
            var T;
            c && 0 < c.remainingCapacity && typeof d != "string" && g === "high" && (T = Tt(n, e, r), 0 <= (c.remainingCapacity -= T.length + 2)) ? (h.resets.image[y] = Qn, c.highImagePreloads && (c.highImagePreloads += ", "), c.highImagePreloads += T) : (c = [], vn(
              c,
              Un(
                { rel: "preload", href: d ? void 0 : n, as: e },
                r
              )
            ), g === "high" ? h.highImagePreloads.add(c) : (h.bulkPreloads.add(c), h.preloads.images.set(y, c)));
            break;
          case "style":
            if (c.styleResources.hasOwnProperty(n)) return;
            d = [], vn(
              d,
              Un({ rel: "preload", href: n, as: e }, r)
            ), c.styleResources[n] = !r || typeof r.crossOrigin != "string" && typeof r.integrity != "string" ? Qn : [r.crossOrigin, r.integrity], h.preloads.stylesheets.set(n, d), h.bulkPreloads.add(d);
            break;
          case "script":
            if (c.scriptResources.hasOwnProperty(n)) return;
            d = [], h.preloads.scripts.set(n, d), h.bulkPreloads.add(d), vn(
              d,
              Un({ rel: "preload", href: n, as: e }, r)
            ), c.scriptResources[n] = !r || typeof r.crossOrigin != "string" && typeof r.integrity != "string" ? Qn : [r.crossOrigin, r.integrity];
            break;
          default:
            if (c.unknownResources.hasOwnProperty(e)) {
              if (d = c.unknownResources[e], d.hasOwnProperty(n))
                return;
            } else
              d = {}, c.unknownResources[e] = d;
            if (d[n] = Qn, (c = h.headers) && 0 < c.remainingCapacity && e === "font" && (y = Tt(n, e, r), 0 <= (c.remainingCapacity -= y.length + 2)))
              h.resets.font[n] = Qn, c.fontPreloads && (c.fontPreloads += ", "), c.fontPreloads += y;
            else
              switch (c = [], n = Un({ rel: "preload", href: n, as: e }, r), vn(c, n), e) {
                case "font":
                  h.fontPreloads.add(c);
                  break;
                default:
                  h.bulkPreloads.add(c);
              }
        }
        Il(a);
      }
    } else hl.L(n, e, r);
  }
  function xr(n, e) {
    var r = yn || null;
    if (r) {
      var a = r.resumableState, c = r.renderState;
      if (n) {
        var h = e && typeof e.as == "string" ? e.as : "script";
        switch (h) {
          case "script":
            if (a.moduleScriptResources.hasOwnProperty(n)) return;
            h = [], a.moduleScriptResources[n] = !e || typeof e.crossOrigin != "string" && typeof e.integrity != "string" ? Qn : [e.crossOrigin, e.integrity], c.preloads.moduleScripts.set(n, h);
            break;
          default:
            if (a.moduleUnknownResources.hasOwnProperty(h)) {
              var d = a.unknownResources[h];
              if (d.hasOwnProperty(n)) return;
            } else
              d = {}, a.moduleUnknownResources[h] = d;
            h = [], d[n] = Qn;
        }
        vn(h, Un({ rel: "modulepreload", href: n }, e)), c.bulkPreloads.add(h), Il(r);
      }
    } else hl.m(n, e);
  }
  function yt(n, e, r) {
    var a = yn || null;
    if (a) {
      var c = a.resumableState, h = a.renderState;
      if (n) {
        e = e || "default";
        var d = h.styles.get(e), b = c.styleResources.hasOwnProperty(n) ? c.styleResources[n] : void 0;
        b !== null && (c.styleResources[n] = null, d || (d = {
          precedence: I(N(e)),
          rules: [],
          hrefs: [],
          sheets: /* @__PURE__ */ new Map()
        }, h.styles.set(e, d)), e = {
          state: 0,
          props: Un(
            { rel: "stylesheet", href: n, "data-precedence": e },
            r
          )
        }, b && (b.length === 2 && he(e.props, b), (h = h.preloads.stylesheets.get(n)) && 0 < h.length ? h.length = 0 : e.state = 1), d.sheets.set(n, e), Il(a));
      }
    } else hl.S(n, e, r);
  }
  function Yl(n, e) {
    var r = yn || null;
    if (r) {
      var a = r.resumableState, c = r.renderState;
      if (n) {
        var h = a.scriptResources.hasOwnProperty(n) ? a.scriptResources[n] : void 0;
        h !== null && (a.scriptResources[n] = null, e = Un({ src: n, async: !0 }, e), h && (h.length === 2 && he(e, h), n = c.preloads.scripts.get(n)) && (n.length = 0), n = [], c.scripts.add(n), nr(n, e), Il(r));
      }
    } else hl.X(n, e);
  }
  function La(n, e) {
    var r = yn || null;
    if (r) {
      var a = r.resumableState, c = r.renderState;
      if (n) {
        var h = a.moduleScriptResources.hasOwnProperty(
          n
        ) ? a.moduleScriptResources[n] : void 0;
        h !== null && (a.moduleScriptResources[n] = null, e = Un({ src: n, type: "module", async: !0 }, e), h && (h.length === 2 && he(e, h), n = c.preloads.moduleScripts.get(n)) && (n.length = 0), n = [], c.scripts.add(n), nr(n, e), Il(r));
      }
    } else hl.M(n, e);
  }
  function he(n, e) {
    n.crossOrigin == null && (n.crossOrigin = e[0]), n.integrity == null && (n.integrity = e[1]);
  }
  function Tt(n, e, r) {
    n = ("" + n).replace(
      oe,
      De
    ), e = ("" + e).replace(
      de,
      se
    ), e = "<" + n + '>; rel=preload; as="' + e + '"';
    for (var a in r)
      Q.call(r, a) && (n = r[a], typeof n == "string" && (e += "; " + a.toLowerCase() + '="' + ("" + n).replace(
        de,
        se
      ) + '"'));
    return e;
  }
  var oe = /[<>\r\n]/g;
  function De(n) {
    switch (n) {
      case "<":
        return "%3C";
      case ">":
        return "%3E";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeLinkHrefForHeaderContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  var de = /["';,\r\n]/g;
  function se(n) {
    switch (n) {
      case '"':
        return "%22";
      case "'":
        return "%27";
      case ";":
        return "%3B";
      case ",":
        return "%2C";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeStringForLinkHeaderQuotedParamValueContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  function Ci(n) {
    this.styles.add(n);
  }
  function Ba(n) {
    this.stylesheets.add(n);
  }
  function ge(n, e) {
    e.styles.forEach(Ci, n), e.stylesheets.forEach(Ba, n), e.suspenseyImages && (n.suspenseyImages = !0);
  }
  function Et(n) {
    return 0 < n.stylesheets.size || n.suspenseyImages;
  }
  var wr = Function.prototype.bind, ve = Symbol.for("react.client.reference");
  function Rr(n) {
    if (n == null) return null;
    if (typeof n == "function")
      return n.$$typeof === ve ? null : n.displayName || n.name || null;
    if (typeof n == "string") return n;
    switch (n) {
      case Yt:
        return "Fragment";
      case Wr:
        return "Profiler";
      case Hr:
        return "StrictMode";
      case le:
        return "Suspense";
      case nt:
        return "SuspenseList";
      case Gr:
        return "Activity";
    }
    if (typeof n == "object")
      switch (n.$$typeof) {
        case je:
          return "Portal";
        case ne:
          return n.displayName || "Context";
        case Ur:
          return (n._context.displayName || "Context") + ".Consumer";
        case $e:
          var e = n.render;
          return n = n.displayName, n || (n = e.displayName || e.name || "", n = n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef"), n;
        case lt:
          return e = n.displayName || null, e !== null ? e : Rr(n.type) || "Memo";
        case ee:
          e = n._payload, n = n._init;
          try {
            return Rr(n(e));
          } catch {
          }
      }
    return null;
  }
  var Na = {}, vl = null;
  function Cr(n, e) {
    if (n !== e) {
      n.context._currentValue = n.parentValue, n = n.parent;
      var r = e.parent;
      if (n === null) {
        if (r !== null) throw Error(R(401));
      } else {
        if (r === null) throw Error(R(401));
        Cr(n, r);
      }
      e.context._currentValue = e.value;
    }
  }
  function Fi(n) {
    n.context._currentValue = n.parentValue, n = n.parent, n !== null && Fi(n);
  }
  function l(n) {
    var e = n.parent;
    e !== null && l(e), n.context._currentValue = n.value;
  }
  function t(n, e) {
    if (n.context._currentValue = n.parentValue, n = n.parent, n === null) throw Error(R(402));
    n.depth === e.depth ? Cr(n, e) : t(n, e);
  }
  function i(n, e) {
    var r = e.parent;
    if (r === null) throw Error(R(402));
    n.depth === r.depth ? Cr(n, r) : i(n, r), e.context._currentValue = e.value;
  }
  function u(n) {
    var e = vl;
    e !== n && (e === null ? l(n) : n === null ? Fi(e) : e.depth === n.depth ? Cr(e, n) : e.depth > n.depth ? t(e, n) : i(e, n), vl = n);
  }
  var f = {
    enqueueSetState: function(n, e) {
      n = n._reactInternals, n.queue !== null && n.queue.push(e);
    },
    enqueueReplaceState: function(n, e) {
      n = n._reactInternals, n.replace = !0, n.queue = [e];
    },
    enqueueForceUpdate: function() {
    }
  }, o = { id: 1, overflow: "" };
  function s(n, e, r) {
    var a = n.id;
    n = n.overflow;
    var c = 32 - E(a) - 1;
    a &= ~(1 << c), r += 1;
    var h = 32 - E(e) + c;
    if (30 < h) {
      var d = c - c % 5;
      return h = (a & (1 << d) - 1).toString(32), a >>= d, c -= d, {
        id: 1 << 32 - E(e) + c | r << c | a,
        overflow: h + n
      };
    }
    return {
      id: 1 << h | r << c | a,
      overflow: n
    };
  }
  var E = Math.clz32 ? Math.clz32 : A, v = Math.log, x = Math.LN2;
  function A(n) {
    return n >>>= 0, n === 0 ? 32 : 31 - (v(n) / x | 0) | 0;
  }
  function S() {
  }
  var M = Error(R(460));
  function O(n, e, r) {
    switch (r = n[r], r === void 0 ? n.push(e) : r !== e && (e.then(S, S), e = r), e.status) {
      case "fulfilled":
        return e.value;
      case "rejected":
        throw e.reason;
      default:
        switch (typeof e.status == "string" ? e.then(S, S) : (n = e, n.status = "pending", n.then(
          function(a) {
            if (e.status === "pending") {
              var c = e;
              c.status = "fulfilled", c.value = a;
            }
          },
          function(a) {
            if (e.status === "pending") {
              var c = e;
              c.status = "rejected", c.reason = a;
            }
          }
        )), e.status) {
          case "fulfilled":
            return e.value;
          case "rejected":
            throw e.reason;
        }
        throw G = e, M;
    }
  }
  var G = null;
  function z() {
    if (G === null) throw Error(R(459));
    var n = G;
    return G = null, n;
  }
  function D(n, e) {
    return n === e && (n !== 0 || 1 / n === 1 / e) || n !== n && e !== e;
  }
  var B = typeof Object.is == "function" ? Object.is : D, H = null, tn = null, fn = null, Z = null, K = null, Y = null, Gn = !1, J = !1, pn = 0, q = 0, gn = -1, bn = 0, rn = null, zn = null, be = 0;
  function jn() {
    if (H === null)
      throw Error(R(321));
    return H;
  }
  function xt() {
    if (0 < be) throw Error(R(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function He() {
    return Y === null ? K === null ? (Gn = !1, K = Y = xt()) : (Gn = !0, Y = K) : Y.next === null ? (Gn = !1, Y = Y.next = xt()) : (Gn = !0, Y = Y.next), Y;
  }
  function kn() {
    var n = rn;
    return rn = null, n;
  }
  function tl() {
    Z = fn = tn = H = null, J = !1, K = null, be = 0, Y = zn = null;
  }
  function dl(n, e) {
    return typeof e == "function" ? e(n) : e;
  }
  function sl(n, e, r) {
    if (H = jn(), Y = He(), Gn) {
      var a = Y.queue;
      if (e = a.dispatch, zn !== null && (r = zn.get(a), r !== void 0)) {
        zn.delete(a), a = Y.memoizedState;
        do
          a = n(a, r.action), r = r.next;
        while (r !== null);
        return Y.memoizedState = a, [a, e];
      }
      return [Y.memoizedState, e];
    }
    return n = n === dl ? typeof e == "function" ? e() : e : r !== void 0 ? r(e) : e, Y.memoizedState = n, n = Y.queue = { last: null, dispatch: null }, n = n.dispatch = Xl.bind(
      null,
      H,
      n
    ), [Y.memoizedState, n];
  }
  function wl(n, e) {
    if (H = jn(), Y = He(), e = e === void 0 ? null : e, Y !== null) {
      var r = Y.memoizedState;
      if (r !== null && e !== null) {
        var a = r[1];
        n: if (a === null) a = !1;
        else {
          for (var c = 0; c < a.length && c < e.length; c++)
            if (!B(e[c], a[c])) {
              a = !1;
              break n;
            }
          a = !0;
        }
        if (a) return r[0];
      }
    }
    return n = n(), Y.memoizedState = [n, e], n;
  }
  function Xl(n, e, r) {
    if (25 <= be) throw Error(R(301));
    if (n === H)
      if (J = !0, n = { action: r, next: null }, zn === null && (zn = /* @__PURE__ */ new Map()), r = zn.get(e), r === void 0)
        zn.set(e, n);
      else {
        for (e = r; e.next !== null; ) e = e.next;
        e.next = n;
      }
  }
  function En() {
    throw Error(R(440));
  }
  function ye() {
    throw Error(R(394));
  }
  function wt() {
    throw Error(R(479));
  }
  function Si(n, e, r) {
    jn();
    var a = q++, c = fn;
    if (typeof n.$$FORM_ACTION == "function") {
      var h = null, d = Z;
      c = c.formState;
      var b = n.$$IS_SIGNATURE_EQUAL;
      if (c !== null && typeof b == "function") {
        var g = c[1];
        b.call(n, c[2], c[3]) && (h = r !== void 0 ? "p" + r : "k" + Zr(
          JSON.stringify([d, null, a]),
          0
        ), g === h && (gn = a, e = c[0]));
      }
      var y = n.bind(null, e);
      return n = function(w) {
        y(w);
      }, typeof y.$$FORM_ACTION == "function" && (n.$$FORM_ACTION = function(w) {
        w = y.$$FORM_ACTION(w), r !== void 0 && (r += "", w.action = r);
        var P = w.data;
        return P && (h === null && (h = r !== void 0 ? "p" + r : "k" + Zr(
          JSON.stringify([
            d,
            null,
            a
          ]),
          0
        )), P.append("$ACTION_KEY", h)), w;
      }), [e, n, !1];
    }
    var T = n.bind(null, e);
    return [
      e,
      function(w) {
        T(w);
      },
      !1
    ];
  }
  function Ai(n) {
    var e = bn;
    return bn += 1, rn === null && (rn = []), O(rn, n, e);
  }
  function za() {
    throw Error(R(393));
  }
  var Pi = {
    readContext: function(n) {
      return n._currentValue;
    },
    use: function(n) {
      if (n !== null && typeof n == "object") {
        if (typeof n.then == "function") return Ai(n);
        if (n.$$typeof === ne) return n._currentValue;
      }
      throw Error(R(438, String(n)));
    },
    useContext: function(n) {
      return jn(), n._currentValue;
    },
    useMemo: wl,
    useReducer: sl,
    useRef: function(n) {
      H = jn(), Y = He();
      var e = Y.memoizedState;
      return e === null ? (n = { current: n }, Y.memoizedState = n) : e;
    },
    useState: function(n) {
      return sl(dl, n);
    },
    useInsertionEffect: S,
    useLayoutEffect: S,
    useCallback: function(n, e) {
      return wl(function() {
        return n;
      }, e);
    },
    useImperativeHandle: S,
    useEffect: S,
    useDebugValue: S,
    useDeferredValue: function(n, e) {
      return jn(), e !== void 0 ? e : n;
    },
    useTransition: function() {
      return jn(), [!1, ye];
    },
    useId: function() {
      var n = tn.treeContext, e = n.overflow;
      n = n.id, n = (n & ~(1 << 32 - E(n) - 1)).toString(32) + e;
      var r = Rt;
      if (r === null) throw Error(R(404));
      return e = pn++, n = "_" + r.idPrefix + "R_" + n, 0 < e && (n += "H" + e.toString(32)), n + "_";
    },
    useSyncExternalStore: function(n, e, r) {
      if (r === void 0)
        throw Error(R(407));
      return r();
    },
    useOptimistic: function(n) {
      return jn(), [n, wt];
    },
    useActionState: Si,
    useFormState: Si,
    useHostTransitionStatus: function() {
      return jn(), fa;
    },
    useMemoCache: function(n) {
      for (var e = Array(n), r = 0; r < n; r++)
        e[r] = $a;
      return e;
    },
    useCacheRefresh: function() {
      return za;
    },
    useEffectEvent: function() {
      return En;
    }
  }, Rt = null, Da = {
    getCacheForType: function() {
      throw Error(R(248));
    },
    cacheSignal: function() {
      throw Error(R(248));
    }
  }, Te, bl;
  function Ee(n) {
    if (Te === void 0)
      try {
        throw Error();
      } catch (r) {
        var e = r.stack.trim().match(/\n( *(at )?)/);
        Te = e && e[1] || "", bl = -1 < r.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < r.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + Te + n + bl;
  }
  var Fr = !1;
  function Zl(n, e) {
    if (!n || Fr) return "";
    Fr = !0;
    var r = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var a = {
        DetermineComponentFrameRoot: function() {
          try {
            if (e) {
              var w = function() {
                throw Error();
              };
              if (Object.defineProperty(w.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(w, []);
                } catch (_) {
                  var P = _;
                }
                Reflect.construct(n, [], w);
              } else {
                try {
                  w.call();
                } catch (_) {
                  P = _;
                }
                n.call(w.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (_) {
                P = _;
              }
              (w = n()) && typeof w.catch == "function" && w.catch(function() {
              });
            }
          } catch (_) {
            if (_ && P && typeof _.stack == "string")
              return [_.stack, P.stack];
          }
          return [null, null];
        }
      };
      a.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var c = Object.getOwnPropertyDescriptor(
        a.DetermineComponentFrameRoot,
        "name"
      );
      c && c.configurable && Object.defineProperty(
        a.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var h = a.DetermineComponentFrameRoot(), d = h[0], b = h[1];
      if (d && b) {
        var g = d.split(`
`), y = b.split(`
`);
        for (c = a = 0; a < g.length && !g[a].includes("DetermineComponentFrameRoot"); )
          a++;
        for (; c < y.length && !y[c].includes(
          "DetermineComponentFrameRoot"
        ); )
          c++;
        if (a === g.length || c === y.length)
          for (a = g.length - 1, c = y.length - 1; 1 <= a && 0 <= c && g[a] !== y[c]; )
            c--;
        for (; 1 <= a && 0 <= c; a--, c--)
          if (g[a] !== y[c]) {
            if (a !== 1 || c !== 1)
              do
                if (a--, c--, 0 > c || g[a] !== y[c]) {
                  var T = `
` + g[a].replace(" at new ", " at ");
                  return n.displayName && T.includes("<anonymous>") && (T = T.replace("<anonymous>", n.displayName)), T;
                }
              while (1 <= a && 0 <= c);
            break;
          }
      }
    } finally {
      Fr = !1, Error.prepareStackTrace = r;
    }
    return (r = n ? n.displayName || n.name : "") ? Ee(r) : "";
  }
  function Mi(n) {
    if (typeof n == "string") return Ee(n);
    if (typeof n == "function")
      return n.prototype && n.prototype.isReactComponent ? Zl(n, !0) : Zl(n, !1);
    if (typeof n == "object" && n !== null) {
      switch (n.$$typeof) {
        case $e:
          return Zl(n.render, !1);
        case lt:
          return Zl(n.type, !1);
        case ee:
          var e = n, r = e._payload;
          e = e._init;
          try {
            n = e(r);
          } catch {
            return Ee("Lazy");
          }
          return Mi(n);
      }
      if (typeof n.name == "string") {
        n: {
          r = n.name, e = n.env;
          var a = n.debugLocation;
          if (a != null && (n = Error.prepareStackTrace, Error.prepareStackTrace = void 0, a = a.stack, Error.prepareStackTrace = n, a.startsWith(`Error: react-stack-top-frame
`) && (a = a.slice(29)), n = a.indexOf(`
`), n !== -1 && (a = a.slice(n + 1)), n = a.indexOf("react_stack_bottom_frame"), n !== -1 && (n = a.lastIndexOf(`
`, n)), n = n !== -1 ? a = a.slice(0, n) : "", a = n.lastIndexOf(`
`), n = a === -1 ? n : n.slice(a + 1), n.indexOf(r) !== -1)) {
            r = `
` + n;
            break n;
          }
          r = Ee(
            r + (e ? " [" + e + "]" : "")
          );
        }
        return r;
      }
    }
    switch (n) {
      case nt:
        return Ee("SuspenseList");
      case le:
        return Ee("Suspense");
    }
    return "";
  }
  function rl(n, e) {
    return (500 < e.byteSize || Et(e.contentState)) && e.contentPreamble === null;
  }
  function Ct(n) {
    if (typeof n == "object" && n !== null && typeof n.environmentName == "string") {
      var e = n.environmentName;
      n = [n].slice(0), typeof n[0] == "string" ? n.splice(
        0,
        1,
        "%c%s%c " + n[0],
        "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px",
        " " + e + " ",
        ""
      ) : n.splice(
        0,
        0,
        "%c%s%c",
        "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px",
        " " + e + " ",
        ""
      ), n.unshift(console), e = wr.apply(console.error, n), e();
    } else console.error(n);
    return null;
  }
  function We(n, e, r, a, c, h, d, b, g, y, T) {
    var w = /* @__PURE__ */ new Set();
    this.destination = null, this.flushScheduled = !1, this.resumableState = n, this.renderState = e, this.rootFormatContext = r, this.progressiveChunkSize = a === void 0 ? 12800 : a, this.status = 10, this.fatalError = null, this.pendingRootTasks = this.allPendingTasks = this.nextSegmentId = 0, this.completedPreambleSegments = this.completedRootSegment = null, this.byteSize = 0, this.abortableTasks = w, this.pingedTasks = [], this.clientRenderedBoundaries = [], this.completedBoundaries = [], this.partialBoundaries = [], this.trackedPostpones = null, this.onError = c === void 0 ? Ct : c, this.onPostpone = y === void 0 ? S : y, this.onAllReady = h === void 0 ? S : h, this.onShellReady = d === void 0 ? S : d, this.onShellError = b === void 0 ? S : b, this.onFatalError = g === void 0 ? S : g, this.formState = T === void 0 ? null : T;
  }
  function Ue(n, e, r, a, c, h, d, b, g, y, T, w) {
    return e = new We(
      e,
      r,
      a,
      c,
      h,
      d,
      b,
      g,
      y,
      T,
      w
    ), r = il(
      e,
      0,
      null,
      a,
      !1,
      !1
    ), r.parentFlushed = !0, n = Ql(
      e,
      null,
      n,
      -1,
      null,
      r,
      null,
      null,
      e.abortableTasks,
      null,
      a,
      null,
      o,
      null,
      null
    ), Vl(n), e.pingedTasks.push(n), e;
  }
  function Ft(n, e, r, a, c, h, d, b, g, y, T) {
    return n = Ue(
      n,
      e,
      r,
      a,
      c,
      h,
      d,
      b,
      g,
      y,
      T,
      void 0
    ), n.trackedPostpones = {
      workingMap: /* @__PURE__ */ new Map(),
      rootNodes: [],
      rootSlots: null
    }, n;
  }
  function Rl(n, e, r, a, c, h, d, b, g) {
    return r = new We(
      e.resumableState,
      r,
      e.rootFormatContext,
      e.progressiveChunkSize,
      a,
      c,
      h,
      d,
      b,
      g,
      null
    ), r.nextSegmentId = e.nextSegmentId, typeof e.replaySlots == "number" ? (a = il(
      r,
      0,
      null,
      e.rootFormatContext,
      !1,
      !1
    ), a.parentFlushed = !0, n = Ql(
      r,
      null,
      n,
      -1,
      null,
      a,
      null,
      null,
      r.abortableTasks,
      null,
      e.rootFormatContext,
      null,
      o,
      null,
      null
    ), Vl(n), r.pingedTasks.push(n), r) : (n = Sr(
      r,
      null,
      {
        nodes: e.replayNodes,
        slots: e.replaySlots,
        pendingTasks: 0
      },
      n,
      -1,
      null,
      null,
      r.abortableTasks,
      null,
      e.rootFormatContext,
      null,
      o,
      null,
      null
    ), Vl(n), r.pingedTasks.push(n), r);
  }
  function Ii(n, e, r, a, c, h, d, b, g) {
    return n = Rl(
      n,
      e,
      r,
      a,
      c,
      h,
      d,
      b,
      g
    ), n.trackedPostpones = {
      workingMap: /* @__PURE__ */ new Map(),
      rootNodes: [],
      rootSlots: null
    }, n;
  }
  var yn = null;
  function Jl(n, e) {
    n.pingedTasks.push(e), n.pingedTasks.length === 1 && (n.flushScheduled = n.destination !== null, n.trackedPostpones !== null || n.status === 10 ? Xt(function() {
      return Li(n);
    }) : Jr(function() {
      return Li(n);
    }));
  }
  function Ge(n, e, r, a, c) {
    return r = {
      status: 0,
      rootSegmentID: -1,
      parentFlushed: !1,
      pendingTasks: 0,
      row: e,
      completedSegments: [],
      byteSize: 0,
      fallbackAbortableTasks: r,
      errorDigest: null,
      contentState: fe(),
      fallbackState: fe(),
      contentPreamble: a,
      fallbackPreamble: c,
      trackedContentKeyPath: null,
      trackedFallbackNode: null
    }, e !== null && (e.pendingTasks++, a = e.boundaries, a !== null && (n.allPendingTasks++, r.pendingTasks++, a.push(r)), n = e.inheritedHoistables, n !== null && ge(r.contentState, n)), r;
  }
  function Ql(n, e, r, a, c, h, d, b, g, y, T, w, P, _, X) {
    n.allPendingTasks++, c === null ? n.pendingRootTasks++ : c.pendingTasks++, _ !== null && _.pendingTasks++;
    var W = {
      replay: null,
      node: r,
      childIndex: a,
      ping: function() {
        return Jl(n, W);
      },
      blockedBoundary: c,
      blockedSegment: h,
      blockedPreamble: d,
      hoistableState: b,
      abortSet: g,
      keyPath: y,
      formatContext: T,
      context: w,
      treeContext: P,
      row: _,
      componentStack: X,
      thenableState: e
    };
    return g.add(W), W;
  }
  function Sr(n, e, r, a, c, h, d, b, g, y, T, w, P, _) {
    n.allPendingTasks++, h === null ? n.pendingRootTasks++ : h.pendingTasks++, P !== null && P.pendingTasks++, r.pendingTasks++;
    var X = {
      replay: r,
      node: a,
      childIndex: c,
      ping: function() {
        return Jl(n, X);
      },
      blockedBoundary: h,
      blockedSegment: null,
      blockedPreamble: null,
      hoistableState: d,
      abortSet: b,
      keyPath: g,
      formatContext: y,
      context: T,
      treeContext: w,
      row: P,
      componentStack: _,
      thenableState: e
    };
    return b.add(X), X;
  }
  function il(n, e, r, a, c, h) {
    return {
      status: 0,
      parentFlushed: !1,
      id: -1,
      index: e,
      chunks: [],
      children: [],
      preambleChildren: [],
      parentFormatContext: a,
      boundary: r,
      lastPushedText: c,
      textEmbedded: h
    };
  }
  function Vl(n) {
    var e = n.node;
    if (typeof e == "object" && e !== null)
      switch (e.$$typeof) {
        case $l:
          n.componentStack = { parent: n.componentStack, type: e.type };
      }
  }
  function xe(n) {
    return n === null ? null : { parent: n.parent, type: "Suspense Fallback" };
  }
  function al(n) {
    var e = {};
    return n && Object.defineProperty(e, "componentStack", {
      configurable: !0,
      enumerable: !0,
      get: function() {
        try {
          var r = "", a = n;
          do
            r += Mi(a.type), a = a.parent;
          while (a);
          var c = r;
        } catch (h) {
          c = `
Error generating stack: ` + h.message + `
` + h.stack;
        }
        return Object.defineProperty(e, "componentStack", {
          value: c
        }), c;
      }
    }), e;
  }
  function An(n, e, r) {
    if (n = n.onError, e = n(e, r), e == null || typeof e == "string") return e;
  }
  function Ye(n, e) {
    var r = n.onShellError, a = n.onFatalError;
    r(e), a(e), n.destination !== null ? (n.status = 14, Vr(n.destination, e)) : (n.status = 13, n.fatalError = e);
  }
  function On(n, e) {
    _i(n, e.next, e.hoistables);
  }
  function _i(n, e, r) {
    for (; e !== null; ) {
      r !== null && (ge(e.hoistables, r), e.inheritedHoistables = r);
      var a = e.boundaries;
      if (a !== null) {
        e.boundaries = null;
        for (var c = 0; c < a.length; c++) {
          var h = a[c];
          r !== null && ge(h.contentState, r), $n(n, h, null, null);
        }
      }
      if (e.pendingTasks--, 0 < e.pendingTasks) break;
      r = e.hoistables, e = e.next;
    }
  }
  function St(n, e) {
    var r = e.boundaries;
    if (r !== null && e.pendingTasks === r.length) {
      for (var a = !0, c = 0; c < r.length; c++) {
        var h = r[c];
        if (h.pendingTasks !== 1 || h.parentFlushed || rl(n, h)) {
          a = !1;
          break;
        }
      }
      a && _i(n, e, e.hoistables);
    }
  }
  function At(n) {
    var e = {
      pendingTasks: 1,
      boundaries: null,
      hoistables: fe(),
      inheritedHoistables: null,
      together: !1,
      next: null
    };
    return n !== null && 0 < n.pendingTasks && (e.pendingTasks++, e.boundaries = [], n.next = e), e;
  }
  function Ha(n, e, r, a, c) {
    var h = e.keyPath, d = e.treeContext, b = e.row;
    e.keyPath = r, r = a.length;
    var g = null;
    if (e.replay !== null) {
      var y = e.replay.slots;
      if (y !== null && typeof y == "object")
        for (var T = 0; T < r; T++) {
          var w = c !== "backwards" && c !== "unstable_legacy-backwards" ? T : r - 1 - T, P = a[w];
          e.row = g = At(
            g
          ), e.treeContext = s(d, r, w);
          var _ = y[w];
          typeof _ == "number" ? (Kl(n, e, _, P, w), delete y[w]) : dn(n, e, P, w), --g.pendingTasks === 0 && On(n, g);
        }
      else
        for (y = 0; y < r; y++)
          T = c !== "backwards" && c !== "unstable_legacy-backwards" ? y : r - 1 - y, w = a[T], e.row = g = At(g), e.treeContext = s(d, r, T), dn(n, e, w, T), --g.pendingTasks === 0 && On(n, g);
    } else if (c !== "backwards" && c !== "unstable_legacy-backwards")
      for (c = 0; c < r; c++)
        y = a[c], e.row = g = At(g), e.treeContext = s(
          d,
          r,
          c
        ), dn(n, e, y, c), --g.pendingTasks === 0 && On(n, g);
    else {
      for (c = e.blockedSegment, y = c.children.length, T = c.chunks.length, w = r - 1; 0 <= w; w--) {
        P = a[w], e.row = g = At(
          g
        ), e.treeContext = s(d, r, w), _ = il(
          n,
          T,
          null,
          e.formatContext,
          w === 0 ? c.lastPushedText : !0,
          !0
        ), c.children.splice(y, 0, _), e.blockedSegment = _;
        try {
          dn(n, e, P, w), _.lastPushedText && _.textEmbedded && _.chunks.push(ol), _.status = 1, Fl(n, e.blockedBoundary, _), --g.pendingTasks === 0 && On(n, g);
        } catch (X) {
          throw _.status = n.status === 12 ? 3 : 4, X;
        }
      }
      e.blockedSegment = c, c.lastPushedText = !1;
    }
    b !== null && g !== null && 0 < g.pendingTasks && (b.pendingTasks++, g.next = b), e.treeContext = d, e.row = b, e.keyPath = h;
  }
  function Wa(n, e, r, a, c, h) {
    var d = e.thenableState;
    for (e.thenableState = null, H = {}, tn = e, fn = n, Z = r, q = pn = 0, gn = -1, bn = 0, rn = d, n = a(c, h); J; )
      J = !1, q = pn = 0, gn = -1, bn = 0, be += 1, Y = null, n = a(c, h);
    return tl(), n;
  }
  function Cl(n, e, r, a, c, h, d) {
    var b = !1;
    if (h !== 0 && n.formState !== null) {
      var g = e.blockedSegment;
      if (g !== null) {
        b = !0, g = g.chunks;
        for (var y = 0; y < h; y++)
          y === d ? g.push(iu) : g.push(ut);
      }
    }
    h = e.keyPath, e.keyPath = r, c ? (r = e.treeContext, e.treeContext = s(r, 1, 0), dn(n, e, a, -1), e.treeContext = r) : b ? dn(n, e, a, -1) : Pn(n, e, a, -1), e.keyPath = h;
  }
  function we(n, e, r, a, c, h) {
    if (typeof a == "function")
      if (a.prototype && a.prototype.isReactComponent) {
        var d = c;
        if ("ref" in c) {
          d = {};
          for (var b in c)
            b !== "ref" && (d[b] = c[b]);
        }
        var g = a.defaultProps;
        if (g) {
          d === c && (d = Un({}, d, c));
          for (var y in g)
            d[y] === void 0 && (d[y] = g[y]);
        }
        c = d, d = Na, g = a.contextType, typeof g == "object" && g !== null && (d = g._currentValue), d = new a(c, d);
        var T = d.state !== void 0 ? d.state : null;
        if (d.updater = f, d.props = c, d.state = T, g = { queue: [], replace: !1 }, d._reactInternals = g, h = a.contextType, d.context = typeof h == "object" && h !== null ? h._currentValue : Na, h = a.getDerivedStateFromProps, typeof h == "function" && (h = h(c, T), T = h == null ? T : Un({}, T, h), d.state = T), typeof a.getDerivedStateFromProps != "function" && typeof d.getSnapshotBeforeUpdate != "function" && (typeof d.UNSAFE_componentWillMount == "function" || typeof d.componentWillMount == "function"))
          if (a = d.state, typeof d.componentWillMount == "function" && d.componentWillMount(), typeof d.UNSAFE_componentWillMount == "function" && d.UNSAFE_componentWillMount(), a !== d.state && f.enqueueReplaceState(
            d,
            d.state,
            null
          ), g.queue !== null && 0 < g.queue.length)
            if (a = g.queue, h = g.replace, g.queue = null, g.replace = !1, h && a.length === 1)
              d.state = a[0];
            else {
              for (g = h ? a[0] : d.state, T = !0, h = h ? 1 : 0; h < a.length; h++)
                y = a[h], y = typeof y == "function" ? y.call(d, g, c, void 0) : y, y != null && (T ? (T = !1, g = Un({}, g, y)) : Un(g, y));
              d.state = g;
            }
          else g.queue = null;
        if (a = d.render(), n.status === 12) throw null;
        c = e.keyPath, e.keyPath = r, Pn(n, e, a, -1), e.keyPath = c;
      } else {
        if (a = Wa(n, e, r, a, c, void 0), n.status === 12) throw null;
        Cl(
          n,
          e,
          r,
          a,
          pn !== 0,
          q,
          gn
        );
      }
    else if (typeof a == "string")
      if (d = e.blockedSegment, d === null)
        d = c.children, g = e.formatContext, T = e.keyPath, e.formatContext = Bl(g, a, c), e.keyPath = r, dn(n, e, d, -1), e.formatContext = g, e.keyPath = T;
      else {
        if (T = er(
          d.chunks,
          a,
          c,
          n.resumableState,
          n.renderState,
          e.blockedPreamble,
          e.hoistableState,
          e.formatContext,
          d.lastPushedText
        ), d.lastPushedText = !1, g = e.formatContext, h = e.keyPath, e.keyPath = r, (e.formatContext = Bl(g, a, c)).insertionMode === 3) {
          r = il(
            n,
            0,
            null,
            e.formatContext,
            !1,
            !1
          ), d.preambleChildren.push(r), e.blockedSegment = r;
          try {
            r.status = 6, dn(n, e, T, -1), r.lastPushedText && r.textEmbedded && r.chunks.push(ol), r.status = 1, Fl(n, e.blockedBoundary, r);
          } finally {
            e.blockedSegment = d;
          }
        } else dn(n, e, T, -1);
        e.formatContext = g, e.keyPath = h;
        n: {
          switch (e = d.chunks, n = n.resumableState, a) {
            case "title":
            case "style":
            case "script":
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
              break n;
            case "body":
              if (1 >= g.insertionMode) {
                n.hasBody = !0;
                break n;
              }
              break;
            case "html":
              if (g.insertionMode === 0) {
                n.hasHtml = !0;
                break n;
              }
              break;
            case "head":
              if (1 >= g.insertionMode) break n;
          }
          e.push(Dl(a));
        }
        d.lastPushedText = !1;
      }
    else {
      switch (a) {
        case ja:
        case Hr:
        case Wr:
        case Yt:
          a = e.keyPath, e.keyPath = r, Pn(n, e, c.children, -1), e.keyPath = a;
          return;
        case Gr:
          a = e.blockedSegment, a === null ? c.mode !== "hidden" && (a = e.keyPath, e.keyPath = r, dn(n, e, c.children, -1), e.keyPath = a) : c.mode !== "hidden" && (a.chunks.push(ue), a.lastPushedText = !1, d = e.keyPath, e.keyPath = r, dn(n, e, c.children, -1), e.keyPath = d, a.chunks.push(tr), a.lastPushedText = !1);
          return;
        case nt:
          n: {
            if (a = c.children, c = c.revealOrder, c === "forwards" || c === "backwards" || c === "unstable_legacy-backwards") {
              if (te(a)) {
                Ha(n, e, r, a, c);
                break n;
              }
              if ((d = Xr(a)) && (d = d.call(a))) {
                if (g = d.next(), !g.done) {
                  do
                    g = d.next();
                  while (!g.done);
                  Ha(n, e, r, a, c);
                }
                break n;
              }
            }
            c === "together" ? (c = e.keyPath, d = e.row, g = e.row = At(null), g.boundaries = [], g.together = !0, e.keyPath = r, Pn(n, e, a, -1), --g.pendingTasks === 0 && On(n, g), e.keyPath = c, e.row = d, d !== null && 0 < g.pendingTasks && (d.pendingTasks++, g.next = d)) : (c = e.keyPath, e.keyPath = r, Pn(n, e, a, -1), e.keyPath = c);
          }
          return;
        case nu:
        case pa:
          throw Error(R(343));
        case le:
          n: if (e.replay !== null) {
            a = e.keyPath, d = e.formatContext, g = e.row, e.keyPath = r, e.formatContext = et(
              n.resumableState,
              d
            ), e.row = null, r = c.children;
            try {
              dn(n, e, r, -1);
            } finally {
              e.keyPath = a, e.formatContext = d, e.row = g;
            }
          } else {
            a = e.keyPath, h = e.formatContext;
            var w = e.row;
            y = e.blockedBoundary, b = e.blockedPreamble;
            var P = e.hoistableState, _ = e.blockedSegment, X = c.fallback;
            c = c.children;
            var W = /* @__PURE__ */ new Set(), U = 2 > e.formatContext.insertionMode ? Ge(
              n,
              e.row,
              W,
              an(),
              an()
            ) : Ge(
              n,
              e.row,
              W,
              null,
              null
            );
            n.trackedPostpones !== null && (U.trackedContentKeyPath = r);
            var en = il(
              n,
              _.chunks.length,
              U,
              e.formatContext,
              !1,
              !1
            );
            _.children.push(en), _.lastPushedText = !1;
            var p = il(
              n,
              0,
              null,
              e.formatContext,
              !1,
              !1
            );
            if (p.parentFlushed = !0, n.trackedPostpones !== null) {
              d = e.componentStack, g = [r[0], "Suspense Fallback", r[2]], T = [g[1], g[2], [], null], n.trackedPostpones.workingMap.set(g, T), U.trackedFallbackNode = T, e.blockedSegment = en, e.blockedPreamble = U.fallbackPreamble, e.keyPath = g, e.formatContext = mt(
                n.resumableState,
                h
              ), e.componentStack = xe(d), en.status = 6;
              try {
                dn(n, e, X, -1), en.lastPushedText && en.textEmbedded && en.chunks.push(ol), en.status = 1, Fl(n, y, en);
              } catch (Mn) {
                throw en.status = n.status === 12 ? 3 : 4, Mn;
              } finally {
                e.blockedSegment = _, e.blockedPreamble = b, e.keyPath = a, e.formatContext = h;
              }
              e = Ql(
                n,
                null,
                c,
                -1,
                U,
                p,
                U.contentPreamble,
                U.contentState,
                e.abortSet,
                r,
                et(
                  n.resumableState,
                  e.formatContext
                ),
                e.context,
                e.treeContext,
                null,
                d
              ), Vl(e), n.pingedTasks.push(e);
            } else {
              e.blockedBoundary = U, e.blockedPreamble = U.contentPreamble, e.hoistableState = U.contentState, e.blockedSegment = p, e.keyPath = r, e.formatContext = et(
                n.resumableState,
                h
              ), e.row = null, p.status = 6;
              try {
                if (dn(n, e, c, -1), p.lastPushedText && p.textEmbedded && p.chunks.push(ol), p.status = 1, Fl(n, U, p), It(U, p), U.pendingTasks === 0 && U.status === 0) {
                  if (U.status = 1, !rl(n, U)) {
                    w !== null && --w.pendingTasks === 0 && On(n, w), n.pendingRootTasks === 0 && e.blockedPreamble && Sl(n);
                    break n;
                  }
                } else
                  w !== null && w.together && St(n, w);
              } catch (Mn) {
                U.status = 4, n.status === 12 ? (p.status = 3, d = n.fatalError) : (p.status = 4, d = Mn), g = al(e.componentStack), T = An(
                  n,
                  d,
                  g
                ), U.errorDigest = T, ki(n, U);
              } finally {
                e.blockedBoundary = y, e.blockedPreamble = b, e.hoistableState = P, e.blockedSegment = _, e.keyPath = a, e.formatContext = h, e.row = w;
              }
              e = Ql(
                n,
                null,
                X,
                -1,
                y,
                en,
                U.fallbackPreamble,
                U.fallbackState,
                W,
                [r[0], "Suspense Fallback", r[2]],
                mt(
                  n.resumableState,
                  e.formatContext
                ),
                e.context,
                e.treeContext,
                e.row,
                xe(
                  e.componentStack
                )
              ), Vl(e), n.pingedTasks.push(e);
            }
          }
          return;
      }
      if (typeof a == "object" && a !== null)
        switch (a.$$typeof) {
          case $e:
            if ("ref" in c)
              for (_ in d = {}, c)
                _ !== "ref" && (d[_] = c[_]);
            else d = c;
            a = Wa(
              n,
              e,
              r,
              a.render,
              d,
              h
            ), Cl(
              n,
              e,
              r,
              a,
              pn !== 0,
              q,
              gn
            );
            return;
          case lt:
            we(n, e, r, a.type, c, h);
            return;
          case ne:
            if (g = c.children, d = e.keyPath, c = c.value, T = a._currentValue, a._currentValue = c, h = vl, vl = a = {
              parent: h,
              depth: h === null ? 0 : h.depth + 1,
              context: a,
              parentValue: T,
              value: c
            }, e.context = a, e.keyPath = r, Pn(n, e, g, -1), n = vl, n === null) throw Error(R(403));
            n.context._currentValue = n.parentValue, n = vl = n.parent, e.context = n, e.keyPath = d;
            return;
          case Ur:
            c = c.children, a = c(a._context._currentValue), c = e.keyPath, e.keyPath = r, Pn(n, e, a, -1), e.keyPath = c;
            return;
          case ee:
            if (d = a._init, a = d(a._payload), n.status === 12) throw null;
            we(n, e, r, a, c, h);
            return;
        }
      throw Error(
        R(130, a == null ? a : typeof a, "")
      );
    }
  }
  function Kl(n, e, r, a, c) {
    var h = e.replay, d = e.blockedBoundary, b = il(
      n,
      0,
      null,
      e.formatContext,
      !1,
      !1
    );
    b.id = r, b.parentFlushed = !0;
    try {
      e.replay = null, e.blockedSegment = b, dn(n, e, a, c), b.status = 1, Fl(n, d, b), d === null ? n.completedRootSegment = b : (It(d, b), d.parentFlushed && n.partialBoundaries.push(d));
    } finally {
      e.replay = h, e.blockedSegment = null;
    }
  }
  function Pn(n, e, r, a) {
    e.replay !== null && typeof e.replay.slots == "number" ? Kl(n, e, e.replay.slots, r, a) : (e.node = r, e.childIndex = a, r = e.componentStack, Vl(e), Xe(n, e), e.componentStack = r);
  }
  function Xe(n, e) {
    var r = e.node, a = e.childIndex;
    if (r !== null) {
      if (typeof r == "object") {
        switch (r.$$typeof) {
          case $l:
            var c = r.type, h = r.key, d = r.props;
            r = d.ref;
            var b = r !== void 0 ? r : null, g = Rr(c), y = h ?? (a === -1 ? 0 : a);
            if (h = [e.keyPath, g, y], e.replay !== null)
              n: {
                var T = e.replay;
                for (a = T.nodes, r = 0; r < a.length; r++) {
                  var w = a[r];
                  if (y === w[1]) {
                    if (w.length === 4) {
                      if (g !== null && g !== w[0])
                        throw Error(
                          R(490, w[0], g)
                        );
                      var P = w[2];
                      g = w[3], y = e.node, e.replay = {
                        nodes: P,
                        slots: g,
                        pendingTasks: 1
                      };
                      try {
                        if (we(n, e, h, c, d, b), e.replay.pendingTasks === 1 && 0 < e.replay.nodes.length)
                          throw Error(R(488));
                        e.replay.pendingTasks--;
                      } catch (L) {
                        if (typeof L == "object" && L !== null && (L === M || typeof L.then == "function"))
                          throw e.node === y ? e.replay = T : a.splice(r, 1), L;
                        e.replay.pendingTasks--, d = al(e.componentStack), h = n, n = e.blockedBoundary, c = L, d = An(h, c, d), Je(
                          h,
                          n,
                          P,
                          g,
                          c,
                          d
                        );
                      }
                      e.replay = T;
                    } else {
                      if (c !== le)
                        throw Error(
                          R(
                            490,
                            "Suspense",
                            Rr(c) || "Unknown"
                          )
                        );
                      l: {
                        T = void 0, c = w[5], b = w[2], g = w[3], y = w[4] === null ? [] : w[4][2], w = w[4] === null ? null : w[4][3];
                        var _ = e.keyPath, X = e.formatContext, W = e.row, U = e.replay, en = e.blockedBoundary, p = e.hoistableState, Mn = d.children, Yn = d.fallback, cl = /* @__PURE__ */ new Set();
                        d = 2 > e.formatContext.insertionMode ? Ge(
                          n,
                          e.row,
                          cl,
                          an(),
                          an()
                        ) : Ge(
                          n,
                          e.row,
                          cl,
                          null,
                          null
                        ), d.parentFlushed = !0, d.rootSegmentID = c, e.blockedBoundary = d, e.hoistableState = d.contentState, e.keyPath = h, e.formatContext = et(
                          n.resumableState,
                          X
                        ), e.row = null, e.replay = {
                          nodes: b,
                          slots: g,
                          pendingTasks: 1
                        };
                        try {
                          if (dn(n, e, Mn, -1), e.replay.pendingTasks === 1 && 0 < e.replay.nodes.length)
                            throw Error(R(488));
                          if (e.replay.pendingTasks--, d.pendingTasks === 0 && d.status === 0) {
                            d.status = 1, n.completedBoundaries.push(d);
                            break l;
                          }
                        } catch (L) {
                          d.status = 4, P = al(e.componentStack), T = An(
                            n,
                            L,
                            P
                          ), d.errorDigest = T, e.replay.pendingTasks--, n.clientRenderedBoundaries.push(d);
                        } finally {
                          e.blockedBoundary = en, e.hoistableState = p, e.replay = U, e.keyPath = _, e.formatContext = X, e.row = W;
                        }
                        P = Sr(
                          n,
                          null,
                          {
                            nodes: y,
                            slots: w,
                            pendingTasks: 0
                          },
                          Yn,
                          -1,
                          en,
                          d.fallbackState,
                          cl,
                          [h[0], "Suspense Fallback", h[2]],
                          mt(
                            n.resumableState,
                            e.formatContext
                          ),
                          e.context,
                          e.treeContext,
                          e.row,
                          xe(
                            e.componentStack
                          )
                        ), Vl(P), n.pingedTasks.push(P);
                      }
                    }
                    a.splice(r, 1);
                    break n;
                  }
                }
              }
            else we(n, e, h, c, d, b);
            return;
          case je:
            throw Error(R(257));
          case ee:
            if (P = r._init, r = P(r._payload), n.status === 12) throw null;
            Pn(n, e, r, a);
            return;
        }
        if (te(r)) {
          Ze(n, e, r, a);
          return;
        }
        if ((P = Xr(r)) && (P = P.call(r))) {
          if (r = P.next(), !r.done) {
            d = [];
            do
              d.push(r.value), r = P.next();
            while (!r.done);
            Ze(n, e, d, a);
          }
          return;
        }
        if (typeof r.then == "function")
          return e.thenableState = null, Pn(n, e, Ai(r), a);
        if (r.$$typeof === ne)
          return Pn(
            n,
            e,
            r._currentValue,
            a
          );
        throw a = Object.prototype.toString.call(r), Error(
          R(
            31,
            a === "[object Object]" ? "object with keys {" + Object.keys(r).join(", ") + "}" : a
          )
        );
      }
      typeof r == "string" ? (a = e.blockedSegment, a !== null && (a.lastPushedText = oa(
        a.chunks,
        r,
        n.renderState,
        a.lastPushedText
      ))) : (typeof r == "number" || typeof r == "bigint") && (a = e.blockedSegment, a !== null && (a.lastPushedText = oa(
        a.chunks,
        "" + r,
        n.renderState,
        a.lastPushedText
      )));
    }
  }
  function Ze(n, e, r, a) {
    var c = e.keyPath;
    if (a !== -1 && (e.keyPath = [e.keyPath, "Fragment", a], e.replay !== null)) {
      for (var h = e.replay, d = h.nodes, b = 0; b < d.length; b++) {
        var g = d[b];
        if (g[1] === a) {
          a = g[2], g = g[3], e.replay = { nodes: a, slots: g, pendingTasks: 1 };
          try {
            if (Ze(n, e, r, -1), e.replay.pendingTasks === 1 && 0 < e.replay.nodes.length)
              throw Error(R(488));
            e.replay.pendingTasks--;
          } catch (w) {
            if (typeof w == "object" && w !== null && (w === M || typeof w.then == "function"))
              throw w;
            e.replay.pendingTasks--, r = al(e.componentStack);
            var y = e.blockedBoundary, T = w;
            r = An(n, T, r), Je(
              n,
              y,
              a,
              g,
              T,
              r
            );
          }
          e.replay = h, d.splice(b, 1);
          break;
        }
      }
      e.keyPath = c;
      return;
    }
    if (h = e.treeContext, d = r.length, e.replay !== null && (b = e.replay.slots, b !== null && typeof b == "object")) {
      for (a = 0; a < d; a++)
        g = r[a], e.treeContext = s(h, d, a), y = b[a], typeof y == "number" ? (Kl(n, e, y, g, a), delete b[a]) : dn(n, e, g, a);
      e.treeContext = h, e.keyPath = c;
      return;
    }
    for (b = 0; b < d; b++)
      a = r[b], e.treeContext = s(h, d, b), dn(n, e, a, b);
    e.treeContext = h, e.keyPath = c;
  }
  function Ar(n, e, r) {
    if (r.status = 5, r.rootSegmentID = n.nextSegmentId++, n = r.trackedContentKeyPath, n === null) throw Error(R(486));
    var a = r.trackedFallbackNode, c = [], h = e.workingMap.get(n);
    return h === void 0 ? (r = [
      n[1],
      n[2],
      c,
      null,
      a,
      r.rootSegmentID
    ], e.workingMap.set(n, r), kr(r, n[0], e), r) : (h[4] = a, h[5] = r.rootSegmentID, h);
  }
  function Pr(n, e, r, a) {
    a.status = 5;
    var c = r.keyPath, h = r.blockedBoundary;
    if (h === null)
      a.id = n.nextSegmentId++, e.rootSlots = a.id, n.completedRootSegment !== null && (n.completedRootSegment.status = 5);
    else {
      if (h !== null && h.status === 0) {
        var d = Ar(
          n,
          e,
          h
        );
        if (h.trackedContentKeyPath === c && r.childIndex === -1) {
          a.id === -1 && (a.id = a.parentFlushed ? h.rootSegmentID : n.nextSegmentId++), d[3] = a.id;
          return;
        }
      }
      if (a.id === -1 && (a.id = a.parentFlushed && h !== null ? h.rootSegmentID : n.nextSegmentId++), r.childIndex === -1)
        c === null ? e.rootSlots = a.id : (r = e.workingMap.get(c), r === void 0 ? (r = [c[1], c[2], [], a.id], kr(r, c[0], e)) : r[3] = a.id);
      else {
        if (c === null) {
          if (n = e.rootSlots, n === null)
            n = e.rootSlots = {};
          else if (typeof n == "number")
            throw Error(R(491));
        } else if (h = e.workingMap, d = h.get(c), d === void 0)
          n = {}, d = [c[1], c[2], [], n], h.set(c, d), kr(d, c[0], e);
        else if (n = d[3], n === null)
          n = d[3] = {};
        else if (typeof n == "number")
          throw Error(R(491));
        n[r.childIndex] = a.id;
      }
    }
  }
  function ki(n, e) {
    n = n.trackedPostpones, n !== null && (e = e.trackedContentKeyPath, e !== null && (e = n.workingMap.get(e), e !== void 0 && (e.length = 4, e[2] = [], e[3] = null)));
  }
  function Mr(n, e, r) {
    return Sr(
      n,
      r,
      e.replay,
      e.node,
      e.childIndex,
      e.blockedBoundary,
      e.hoistableState,
      e.abortSet,
      e.keyPath,
      e.formatContext,
      e.context,
      e.treeContext,
      e.row,
      e.componentStack
    );
  }
  function Oi(n, e, r) {
    var a = e.blockedSegment, c = il(
      n,
      a.chunks.length,
      null,
      e.formatContext,
      a.lastPushedText,
      !0
    );
    return a.children.push(c), a.lastPushedText = !1, Ql(
      n,
      r,
      e.node,
      e.childIndex,
      e.blockedBoundary,
      c,
      e.blockedPreamble,
      e.hoistableState,
      e.abortSet,
      e.keyPath,
      e.formatContext,
      e.context,
      e.treeContext,
      e.row,
      e.componentStack
    );
  }
  function dn(n, e, r, a) {
    var c = e.formatContext, h = e.context, d = e.keyPath, b = e.treeContext, g = e.componentStack, y = e.blockedSegment;
    if (y === null) {
      y = e.replay;
      try {
        return Pn(n, e, r, a);
      } catch (P) {
        if (tl(), r = P === M ? z() : P, n.status !== 12 && typeof r == "object" && r !== null) {
          if (typeof r.then == "function") {
            a = P === M ? kn() : null, n = Mr(n, e, a).ping, r.then(n, n), e.formatContext = c, e.context = h, e.keyPath = d, e.treeContext = b, e.componentStack = g, e.replay = y, u(h);
            return;
          }
          if (r.message === "Maximum call stack size exceeded") {
            r = P === M ? kn() : null, r = Mr(n, e, r), n.pingedTasks.push(r), e.formatContext = c, e.context = h, e.keyPath = d, e.treeContext = b, e.componentStack = g, e.replay = y, u(h);
            return;
          }
        }
      }
    } else {
      var T = y.children.length, w = y.chunks.length;
      try {
        return Pn(n, e, r, a);
      } catch (P) {
        if (tl(), y.children.length = T, y.chunks.length = w, r = P === M ? z() : P, n.status !== 12 && typeof r == "object" && r !== null) {
          if (typeof r.then == "function") {
            y = r, r = P === M ? kn() : null, n = Oi(n, e, r).ping, y.then(n, n), e.formatContext = c, e.context = h, e.keyPath = d, e.treeContext = b, e.componentStack = g, u(h);
            return;
          }
          if (r.message === "Maximum call stack size exceeded") {
            y = P === M ? kn() : null, y = Oi(n, e, y), n.pingedTasks.push(y), e.formatContext = c, e.context = h, e.keyPath = d, e.treeContext = b, e.componentStack = g, u(h);
            return;
          }
        }
      }
    }
    throw e.formatContext = c, e.context = h, e.keyPath = d, e.treeContext = b, u(h), r;
  }
  function Ir(n) {
    var e = n.blockedBoundary, r = n.blockedSegment;
    r !== null && (r.status = 3, $n(this, e, n.row, r));
  }
  function Je(n, e, r, a, c, h) {
    for (var d = 0; d < r.length; d++) {
      var b = r[d];
      if (b.length === 4)
        Je(
          n,
          e,
          b[2],
          b[3],
          c,
          h
        );
      else {
        b = b[5];
        var g = n, y = h, T = Ge(
          g,
          null,
          /* @__PURE__ */ new Set(),
          null,
          null
        );
        T.parentFlushed = !0, T.rootSegmentID = b, T.status = 4, T.errorDigest = y, T.parentFlushed && g.clientRenderedBoundaries.push(T);
      }
    }
    if (r.length = 0, a !== null) {
      if (e === null) throw Error(R(487));
      if (e.status !== 4 && (e.status = 4, e.errorDigest = h, e.parentFlushed && n.clientRenderedBoundaries.push(e)), typeof a == "object") for (var w in a) delete a[w];
    }
  }
  function Qe(n, e, r) {
    var a = n.blockedBoundary, c = n.blockedSegment;
    if (c !== null) {
      if (c.status === 6) return;
      c.status = 3;
    }
    var h = al(n.componentStack);
    if (a === null) {
      if (e.status !== 13 && e.status !== 14) {
        if (a = n.replay, a === null) {
          e.trackedPostpones !== null && c !== null ? (a = e.trackedPostpones, An(e, r, h), Pr(e, a, n, c), $n(e, null, n.row, c)) : (An(e, r, h), Ye(e, r));
          return;
        }
        a.pendingTasks--, a.pendingTasks === 0 && 0 < a.nodes.length && (c = An(e, r, h), Je(
          e,
          null,
          a.nodes,
          a.slots,
          r,
          c
        )), e.pendingRootTasks--, e.pendingRootTasks === 0 && _r(e);
      }
    } else {
      var d = e.trackedPostpones;
      if (a.status !== 4) {
        if (d !== null && c !== null)
          return An(e, r, h), Pr(e, d, n, c), a.fallbackAbortableTasks.forEach(function(b) {
            return Qe(b, e, r);
          }), a.fallbackAbortableTasks.clear(), $n(e, a, n.row, c);
        a.status = 4, c = An(e, r, h), a.status = 4, a.errorDigest = c, ki(e, a), a.parentFlushed && e.clientRenderedBoundaries.push(a);
      }
      a.pendingTasks--, c = a.row, c !== null && --c.pendingTasks === 0 && On(e, c), a.fallbackAbortableTasks.forEach(function(b) {
        return Qe(b, e, r);
      }), a.fallbackAbortableTasks.clear();
    }
    n = n.row, n !== null && --n.pendingTasks === 0 && On(e, n), e.allPendingTasks--, e.allPendingTasks === 0 && Mt(e);
  }
  function Pt(n, e) {
    try {
      var r = n.renderState, a = r.onHeaders;
      if (a) {
        var c = r.headers;
        if (c) {
          r.headers = null;
          var h = c.preconnects;
          if (c.fontPreloads && (h && (h += ", "), h += c.fontPreloads), c.highImagePreloads && (h && (h += ", "), h += c.highImagePreloads), !e) {
            var d = r.styles.values(), b = d.next();
            n: for (; 0 < c.remainingCapacity && !b.done; b = d.next())
              for (var g = b.value.sheets.values(), y = g.next(); 0 < c.remainingCapacity && !y.done; y = g.next()) {
                var T = y.value, w = T.props, P = w.href, _ = T.props, X = Tt(_.href, "style", {
                  crossOrigin: _.crossOrigin,
                  integrity: _.integrity,
                  nonce: _.nonce,
                  type: _.type,
                  fetchPriority: _.fetchPriority,
                  referrerPolicy: _.referrerPolicy,
                  media: _.media
                });
                if (0 <= (c.remainingCapacity -= X.length + 2))
                  r.resets.style[P] = Qn, h && (h += ", "), h += X, r.resets.style[P] = typeof w.crossOrigin == "string" || typeof w.integrity == "string" ? [w.crossOrigin, w.integrity] : Qn;
                else break n;
              }
          }
          a(h ? { Link: h } : {});
        }
      }
    } catch (W) {
      An(n, W, {});
    }
  }
  function _r(n) {
    n.trackedPostpones === null && Pt(n, !0), n.trackedPostpones === null && Sl(n), n.onShellError = S, n = n.onShellReady, n();
  }
  function Mt(n) {
    Pt(
      n,
      n.trackedPostpones === null ? !0 : n.completedRootSegment === null || n.completedRootSegment.status !== 5
    ), Sl(n), n = n.onAllReady, n();
  }
  function It(n, e) {
    if (e.chunks.length === 0 && e.children.length === 1 && e.children[0].boundary === null && e.children[0].id === -1) {
      var r = e.children[0];
      r.id = e.id, r.parentFlushed = !0, r.status !== 1 && r.status !== 3 && r.status !== 4 || It(n, r);
    } else n.completedSegments.push(e);
  }
  function Fl(n, e, r) {
    if (Ae !== null) {
      r = r.chunks;
      for (var a = 0, c = 0; c < r.length; c++)
        a += r[c].byteLength;
      e === null ? n.byteSize += a : e.byteSize += a;
    }
  }
  function $n(n, e, r, a) {
    if (r !== null && (--r.pendingTasks === 0 ? On(n, r) : r.together && St(n, r)), n.allPendingTasks--, e === null) {
      if (a !== null && a.parentFlushed) {
        if (n.completedRootSegment !== null)
          throw Error(R(389));
        n.completedRootSegment = a;
      }
      n.pendingRootTasks--, n.pendingRootTasks === 0 && _r(n);
    } else if (e.pendingTasks--, e.status !== 4)
      if (e.pendingTasks === 0) {
        if (e.status === 0 && (e.status = 1), a !== null && a.parentFlushed && (a.status === 1 || a.status === 3) && It(e, a), e.parentFlushed && n.completedBoundaries.push(e), e.status === 1)
          r = e.row, r !== null && ge(r.hoistables, e.contentState), rl(n, e) || (e.fallbackAbortableTasks.forEach(Ir, n), e.fallbackAbortableTasks.clear(), r !== null && --r.pendingTasks === 0 && On(n, r)), n.pendingRootTasks === 0 && n.trackedPostpones === null && e.contentPreamble !== null && Sl(n);
        else if (e.status === 5 && (e = e.row, e !== null)) {
          if (n.trackedPostpones !== null) {
            r = n.trackedPostpones;
            var c = e.next;
            if (c !== null && (a = c.boundaries, a !== null))
              for (c.boundaries = null, c = 0; c < a.length; c++) {
                var h = a[c];
                Ar(n, r, h), $n(n, h, null, null);
              }
          }
          --e.pendingTasks === 0 && On(n, e);
        }
      } else
        a === null || !a.parentFlushed || a.status !== 1 && a.status !== 3 || (It(e, a), e.completedSegments.length === 1 && e.parentFlushed && n.partialBoundaries.push(e)), e = e.row, e !== null && e.together && St(n, e);
    n.allPendingTasks === 0 && Mt(n);
  }
  function Li(n) {
    if (n.status !== 14 && n.status !== 13) {
      var e = vl, r = Ll.H;
      Ll.H = Pi;
      var a = Ll.A;
      Ll.A = Da;
      var c = yn;
      yn = n;
      var h = Rt;
      Rt = n.resumableState;
      try {
        var d = n.pingedTasks, b;
        for (b = 0; b < d.length; b++) {
          var g = d[b], y = n, T = g.blockedSegment;
          if (T === null) {
            var w = y;
            if (g.replay.pendingTasks !== 0) {
              u(g.context);
              try {
                if (typeof g.replay.slots == "number" ? Kl(
                  w,
                  g,
                  g.replay.slots,
                  g.node,
                  g.childIndex
                ) : Xe(w, g), g.replay.pendingTasks === 1 && 0 < g.replay.nodes.length)
                  throw Error(R(488));
                g.replay.pendingTasks--, g.abortSet.delete(g), $n(
                  w,
                  g.blockedBoundary,
                  g.row,
                  null
                );
              } catch (In) {
                tl();
                var P = In === M ? z() : In;
                if (typeof P == "object" && P !== null && typeof P.then == "function") {
                  var _ = g.ping;
                  P.then(_, _), g.thenableState = In === M ? kn() : null;
                } else {
                  g.replay.pendingTasks--, g.abortSet.delete(g);
                  var X = al(g.componentStack);
                  y = void 0;
                  var W = w, U = g.blockedBoundary, en = w.status === 12 ? w.fatalError : P, p = g.replay.nodes, Mn = g.replay.slots;
                  y = An(
                    W,
                    en,
                    X
                  ), Je(
                    W,
                    U,
                    p,
                    Mn,
                    en,
                    y
                  ), w.pendingRootTasks--, w.pendingRootTasks === 0 && _r(w), w.allPendingTasks--, w.allPendingTasks === 0 && Mt(w);
                }
              } finally {
              }
            }
          } else if (w = void 0, W = T, W.status === 0) {
            W.status = 6, u(g.context);
            var Yn = W.children.length, cl = W.chunks.length;
            try {
              Xe(y, g), W.lastPushedText && W.textEmbedded && W.chunks.push(ol), g.abortSet.delete(g), W.status = 1, Fl(y, g.blockedBoundary, W), $n(
                y,
                g.blockedBoundary,
                g.row,
                W
              );
            } catch (In) {
              tl(), W.children.length = Yn, W.chunks.length = cl;
              var L = In === M ? z() : y.status === 12 ? y.fatalError : In;
              if (y.status === 12 && y.trackedPostpones !== null) {
                var Ln = y.trackedPostpones, hn = al(g.componentStack);
                g.abortSet.delete(g), An(y, L, hn), Pr(y, Ln, g, W), $n(
                  y,
                  g.blockedBoundary,
                  g.row,
                  W
                );
              } else if (typeof L == "object" && L !== null && typeof L.then == "function") {
                W.status = 0, g.thenableState = In === M ? kn() : null;
                var Dn = g.ping;
                L.then(Dn, Dn);
              } else {
                var _l = al(g.componentStack);
                g.abortSet.delete(g), W.status = 4;
                var on = g.blockedBoundary, pl = g.row;
                if (pl !== null && --pl.pendingTasks === 0 && On(y, pl), y.allPendingTasks--, w = An(
                  y,
                  L,
                  _l
                ), on === null) Ye(y, L);
                else if (on.pendingTasks--, on.status !== 4) {
                  on.status = 4, on.errorDigest = w, ki(y, on);
                  var yl = on.row;
                  yl !== null && --yl.pendingTasks === 0 && On(y, yl), on.parentFlushed && y.clientRenderedBoundaries.push(on), y.pendingRootTasks === 0 && y.trackedPostpones === null && on.contentPreamble !== null && Sl(y);
                }
                y.allPendingTasks === 0 && Mt(y);
              }
            } finally {
            }
          }
        }
        d.splice(0, b), n.destination !== null && _t(n, n.destination);
      } catch (In) {
        An(n, In, {}), Ye(n, In);
      } finally {
        Rt = h, Ll.H = r, Ll.A = a, r === Pi && u(e), yn = c;
      }
    }
  }
  function ml(n, e, r) {
    e.preambleChildren.length && r.push(e.preambleChildren);
    for (var a = !1, c = 0; c < e.children.length; c++)
      a = Bi(
        n,
        e.children[c],
        r
      ) || a;
    return a;
  }
  function Bi(n, e, r) {
    var a = e.boundary;
    if (a === null)
      return ml(
        n,
        e,
        r
      );
    var c = a.contentPreamble, h = a.fallbackPreamble;
    if (c === null || h === null) return !1;
    switch (a.status) {
      case 1:
        if (ui(n.renderState, c), n.byteSize += a.byteSize, e = a.completedSegments[0], !e) throw Error(R(391));
        return ml(
          n,
          e,
          r
        );
      case 5:
        if (n.trackedPostpones !== null) return !0;
      case 4:
        if (e.status === 1)
          return ui(n.renderState, h), ml(
            n,
            e,
            r
          );
      default:
        return !0;
    }
  }
  function Sl(n) {
    if (n.completedRootSegment && n.completedPreambleSegments === null) {
      var e = [], r = n.byteSize, a = Bi(
        n,
        n.completedRootSegment,
        e
      ), c = n.renderState.preamble;
      a === !1 || c.headChunks && c.bodyChunks ? n.completedPreambleSegments = e : n.byteSize = r;
    }
  }
  function Re(n, e, r, a) {
    switch (r.parentFlushed = !0, r.status) {
      case 0:
        r.id = n.nextSegmentId++;
      case 5:
        return a = r.id, r.lastPushedText = !1, r.textEmbedded = !1, n = n.renderState, F(e, xa), F(e, n.placeholderPrefix), n = I(a.toString(16)), F(e, n), k(e, fu);
      case 1:
        r.status = 2;
        var c = !0, h = r.chunks, d = 0;
        r = r.children;
        for (var b = 0; b < r.length; b++) {
          for (c = r[b]; d < c.index; d++)
            F(e, h[d]);
          c = Ve(n, e, c, a);
        }
        for (; d < h.length - 1; d++)
          F(e, h[d]);
        return d < h.length && (c = k(e, h[d])), c;
      case 3:
        return !0;
      default:
        throw Error(R(390));
    }
  }
  var Al = 0;
  function Ve(n, e, r, a) {
    var c = r.boundary;
    if (c === null)
      return Re(n, e, r, a);
    if (c.parentFlushed = !0, c.status === 4) {
      var h = c.row;
      h !== null && --h.pendingTasks === 0 && On(n, h), c = c.errorDigest, k(e, Nn), F(e, su), c && (F(e, ir), F(e, I(N(c))), F(
        e,
        rr
      )), k(e, gu), Re(n, e, r, a);
    } else if (c.status !== 1)
      c.status === 0 && (c.rootSegmentID = n.nextSegmentId++), 0 < c.completedSegments.length && n.partialBoundaries.push(c), wa(
        e,
        n.renderState,
        c.rootSegmentID
      ), a && ge(a, c.fallbackState), Re(n, e, r, a);
    else if (!Ml && rl(n, c) && (Al + c.byteSize > n.progressiveChunkSize || Et(c.contentState)))
      c.rootSegmentID = n.nextSegmentId++, n.completedBoundaries.push(c), wa(
        e,
        n.renderState,
        c.rootSegmentID
      ), Re(n, e, r, a);
    else {
      if (Al += c.byteSize, a && ge(a, c.contentState), r = c.row, r !== null && rl(n, c) && --r.pendingTasks === 0 && On(n, r), k(e, hu), r = c.completedSegments, r.length !== 1) throw Error(R(391));
      Ve(n, e, r[0], a);
    }
    return k(e, qn);
  }
  function Pl(n, e, r, a) {
    return Fa(
      e,
      n.renderState,
      r.parentFormatContext,
      r.id
    ), Ve(n, e, r, a), Sa(e, r.parentFormatContext);
  }
  function Ni(n, e, r) {
    Al = r.byteSize;
    for (var a = r.completedSegments, c = 0; c < a.length; c++)
      zi(
        n,
        e,
        r,
        a[c]
      );
    a.length = 0, a = r.row, a !== null && rl(n, r) && --a.pendingTasks === 0 && On(n, a), ze(
      e,
      r.contentState,
      n.renderState
    ), a = n.resumableState, n = n.renderState, c = r.rootSegmentID, r = r.contentState;
    var h = n.stylesToHoist;
    return n.stylesToHoist = !1, F(e, n.startInlineScript), F(e, ln), h ? ((a.instructions & 4) === 0 && (a.instructions |= 4, F(e, Le)), (a.instructions & 2) === 0 && (a.instructions |= 2, F(e, si)), (a.instructions & 8) === 0 ? (a.instructions |= 8, F(e, Eu)) : F(e, Pa)) : ((a.instructions & 2) === 0 && (a.instructions |= 2, F(e, si)), F(e, Aa)), a = I(c.toString(16)), F(e, n.boundaryPrefix), F(e, a), F(e, hr), F(e, n.segmentPrefix), F(e, a), h ? (F(e, xu), Tn(e, r)) : F(e, gi), r = k(e, Ma), ci(e, n) && r;
  }
  function zi(n, e, r, a) {
    if (a.status === 2) return !0;
    var c = r.contentState, h = a.id;
    if (h === -1) {
      if ((a.id = r.rootSegmentID) === -1)
        throw Error(R(392));
      return Pl(n, e, a, c);
    }
    return h === r.rootSegmentID ? Pl(n, e, a, c) : (Pl(n, e, a, c), r = n.resumableState, n = n.renderState, F(e, n.startInlineScript), F(e, ln), (r.instructions & 1) === 0 ? (r.instructions |= 1, F(e, vu)) : F(e, bu), F(e, n.segmentPrefix), h = I(h.toString(16)), F(e, h), F(e, yu), F(e, n.placeholderPrefix), F(e, h), e = k(e, Tu), e);
  }
  var Ml = !1;
  function _t(n, e) {
    Zn = new Uint8Array(2048), Jn = 0;
    try {
      if (!(0 < n.pendingRootTasks)) {
        var r, a = n.completedRootSegment;
        if (a !== null) {
          if (a.status === 5) return;
          var c = n.completedPreambleSegments;
          if (c === null) return;
          Al = n.byteSize;
          var h = n.resumableState, d = n.renderState, b = d.preamble, g = b.htmlChunks, y = b.headChunks, T;
          if (g) {
            for (T = 0; T < g.length; T++)
              F(e, g[T]);
            if (y)
              for (T = 0; T < y.length; T++)
                F(e, y[T]);
            else
              F(e, sn("head")), F(e, ln);
          } else if (y)
            for (T = 0; T < y.length; T++)
              F(e, y[T]);
          var w = d.charsetChunks;
          for (T = 0; T < w.length; T++)
            F(e, w[T]);
          w.length = 0, d.preconnects.forEach($, e), d.preconnects.clear();
          var P = d.viewportChunks;
          for (T = 0; T < P.length; T++)
            F(e, P[T]);
          P.length = 0, d.fontPreloads.forEach($, e), d.fontPreloads.clear(), d.highImagePreloads.forEach($, e), d.highImagePreloads.clear(), ie = d, d.styles.forEach(gr, e), ie = null;
          var _ = d.importMapChunks;
          for (T = 0; T < _.length; T++)
            F(e, _[T]);
          _.length = 0, d.bootstrapScripts.forEach($, e), d.scripts.forEach($, e), d.scripts.clear(), d.bulkPreloads.forEach($, e), d.bulkPreloads.clear(), g || y || (h.instructions |= 32);
          var X = d.hoistableChunks;
          for (T = 0; T < X.length; T++)
            F(e, X[T]);
          for (h = X.length = 0; h < c.length; h++) {
            var W = c[h];
            for (d = 0; d < W.length; d++)
              Ve(n, e, W[d], null);
          }
          var U = n.renderState.preamble, en = U.headChunks;
          (U.htmlChunks || en) && F(e, Dl("head"));
          var p = U.bodyChunks;
          if (p)
            for (c = 0; c < p.length; c++)
              F(e, p[c]);
          Ve(n, e, a, null), n.completedRootSegment = null;
          var Mn = n.renderState;
          if (n.allPendingTasks !== 0 || n.clientRenderedBoundaries.length !== 0 || n.completedBoundaries.length !== 0 || n.trackedPostpones !== null && (n.trackedPostpones.rootNodes.length !== 0 || n.trackedPostpones.rootSlots !== null)) {
            var Yn = n.resumableState;
            if ((Yn.instructions & 64) === 0) {
              if (Yn.instructions |= 64, F(e, Mn.startInlineScript), (Yn.instructions & 32) === 0) {
                Yn.instructions |= 32;
                var cl = "_" + Yn.idPrefix + "R_";
                F(e, vr), F(
                  e,
                  I(N(cl))
                ), F(e, un);
              }
              F(e, ln), F(e, Hl), k(e, V);
            }
          }
          ci(e, Mn);
        }
        var L = n.renderState;
        a = 0;
        var Ln = L.viewportChunks;
        for (a = 0; a < Ln.length; a++)
          F(e, Ln[a]);
        Ln.length = 0, L.preconnects.forEach($, e), L.preconnects.clear(), L.fontPreloads.forEach($, e), L.fontPreloads.clear(), L.highImagePreloads.forEach(
          $,
          e
        ), L.highImagePreloads.clear(), L.styles.forEach(Ei, e), L.scripts.forEach($, e), L.scripts.clear(), L.bulkPreloads.forEach($, e), L.bulkPreloads.clear();
        var hn = L.hoistableChunks;
        for (a = 0; a < hn.length; a++)
          F(e, hn[a]);
        hn.length = 0;
        var Dn = n.clientRenderedBoundaries;
        for (r = 0; r < Dn.length; r++) {
          var _l = Dn[r];
          L = e;
          var on = n.resumableState, pl = n.renderState, yl = _l.rootSegmentID, In = _l.errorDigest;
          F(
            L,
            pl.startInlineScript
          ), F(L, ln), (on.instructions & 4) === 0 ? (on.instructions |= 4, F(L, vi)) : F(L, or), F(L, pl.boundaryPrefix), F(L, I(yl.toString(16))), F(L, Ia), In && (F(
            L,
            Be
          ), F(
            L,
            I(
              Cu(In || "")
            )
          ));
          var fl = k(
            L,
            wu
          );
          if (!fl) {
            n.destination = null, r++, Dn.splice(0, r);
            return;
          }
        }
        Dn.splice(0, r);
        var kt = n.completedBoundaries;
        for (r = 0; r < kt.length; r++)
          if (!Ni(n, e, kt[r])) {
            n.destination = null, r++, kt.splice(0, r);
            return;
          }
        kt.splice(0, r), Qr(e), Zn = new Uint8Array(2048), Jn = 0, Ml = !0;
        var Ot = n.partialBoundaries;
        for (r = 0; r < Ot.length; r++) {
          var Fe = Ot[r];
          n: {
            Dn = n, _l = e, Al = Fe.byteSize;
            var Lt = Fe.completedSegments;
            for (fl = 0; fl < Lt.length; fl++)
              if (!zi(
                Dn,
                _l,
                Fe,
                Lt[fl]
              )) {
                fl++, Lt.splice(0, fl);
                var Hi = !1;
                break n;
              }
            Lt.splice(0, fl);
            var jl = Fe.row;
            jl !== null && jl.together && Fe.pendingTasks === 1 && (jl.pendingTasks === 1 ? _i(
              Dn,
              jl,
              jl.hoistables
            ) : jl.pendingTasks--), Hi = ze(
              _l,
              Fe.contentState,
              Dn.renderState
            );
          }
          if (!Hi) {
            n.destination = null, r++, Ot.splice(0, r);
            return;
          }
        }
        Ot.splice(0, r), Ml = !1;
        var me = n.completedBoundaries;
        for (r = 0; r < me.length; r++)
          if (!Ni(n, e, me[r])) {
            n.destination = null, r++, me.splice(0, r);
            return;
          }
        me.splice(0, r);
      }
    } finally {
      Ml = !1, n.allPendingTasks === 0 && n.clientRenderedBoundaries.length === 0 && n.completedBoundaries.length === 0 ? (n.flushScheduled = !1, r = n.resumableState, r.hasBody && F(e, Dl("body")), r.hasHtml && F(e, Dl("html")), Qr(e), n.status = 14, e.close(), n.destination = null) : Qr(e);
    }
  }
  function Ce(n) {
    n.flushScheduled = n.destination !== null, Xt(function() {
      return Li(n);
    }), Jr(function() {
      n.status === 10 && (n.status = 11), n.trackedPostpones === null && Pt(n, n.pendingRootTasks === 0);
    });
  }
  function Il(n) {
    n.flushScheduled === !1 && n.pingedTasks.length === 0 && n.destination !== null && (n.flushScheduled = !0, Jr(function() {
      var e = n.destination;
      e ? _t(n, e) : n.flushScheduled = !1;
    }));
  }
  function ql(n, e) {
    if (n.status === 13)
      n.status = 14, Vr(e, n.fatalError);
    else if (n.status !== 14 && n.destination === null) {
      n.destination = e;
      try {
        _t(n, e);
      } catch (r) {
        An(n, r, {}), Ye(n, r);
      }
    }
  }
  function ul(n, e) {
    (n.status === 11 || n.status === 10) && (n.status = 12);
    try {
      var r = n.abortableTasks;
      if (0 < r.size) {
        var a = e === void 0 ? Error(R(432)) : typeof e == "object" && e !== null && typeof e.then == "function" ? Error(R(530)) : e;
        n.fatalError = a, r.forEach(function(c) {
          return Qe(c, n, a);
        }), r.clear();
      }
      n.destination !== null && _t(n, n.destination);
    } catch (c) {
      An(n, c, {}), Ye(n, c);
    }
  }
  function kr(n, e, r) {
    if (e === null) r.rootNodes.push(n);
    else {
      var a = r.workingMap, c = a.get(e);
      c === void 0 && (c = [e[1], e[2], [], null], a.set(e, c), kr(c, e[0], r)), c[2].push(n);
    }
  }
  function Di(n) {
    var e = n.trackedPostpones;
    if (e === null || e.rootNodes.length === 0 && e.rootSlots === null)
      return n.trackedPostpones = null;
    if (n.completedRootSegment === null || n.completedRootSegment.status !== 5 && n.completedPreambleSegments !== null) {
      var r = n.nextSegmentId, a = e.rootSlots, c = n.resumableState;
      c.bootstrapScriptContent = void 0, c.bootstrapScripts = void 0, c.bootstrapModules = void 0;
    } else {
      r = 0, a = -1, c = n.resumableState;
      var h = n.renderState;
      c.nextFormID = 0, c.hasBody = !1, c.hasHtml = !1, c.unknownResources = { font: h.resets.font }, c.dnsResources = h.resets.dns, c.connectResources = h.resets.connect, c.imageResources = h.resets.image, c.styleResources = h.resets.style, c.scriptResources = {}, c.moduleUnknownResources = {}, c.moduleScriptResources = {}, c.instructions = 0;
    }
    return {
      nextSegmentId: r,
      rootFormatContext: n.rootFormatContext,
      progressiveChunkSize: n.progressiveChunkSize,
      resumableState: n.resumableState,
      replayNodes: e.rootNodes,
      replaySlots: a
    };
  }
  function Ke() {
    var n = Wn.version;
    if (n !== "19.2.0")
      throw Error(
        R(
          527,
          n,
          "19.2.0"
        )
      );
  }
  return Ke(), Ke(), Gt.prerender = function(n, e) {
    return new Promise(function(r, a) {
      var c = e ? e.onHeaders : void 0, h;
      c && (h = function(T) {
        c(new Headers(T));
      });
      var d = ni(
        e ? e.identifierPrefix : void 0,
        e ? e.unstable_externalRuntimeSrc : void 0,
        e ? e.bootstrapScriptContent : void 0,
        e ? e.bootstrapScripts : void 0,
        e ? e.bootstrapModules : void 0
      ), b = Ft(
        n,
        d,
        Kt(
          d,
          void 0,
          e ? e.unstable_externalRuntimeSrc : void 0,
          e ? e.importMap : void 0,
          h,
          e ? e.maxHeadersLength : void 0
        ),
        li(e ? e.namespaceURI : void 0),
        e ? e.progressiveChunkSize : void 0,
        e ? e.onError : void 0,
        function() {
          var T = new ReadableStream(
            {
              type: "bytes",
              pull: function(w) {
                ql(b, w);
              },
              cancel: function(w) {
                b.destination = null, ul(b, w);
              }
            },
            { highWaterMark: 0 }
          );
          T = { postponed: Di(b), prelude: T }, r(T);
        },
        void 0,
        void 0,
        a,
        e ? e.onPostpone : void 0
      );
      if (e && e.signal) {
        var g = e.signal;
        if (g.aborted) ul(b, g.reason);
        else {
          var y = function() {
            ul(b, g.reason), g.removeEventListener("abort", y);
          };
          g.addEventListener("abort", y);
        }
      }
      Ce(b);
    });
  }, Gt.renderToReadableStream = function(n, e) {
    return new Promise(function(r, a) {
      var c, h, d = new Promise(function(_, X) {
        h = _, c = X;
      }), b = e ? e.onHeaders : void 0, g;
      b && (g = function(_) {
        b(new Headers(_));
      });
      var y = ni(
        e ? e.identifierPrefix : void 0,
        e ? e.unstable_externalRuntimeSrc : void 0,
        e ? e.bootstrapScriptContent : void 0,
        e ? e.bootstrapScripts : void 0,
        e ? e.bootstrapModules : void 0
      ), T = Ue(
        n,
        y,
        Kt(
          y,
          e ? e.nonce : void 0,
          e ? e.unstable_externalRuntimeSrc : void 0,
          e ? e.importMap : void 0,
          g,
          e ? e.maxHeadersLength : void 0
        ),
        li(e ? e.namespaceURI : void 0),
        e ? e.progressiveChunkSize : void 0,
        e ? e.onError : void 0,
        h,
        function() {
          var _ = new ReadableStream(
            {
              type: "bytes",
              pull: function(X) {
                ql(T, X);
              },
              cancel: function(X) {
                T.destination = null, ul(T, X);
              }
            },
            { highWaterMark: 0 }
          );
          _.allReady = d, r(_);
        },
        function(_) {
          d.catch(function() {
          }), a(_);
        },
        c,
        e ? e.onPostpone : void 0,
        e ? e.formState : void 0
      );
      if (e && e.signal) {
        var w = e.signal;
        if (w.aborted) ul(T, w.reason);
        else {
          var P = function() {
            ul(T, w.reason), w.removeEventListener("abort", P);
          };
          w.addEventListener("abort", P);
        }
      }
      Ce(T);
    });
  }, Gt.resume = function(n, e, r) {
    return new Promise(function(a, c) {
      var h, d, b = new Promise(function(w, P) {
        d = w, h = P;
      }), g = Rl(
        n,
        e,
        Kt(
          e.resumableState,
          r ? r.nonce : void 0,
          void 0,
          void 0,
          void 0,
          void 0
        ),
        r ? r.onError : void 0,
        d,
        function() {
          var w = new ReadableStream(
            {
              type: "bytes",
              pull: function(P) {
                ql(g, P);
              },
              cancel: function(P) {
                g.destination = null, ul(g, P);
              }
            },
            { highWaterMark: 0 }
          );
          w.allReady = b, a(w);
        },
        function(w) {
          b.catch(function() {
          }), c(w);
        },
        h,
        r ? r.onPostpone : void 0
      );
      if (r && r.signal) {
        var y = r.signal;
        if (y.aborted) ul(g, y.reason);
        else {
          var T = function() {
            ul(g, y.reason), y.removeEventListener("abort", T);
          };
          y.addEventListener("abort", T);
        }
      }
      Ce(g);
    });
  }, Gt.resumeAndPrerender = function(n, e, r) {
    return new Promise(function(a, c) {
      var h = Ii(
        n,
        e,
        Kt(
          e.resumableState,
          void 0,
          void 0,
          void 0,
          void 0,
          void 0
        ),
        r ? r.onError : void 0,
        function() {
          var g = new ReadableStream(
            {
              type: "bytes",
              pull: function(y) {
                ql(h, y);
              },
              cancel: function(y) {
                h.destination = null, ul(h, y);
              }
            },
            { highWaterMark: 0 }
          );
          g = { postponed: Di(h), prelude: g }, a(g);
        },
        void 0,
        void 0,
        c,
        r ? r.onPostpone : void 0
      );
      if (r && r.signal) {
        var d = r.signal;
        if (d.aborted) ul(h, d.reason);
        else {
          var b = function() {
            ul(h, d.reason), d.removeEventListener("abort", b);
          };
          d.addEventListener("abort", b);
        }
      }
      Ce(h);
    });
  }, Gt.version = "19.2.0", Gt;
}
var Cc;
function Xc() {
  if (Cc) return Ut;
  Cc = 1;
  var Wn, Tl;
  return Wn = Gc(), Tl = Yc(), Ut.version = Wn.version, Ut.renderToString = Wn.renderToString, Ut.renderToStaticMarkup = Wn.renderToStaticMarkup, Ut.renderToReadableStream = Tl.renderToReadableStream, Ut.resume = Tl.resume, Ut;
}
var Zc = Xc();
window.addEventListener("gorgias-widget-loaded", () => {
  const Wn = document.getElementById("gorgias-chat-container");
  if (!Wn || !window.GorgiasChat) return;
  const Tl = /* @__PURE__ */ Gu.jsx("button", {
    id: "close-btn",
    className: "georgias-chat-widget-close fixed bottom-[min(75vh,720px)] right-11 size-10 flex items-center justify-center opacity-0 md:aria-[hidden=true]:opacity-100 data-[focus-on-hidden=true]:!pointer-events-auto cursor-pointer z-[2147483648] transition-opacity duration-200 aria-[hidden=true]:delay-250",
    children: /* @__PURE__ */ Gu.jsx(Wc, {
      size: 24
    })
  }), R = document.createElement("button");
  Wn.appendChild(R), Wn.addEventListener("click", ($l) => {
    $l.target.closest("button")?.id === "close-btn" && window.GorgiasChat.close();
  }), R.outerHTML = Zc.renderToStaticMarkup(Tl);
});
